(function (api) {
  if (!api) return;
  const root = document.querySelector('[data-daluca-filter-engine]');
  if (!root) return;
  api.localizeMarkup(root);
  root.querySelectorAll('[aria-label], [placeholder], option').forEach(function (node) {
    ['aria-label', 'placeholder'].forEach(function (name) {
      if (node.hasAttribute(name)) node.setAttribute(name, api.displayText(node.getAttribute(name)));
    });
    if (node.tagName === 'OPTION') node.textContent = api.displayText(node.textContent);
  });
})(window.DaLucaI18n);

(function () {
  if (window.DaLucaAdvancedFilterInitialized) return;
  window.DaLucaAdvancedFilterInitialized = true;

  const STYLE_PARAM = 'filter.p.m.daluca_filter.styles';
  const WIDTH_PARAM = 'filter.p.m.daluca_filter.widths';
  const LEGACY_WIDTH_PARAM = 'filter.p.m.filter.width';



  const SAVED_WATCH_KEY = 'daluca_selected_watch_v1';
  const CUSTOM_COLLECTION_PATH = window.DaLucaI18n.url('/collections/custom-watch-straps');
  const MANUAL_CUSTOM_WIDTH_PARAM = 'daluca_custom_width';
  const MANUAL_CUSTOM_WIDTHS = new Set(
    Array.from(
      { length: 15 },
      function (_, index) {
        return String(14 + index);
      }
    )
  );

  const CUSTOM_PROGRAM_WIDTHS = new Set(
    Array.from(
      { length: 15 },
      function (_, index) {
        return String(14 + index);
      }
    )
  );

  /*
    GLOBAL FIT RULE

    DaLuca's standard ready-made widths are:
    18, 20, 22, 24, 26mm.

    Odd/intermediate widths normally route to Custom,
    except on Custom collections that can accept them.
  */
  const READY_MADE_WIDTHS = new Set([
    '18',
    '20',
    '22',
    '24',
    '26'
  ]);

  let watchDatabase = null;
  let watchDatabasePromise = null;
  let renderedWatchGroups = [];
  let cachedCollectionContext = null;
  let activeManualCustomWidth = null;
  let pendingManualCustomWidth = null;
  let selectedCustomProgramWidth = null;


  /* =========================================================
     BASIC HELPERS
  ========================================================= */

  function getRoot() {
    return document.querySelector(
      '[data-daluca-filter-engine]'
    );
  }


  function getFacetForm() {
    return document.getElementById(
      'FacetFiltersForm'
    );
  }


  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }


  function displayModel(record) {
    return String(
      record.display_model ||
      record.model ||
      ''
    ).trim();
  }


  function displayReference(record) {
    return String(
      record._display_reference ||
      record.display_reference ||
      record.canonical_reference ||
      record.reference ||
      ''
    ).trim();
  }


  /* =========================================================
     COLLECTION CONTEXT
     Automatically understands fixed-width collection pages.
  ========================================================= */

  function uniqueNumericMatches(values) {
    return Array.from(
      new Set(
        values
          .map(Number)
          .filter(
            (value) =>
              Number.isFinite(value) &&
              value >= 18 &&
              value <= 26
          )
      )
    );
  }


function detectCollectionLugWidth(
  title,
  description,
  handle
) {
  const titleText =
    String(title || '')
      .replace(/\s+/g, ' ')
      .trim();

  const handleText =
    String(handle || '')
      .toLowerCase()
      .trim();

  /*
    HIGH-CONFIDENCE RULES ONLY.

    Never determine a fixed collection width from
    normal collection-description prose.

    A model family can span multiple lug widths across
    references/generations, so ambiguous collections
    must keep Watch Search available.
  */


/*
  VERIFIED FIXED-FIT MODEL FAMILIES

  Keep this list intentionally small and explicit.
  These collection families are known to use one lug
  width across the references represented by the page.

  Do NOT use this as a general model-name guesser.
*/
if (
  /\brolex\s+datejust\s*36\b/i.test(titleText) ||
  /(?:^|-)rolex-datejust-36(?:-|$)/i.test(handleText) ||
  /(?:^|-)datejust-36(?:-|$)/i.test(handleText)
) {
  return 20;
}

if (
  /\brolex\s+datejust\s*41\b/i.test(titleText) ||
  /(?:^|-)rolex-datejust-41(?:-|$)/i.test(handleText) ||
  /(?:^|-)datejust-41(?:-|$)/i.test(handleText)
) {
  return 21;
}

if (
  /\brolex\s+datejust\s+ii\b/i.test(titleText) ||
  /(?:^|-)rolex-datejust-ii(?:-|$)/i.test(handleText) ||
  /(?:^|-)datejust-ii(?:-|$)/i.test(handleText)
) {
  return 21;
}


/*
  TRAILING WIDTH SAFETY RULE

  A trailing width such as "(24mm)" is only enough
  to lock a collection when the title/handle gives
  us another strong signal that this is truly an
  exact-width collection.

  Examples:

  YES:
  "44mm Panerai Luminor Watch Straps (24mm)"
  -> 44mm is the case size, 24mm is the lug width.

  YES:
  "Rolex Submariner 116610 Watch Straps (20mm)"
  -> exact watch reference is present.

  YES:
  "24mm Watch Straps (24mm)"
  -> explicitly a width collection.

  NO:
  "Rolex Daytona Watch Straps (20mm)"
  -> broad model family; different references can
     use different lug widths, so keep Watch Search.
*/
const trailingWidth =
  titleText.match(
    /\((18|19|20|21|22|23|24|25|26)\s*mm\)\s*$/i
  );

if (trailingWidth) {

  const detectedWidth =
    Number(
      trailingWidth[1]
    );

  const titleBeforeTrailingWidth =
    titleText
      .slice(
        0,
        trailingWidth.index
      )
      .trim();


  /*
    Separate watch case size before the trailing
    lug width.

    Example:
    44mm Panerai ... (24mm)
  */
  const hasSeparateCaseSize =
    /\b(?:2[8-9]|[3-5][0-9]|60)\s*mm\b/i
      .test(
        titleBeforeTrailingWidth
      );


  /*
    Exact watch reference in the title.

    Examples:
    116610
    126610LN
    PAM 111
    PAM111
    A17367
  */
  const hasExplicitReference =
    /\b(?:PAM[\s-]?\d{2,4}|[A-Z]{1,4}\d{3,8}[A-Z0-9.-]*|\d{5,8}[A-Z0-9.-]*)\b/i
      .test(
        titleBeforeTrailingWidth
      );


  /*
    Explicit width-first collection.

    Example:
    24mm Watch Straps (24mm)
  */
  const hasLeadingStrapWidth =
    new RegExp(
      '^\\s*' +
      detectedWidth +
      '\\s*mm\\b',
      'i'
    ).test(
      titleBeforeTrailingWidth
    );


  /*
    Width-specific collection handle.

    Example:
    24mm-watch-straps
  */
  const hasWidthSpecificHandle =
    new RegExp(
      '(^|-)' +
      detectedWidth +
      'mm(-|$)',
      'i'
    ).test(
      handleText
    );


  if (
    hasSeparateCaseSize ||
    hasExplicitReference ||
    hasLeadingStrapWidth ||
    hasWidthSpecificHandle
  ) {
    return detectedWidth;
  }


  /*
    The title ends in a width, but it is otherwise
    just a broad model-family collection.

    Do NOT allow later rules in this function to
    reinterpret that same title as fixed-width.
  */
  return null;
}


  /*
    Width-first collection titles:

    "24mm Watch Straps"
    "24mm Panerai Watch Straps"
    "20mm Rolex Watch Bands"

    A valid DaLuca lug width at the beginning of a
    strap/band collection title is treated as explicit.
  */
  const leadingWidth =
    titleText.match(
      /^(18|19|20|21|22|23|24|25|26)\s*mm\b/i
    );

  if (
    leadingWidth &&
    /\b(?:straps?|bands?)\b/i.test(
      titleText
    )
  ) {
    return Number(
      leadingWidth[1]
    );
  }


  /*
    Explicit width immediately tied to "watch straps"
    or "watch bands" anywhere in the title.

    Example:
    "Panerai 24mm Watch Straps"

    We intentionally DO NOT treat something like
    "Panerai Luminor 44mm Watch Straps" as a lug width
    because 44mm is outside DaLuca's 18–26mm lug range
    and is normally the case size.
  */
  const explicitWatchStrapWidth =
    titleText.match(
      /\b(18|19|20|21|22|23|24|25|26)\s*mm\s+(?:watch\s+)?(?:straps?|bands?)\b/i
    );

  if (explicitWatchStrapWidth) {
    return Number(
      explicitWatchStrapWidth[1]
    );
  }


  /*
    Explicit URL handles such as:

    /collections/24mm-watch-straps
    /collections/panerai-24mm-watch-straps
  */
  const handleWidth =
    handleText.match(
      /(?:^|-)(18|19|20|21|22|23|24|25|26)mm-(?:watch-)?(?:straps?|bands?)(?:-|$)/i
    );

  if (handleWidth) {
    return Number(
      handleWidth[1]
    );
  }


  /*
    Anything ambiguous stays unlocked.

    Rolex Daytona, Submariner, Speedmaster, Luminor,
    etc. may contain multiple references/generations
    with different lug widths.

    Watch Search will determine the exact fit instead
    of guessing.
  */
  return null;
}


  function getCollectionContext() {
    if (cachedCollectionContext) {
      return cachedCollectionContext;
    }

    const root = getRoot();

    let context = {
      handle: '',
      title: '',
      description: '',
      locked_width_mm: null,
      custom_width_collection: false
    };

    if (root) {
      const node =
        root.querySelector(
          '[data-daluca-collection-context]'
        );

      if (node) {
        try {
          const parsed =
            JSON.parse(
              window.DaLucaI18n.sourceText(node) || '{}'
            );

          context.handle =
            String(parsed.handle || '');

          context.title =
            String(parsed.title || '');

          context.description =
            String(parsed.description || '');
        } catch (error) {
          console.warn(
            'DaLuca collection context unavailable:',
            error
          );
        }
      }
    }

    if (!context.handle) {
      const parts =
        window.location.pathname
          .split('/')
          .filter(Boolean);

      if (parts[0] === 'collections') {
        context.handle =
          parts[1] || '';
      }
    }

    context.locked_width_mm =
      detectCollectionLugWidth(
        context.title,
        context.description,
        context.handle
      );

    const normalizedTitle =
      context.title.toLowerCase();

    const normalizedHandle =
      context.handle.toLowerCase();

    context.custom_width_collection =
      normalizedHandle === 'custom-watch-straps' ||
      normalizedHandle.includes('custom-watch-strap') ||
      (
        normalizedTitle.includes('custom') &&
        (
          normalizedTitle.includes('watch strap') ||
          normalizedTitle.includes('watch band')
        )
      );

    cachedCollectionContext = context;

    return cachedCollectionContext;
  }


  /*
    CUSTOM PROGRAM COLLECTION DETECTION

    Do not rely only on cached collection metadata. The filter can initialize
    before all DaLuca collection context markup is available, so also use the
    current collection URL as an authoritative fallback. This covers the main
    /collections/custom-watch-straps page plus DaLuca custom sub-collections.
  */
  function isCustomProgramCollection() {
    const path =
      String(window.location.pathname || '')
        .toLowerCase()
        .replace(/\/+$/, '');

    if (
      /^\/collections\/[^/]*custom[^/]*watch-straps?$/.test(path)
    ) {
      return true;
    }

    return !!getCollectionContext().custom_width_collection;
  }


  function collectionHasLockedWidth() {
    return !!Number(
      getCollectionContext()
        .locked_width_mm
    );
  }


  function collectionAllowsWidth(width) {
    const context =
      getCollectionContext();

    const numericWidth =
      Number(width);

    if (!Number.isFinite(numericWidth)) {
      return false;
    }

    if (
      isCustomProgramCollection()
    ) {
      return (
        window.DaLucaWatchData.canOrderWidth(numericWidth)
      );
    }

    return READY_MADE_WIDTHS.has(
      String(numericWidth)
    );
  }


  function watchBelongsToCurrentCollection(
    watch
  ) {
    if (!watch) return false;

    if (collectionHasLockedWidth()) {
      return false;
    }

    const handle =
      getCollectionContext()
        .handle;

    /*
      A watch that required made-to-order sizing is intentionally
      carried into the Custom collection so the shopper keeps the
      exact watch/reference context while browsing the Custom options.
    */
    if (
      handle === 'custom-watch-straps' &&
      watch.custom_route === true
    ) {
      return true;
    }

    if (watch.collection_handle) {
      return (
        String(
          watch.collection_handle
        ) ===
        String(handle)
      );
    }

    /*
      Legacy saved watches were created while the filter
      existed only on the Two Piece pilot collection.
    */
    return (
      handle ===
      'two-piece-watch-straps'
    );
  }


  function getRelevantSavedWatch() {
    const watch =
      getSavedWatch();

    return watchBelongsToCurrentCollection(
      watch
    )
      ? watch
      : null;
  }


  function renderCollectionContextUI() {
    const context =
      getCollectionContext();

    const width =
      Number(
        context.locked_width_mm
      );

    if (!width) {
      return false;
    }

    const root = getRoot();

    if (!root) return false;

    hideCustomFitNotice();

    const heading =
      root.querySelector(
        '.daluca-filter-fit__heading'
      );

    const search =
      root.querySelector(
        '.daluca-filter-fit__search'
      );

    const selected =
      root.querySelector(
        '[data-daluca-selected-watch]'
      );

    /*
      FIXED-WIDTH COLLECTION SAFETY
      A collection such as 18mm Watch Straps is already the fit constraint.
      Do not present a second lug-width chooser that can contradict it.
    */
    const widthSlot =
      root.querySelector(
        '[data-daluca-dynamic-filter-slot="width"]'
      );

    if (widthSlot) {
      widthSlot.hidden = true;
    }

    if (search) {
      search.hidden = true;
    }

    if (heading) {
      const eyebrow =
        heading.querySelector(
          '.daluca-filter-fit__eyebrow'
        );

      const title =
        heading.querySelector(
          '.daluca-filter-fit__title'
        );

      const copy =
        heading.querySelector(
          '.daluca-filter-fit__text'
        );

      setTextIfNeeded(
        eyebrow,
        'SHOP THIS EXACT WIDTH'
      );

      setTextIfNeeded(
        title,
        'Straps selected for this watch fit'
      );

      setTextIfNeeded(
        copy,
        `This collection is already matched to an exact ${width}mm lug width. Refine by style, material, availability or price.`
      );
    }

    if (selected) {
      selected.hidden = false;

      const label =
        selected.querySelector(
          '.daluca-filter-fit__selected-label'
        );

      const name =
        selected.querySelector(
          '[data-daluca-selected-watch-name]'
        );

      const widthNode =
        selected.querySelector(
          '[data-daluca-selected-watch-width]'
        );

      const changeButton =
        selected.querySelector(
          '[data-daluca-change-watch]'
        );

      setTextIfNeeded(
        label,
        'COLLECTION FIT'
      );

      setTextIfNeeded(
        name,
        context.title ||
          `${width}mm Watch Straps`
      );

      setTextIfNeeded(
        widthNode,
        `${width}mm lug width`
      );

      if (changeButton) {
        changeButton.hidden = true;
      }
    }

    return true;
  }


  /* =========================================================
     STYLE CONTROL
     KEEP SHOPIFY / HABITAT AUTHORITATIVE
  ========================================================= */

  function getStyleInputs() {
    const form = getFacetForm();

    if (!form) return [];

    return Array.from(
      form.querySelectorAll(
        `input[name="${STYLE_PARAM}"]`
      )
    );
  }


  function getStyleInput(style) {
    return getStyleInputs().find(
      (input) => input.value === style
    ) || null;
  }


  /*
    COLLECTION STYLE SHORTCUT POLICY

    Keep the collection-page style row visually restrained: four shortcuts
    (Everyday, Dress, Vintage, Collector) are the default. Sport is only
    surfaced on collections whose own title/handle is clearly sport-oriented.
    The Sport metafield/classification remains intact for Finder logic and
    filtering; this only controls the collection-page shortcut button.
  */
  function collectionShouldOfferSportShortcut() {
    /*
      Keep Sport available anywhere Shopify reports a usable Sport facet.
      Earlier collection-name gating could hide Sport even when compatible
      Sport products existed in the current assortment.
    */
    return true;
  }


  function isSportStyle(style) {
    return String(style || '')
      .trim()
      .toLowerCase() === 'sport';
  }


  function syncVisibleStyleCount() {
    document
      .querySelectorAll('.daluca-filter-styles__grid')
      .forEach((grid) => {
        const visibleCount = Array.from(
          grid.querySelectorAll('[data-daluca-style]')
        ).filter((button) => !button.hidden).length;

        grid.setAttribute(
          'data-daluca-visible-style-count',
          String(visibleCount)
        );
      });
  }


  function selectedWatchNeedsCustom() {
    if (
      window.DaLucaInPlaceCustomMode &&
      window.DaLucaInPlaceCustomMode.active()
    ) {
      return false;
    }

    const watch =
      getRelevantSavedWatch();

    if (!watch) return false;

    return !collectionAllowsWidth(
      watch.lug_width_mm
    );
  }


  function syncStyleButtons() {
    if (
      window.DaLucaInPlaceCustomMode &&
      window.DaLucaInPlaceCustomMode.active()
    ) {
      window.DaLucaInPlaceCustomMode.syncStyles();
      return;
    }

    document
      .querySelectorAll('[data-daluca-style]')
      .forEach((button) => {
        const style =
          button.dataset.dalucaStyle;

        const input =
          getStyleInput(style);

        const active =
          !!input && input.checked;

        /*
          Four collection-page style shortcuts are the normal presentation.
          Sport is a specialized shortcut and only earns a slot on explicitly
          sport-oriented collection pages. If Sport is already active through
          a URL/session state, keep it visible so the customer can see/clear it.
        */
        if (
          isSportStyle(style) &&
          !collectionShouldOfferSportShortcut() &&
          !active
        ) {
          button.hidden = true;
          button.disabled = true;
          button.classList.add('is-disabled');
          button.classList.remove('is-active');
          button.setAttribute('aria-pressed', 'false');
          button.setAttribute('aria-hidden', 'true');
          return;
        }

        /*
          If the selected watch requires an odd width
          that this ready-made collection does not carry,
          Style choices should not imply compatibility.
        */
        if (selectedWatchNeedsCustom()) {
          button.hidden = false;
          button.disabled = true;
          button.classList.add('is-disabled');
          button.classList.remove('is-active');
          button.setAttribute(
            'aria-pressed',
            'false'
          );
          button.setAttribute(
            'aria-hidden',
            'false'
          );

          return;
        }

        const unavailable =
          !input || input.disabled;

        button.disabled = unavailable;

        button.hidden =
          unavailable &&
          !active;

        button.classList.toggle(
          'is-disabled',
          unavailable
        );

        button.classList.toggle(
          'is-active',
          active
        );

        button.setAttribute(
          'aria-pressed',
          active ? 'true' : 'false'
        );

        button.setAttribute(
          'aria-hidden',
          button.hidden
            ? 'true'
            : 'false'
        );
      });

    syncVisibleStyleCount();
  }


  function applyStyle(style) {
    if (
      window.DaLucaInPlaceCustomMode &&
      window.DaLucaInPlaceCustomMode.active()
    ) {
      window.DaLucaInPlaceCustomMode.applyStyle(style);
      return;
    }

    const form = getFacetForm();

    if (!form) return;

    if (selectedWatchNeedsCustom()) {
      return;
    }

    const targetInput =
      getStyleInput(style);

    /*
      Never manufacture a Style value.

      If Shopify says a Style does not exist in this
      collection/filter state, it stays unavailable.
    */
    if (
      !targetInput ||
      targetInput.disabled
    ) {
      return;
    }

    const wasSelected =
      targetInput.checked;

    /*
      Single-select Style tabs.
    */
    getStyleInputs().forEach((input) => {
      input.checked = false;
    });

    if (!wasSelected) {
      targetInput.checked = true;
    }

    targetInput.dispatchEvent(
      new Event('input', {
        bubbles: true
      })
    );
  }


  /* =========================================================
     V20 DATABASE
  ========================================================= */

  function ensureWatchDatabase() {
    if (watchDatabase) {
      return Promise.resolve(
        watchDatabase
      );
    }

    if (watchDatabasePromise) {
      return watchDatabasePromise;
    }

    watchDatabasePromise = window.DaLucaWatchData.load()
        .then((json) => {
          if (!Array.isArray(json.records)) {
            throw new Error(
              'V20 records array missing'
            );
          }

          /*
            Only use records carrying the verified
            production status.
          */
          watchDatabase =
            json.records.filter((record) => {
              const verified =
                String(
                  record.verification_status ||
                  ''
                )
                  .toUpperCase()
                  .startsWith('VERIFIED');

              return (
                verified &&
                record.brand &&
                record.model &&
                record.reference &&
                Number(record.lug_width_mm)
              );
            });

          return watchDatabase;
        })
        .catch((error) => {
          console.error(
            'DaLuca V20 watch database error:',
            error
          );

          watchDatabasePromise = null;

          throw error;
        });

    return watchDatabasePromise;
  }


  /* =========================================================
     V20 SEARCH NORMALIZATION
  ========================================================= */

  function compactSearchValue(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/[^a-z0-9]/g, '');
  }


  function normalizedReferenceValue(value) {
    const compact =
      compactSearchValue(value);

    const simple =
      compact.match(
        /^([a-z]+)0*(\d+)$/
      );

    return simple
      ? simple[1] + simple[2]
      : compact;
  }


  function numericReferenceCore(value) {
    const compact =
      compactSearchValue(value);

    const digits =
      compact.replace(/\D/g, '');

    if (!digits) return '';

    return digits.replace(
      /^0+(?=\d)/,
      ''
    );
  }


  function searchValuesForRecord(record) {
    return [
      record.brand,
      displayModel(record),
      record.model,
      record.source_model,
      record.reference,
      record.canonical_reference,
      record.display_reference
    ]
      .concat(record.aliases || [])
      .concat(
        record.source_model_aliases || []
      )
      .concat(record.search_terms || [])
      .filter(Boolean)
      .map(String);
  }


  function wordStartsWith(
    values,
    token
  ) {
    return values.some((value) => {
      return String(value || '')
        .toLowerCase()
        .split(/[^a-z0-9]+/)
        .filter(Boolean)
        .some(
          (word) =>
            word.startsWith(token)
        );
    });
  }


  function compactSearchFormsForRecord(
    record
  ) {
    const brand =
      compactSearchValue(
        record.brand
      );

    const brandShort =
      brand.length >= 3
        ? brand.slice(0, 3)
        : brand;

    const model =
      compactSearchValue(
        displayModel(record)
      );

    const refValue =
      record.canonical_reference ||
      record.reference ||
      '';

    const ref =
      compactSearchValue(refValue);

    const normalizedRef =
      normalizedReferenceValue(
        refValue
      );

    const numericCore =
      numericReferenceCore(
        refValue
      );

    const forms = new Set();


    function add(value) {
      const compact =
        compactSearchValue(value);

      if (compact) {
        forms.add(compact);
      }
    }


    add(brand);
    add(model);
    add(ref);
    add(normalizedRef);
    add(numericCore);

    if (brand && ref) {
      add(brand + ref);
    }

    if (brand && normalizedRef) {
      add(
        brand +
        normalizedRef
      );
    }

    if (brand && numericCore) {
      add(
        brand +
        numericCore
      );
    }

    if (
      brandShort &&
      numericCore
    ) {
      add(
        brandShort +
        numericCore
      );
    }

    if (brand && model) {
      add(
        brand +
        model
      );
    }

    if (
      brandShort &&
      model
    ) {
      add(
        brandShort +
        model
      );
    }

    if (
      model &&
      numericCore
    ) {
      add(
        model +
        numericCore
      );
    }

    searchValuesForRecord(
      record
    ).forEach(add);

    return Array.from(forms);
  }


  function compactWholeQueryMatchScore(
    record,
    term
  ) {
    const query =
      compactSearchValue(term);

    if (query.length < 2) {
      return 0;
    }

    const forms =
      compactSearchFormsForRecord(
        record
      );

    if (
      forms.includes(query)
    ) {
      return 10000;
    }

    if (
      forms.some(
        (form) =>
          form.startsWith(query)
      )
    ) {
      return 4200;
    }

    if (
      query.length >= 5 &&
      forms.some(
        (form) =>
          form.includes(query)
      )
    ) {
      return 1800;
    }

    return 0;
  }


  function queryTokens(term) {
    return String(term || '')
      .trim()
      .toLowerCase()
      .split(/\s+/)
      .map(
        (token) =>
          token.trim()
      )
      .filter(Boolean);
  }


  function tokenMatchesRecord(
    record,
    token
  ) {
    const lowerToken =
      String(token || '')
        .toLowerCase();

    if (!lowerToken) {
      return true;
    }

    const values =
      searchValuesForRecord(
        record
      );

    /*
      Bare numeric shorthand:
      Panerai 111 -> PAM00111
    */
    if (
      /^\d+$/.test(
        lowerToken
      )
    ) {
      const tokenCore =
        lowerToken.replace(
          /^0+(?=\d)/,
          ''
        );

      const refs = [
        record.reference,
        record.canonical_reference
      ].filter(Boolean);

      const refMatch =
        refs.some((ref) => {
          const core =
            numericReferenceCore(
              ref
            );

          return (
            core === tokenCore ||
            core.startsWith(
              tokenCore
            )
          );
        });

      if (refMatch) {
        return true;
      }
    }

    /*
      Important for searches such as:

      Breitling a

      "a" should match Avenger rather than
      randomly matching every record containing
      the letter a.
    */
    if (
      lowerToken.length === 1
    ) {
      return wordStartsWith(
        values,
        lowerToken
      );
    }

    const compactToken =
      compactSearchValue(
        lowerToken
      );

    const normalizedToken =
      normalizedReferenceValue(
        lowerToken
      );

    return values.some(
      (value) => {

        const lower =
          String(value || '')
            .toLowerCase();

        const compact =
          compactSearchValue(
            value
          );

        const normalized =
          normalizedReferenceValue(
            value
          );

        return (
          lower.includes(
            lowerToken
          ) ||
          (
            compactToken &&
            compact.includes(
              compactToken
            )
          ) ||
          (
            normalizedToken &&
            normalized.includes(
              normalizedToken
            )
          )
        );
      }
    );
  }


  function recordMatchesSearch(
    record,
    term
  ) {
    if (
      compactWholeQueryMatchScore(
        record,
        term
      ) > 0
    ) {
      return true;
    }

    const tokens =
      queryTokens(term);

    return tokens.every(
      (token) =>
        tokenMatchesRecord(
          record,
          token
        )
    );
  }


  function watchResultScore(
    record,
    term
  ) {
    const t =
      String(term || '')
        .trim()
        .toLowerCase();

    const ref =
      String(
        record.reference || ''
      ).toLowerCase();

    const model =
      displayModel(
        record
      ).toLowerCase();

    const brand =
      String(
        record.brand || ''
      ).toLowerCase();

    const tokens =
      queryTokens(t);

    let score = 100;

    score +=
      compactWholeQueryMatchScore(
        record,
        t
      );

    if (ref === t) {
      score += 5000;
    }

    if (
      normalizedReferenceValue(
        ref
      ) ===
      normalizedReferenceValue(
        t
      )
    ) {
      score += 4500;
    }

    if (
      ref.startsWith(t)
    ) {
      score += 1800;
    }

    if (model === t) {
      score += 1400;
    }

    if (
      model.startsWith(t)
    ) {
      score += 1000;
    }

    if (brand === t) {
      score += 800;
    }

    score +=
      Number(
        record.display_priority ||
        0
      );

    tokens.forEach(
      (token, index) => {

        if (brand === token) {
          score +=
            index === 0
              ? 700
              : 350;
        } else if (
          brand.startsWith(
            token
          )
        ) {
          score +=
            index === 0
              ? 450
              : 220;
        }

        if (
          model === token
        ) {
          score += 650;
        } else if (
          model.startsWith(
            token
          )
        ) {
          score += 450;
        }

        if (
          /^\d+$/.test(
            token
          )
        ) {
          const tokenCore =
            token.replace(
              /^0+(?=\d)/,
              ''
            );

          const refCore =
            numericReferenceCore(
              record.canonical_reference ||
              record.reference
            );

          if (
            refCore ===
            tokenCore
          ) {
            score += 6000;
          } else if (
            refCore.startsWith(
              tokenCore
            )
          ) {
            score += 1800;
          }
        }
      }
    );

    return score;
  }


  /* =========================================================
     V20 AUTHORITATIVE REFERENCE GROUPING
  ========================================================= */

  function referenceGroupKey(
    record
  ) {
    const explicit =
      String(
        record.reference_group ||
        ''
      ).trim();

    if (explicit) {
      return (
        explicit +
        '|||' +
        String(
          record.lug_width_mm
        )
      );
    }

    return [
      String(
        record.brand || ''
      ).toLowerCase(),

      displayModel(
        record
      ).toLowerCase(),

      String(
        record.lug_width_mm
      ),

      normalizedReferenceValue(
        displayReference(
          record
        )
      )
    ].join('|||');
  }


  function consolidateWatchResults(
    records,
    term
  ) {
    const groups = new Map();

    records.forEach(
      (record) => {

        const key =
          referenceGroupKey(
            record
          );

        if (
          !groups.has(key)
        ) {
          groups.set(
            key,
            []
          );
        }

        groups
          .get(key)
          .push(record);
      }
    );

    return Array.from(
      groups.values()
    )
      .map((members) => {

        members.sort(
          (a, b) => {

            const score =
              watchResultScore(
                b,
                term
              ) -
              watchResultScore(
                a,
                term
              );

            if (score) {
              return score;
            }

            return (
              Number(
                b.display_priority ||
                0
              ) -
              Number(
                a.display_priority ||
                0
              )
            );
          }
        );

        return {
          record:
            members[0],

          display_reference:
            displayReference(
              members[0]
            ),

          width:
            Number(
              members[0]
                .lug_width_mm
            )
        };
      })
      .sort((a, b) => {

        const score =
          watchResultScore(
            b.record,
            term
          ) -
          watchResultScore(
            a.record,
            term
          );

        if (score) {
          return score;
        }

        return (
          Number(
            b.record
              .display_priority ||
              0
          ) -
          Number(
            a.record
              .display_priority ||
              0
          )
        );
      });
  }


  /* =========================================================
     WATCH SEARCH UI
  ========================================================= */

  function getWatchSearchInput() {
    return document.getElementById(
      'DaLucaCollectionWatchSearch'
    );
  }


  function getWatchResultsBox() {
    const root = getRoot();

    if (!root) return null;

    return root.querySelector(
      '[data-daluca-watch-results]'
    );
  }


  function showWatchLoading() {
    const box =
      getWatchResultsBox();

    if (!box) return;

    box.hidden = false;

    window.DaLucaI18n.setHtml(box, '<div class="daluca-watch-search-message">Loading watch database…</div>');
  }


  function showWatchDatabaseError() {
    const box =
      getWatchResultsBox();

    if (!box) return;

    box.hidden = false;

    window.DaLucaI18n.setHtml(box, '<div class="daluca-watch-search-message">Watch search is temporarily unavailable. Please use the full Strap Finder or contact DaLuca.</div>');
  }


  function renderWatchResults(
    term
  ) {
    const box =
      getWatchResultsBox();

    if (
      !box ||
      !watchDatabase
    ) {
      return;
    }

    const search =
      String(term || '')
        .trim();

    if (
      search.length < 2
    ) {
      box.hidden = true;
      window.DaLucaI18n.setHtml(box, '');
      renderedWatchGroups = [];

      return;
    }

    const candidates =
      watchDatabase
        .filter(
          (record) =>
            recordMatchesSearch(
              record,
              search
            )
        )
        .sort(
          (a, b) => {

            const score =
              watchResultScore(
                b,
                search
              ) -
              watchResultScore(
                a,
                search
              );

            if (score) {
              return score;
            }

            return String(
              a.reference || ''
            ).localeCompare(
              String(
                b.reference ||
                ''
              ),
              undefined,
              {
                numeric: true,
                sensitivity: 'base'
              }
            );
          }
        );

    if (
      !candidates.length
    ) {
      renderedWatchGroups = [];

      box.hidden = false;

      window.DaLucaI18n.setHtml(box, '<div class="daluca-watch-search-message">No match yet. Keep typing, or try the brand, model, or reference number.</div>');

      return;
    }

    renderedWatchGroups =
      consolidateWatchResults(
        candidates,
        search
      ).slice(0, 40);

    box.hidden = false;

    window.DaLucaI18n.setHtml(box, renderedWatchGroups
        .map(
          (group, index) => {

            const record =
              group.record;

            return `
              <button
                type="button"
                class="daluca-watch-result"
                data-daluca-watch-index="${index}"
              >
                <span class="daluca-watch-result__main">
                  <strong>
                    ${escapeHtml(record.brand)}
                    ${escapeHtml(displayModel(record))}
                  </strong>

                  <small>
                    Ref. ${escapeHtml(group.display_reference)}
                  </small>
                </span>

                <span class="daluca-watch-result__width">
                  ${escapeHtml(group.width)}mm
                </span>
              </button>
            `;
          }
        )
        .join(''));
  }


  function runWatchSearch(
    term
  ) {
    const search =
      String(term || '');

    if (
      search.trim().length < 2
    ) {
      const box =
        getWatchResultsBox();

      if (box) {
        box.hidden = true;
        window.DaLucaI18n.setHtml(box, '');
      }

      return;
    }

    if (!watchDatabase) {
      showWatchLoading();
    }

    ensureWatchDatabase()
      .then(() => {

        /*
          The customer may have typed additional
          characters while V20 was loading.
        */
        const currentInput =
          getWatchSearchInput();

        renderWatchResults(
          currentInput
            ? currentInput.value
            : search
        );
      })
      .catch(
        showWatchDatabaseError
      );
  }


  /* =========================================================
     SAVED WATCH
  ========================================================= */

  function saveWatch(record) {
    const watch = {
      brand_id:
        record.brand_id ||
        '',

      brand:
        record.brand ||
        '',

      model:
        displayModel(
          record
        ),

      reference:
        displayReference(
          record
        ),

      canonical_reference:
        record.canonical_reference ||
        record.reference ||
        '',

      reference_group:
        record.reference_group ||
        '',

      lug_width_mm:
        Number(
          record.lug_width_mm
        ),

      collection_handle:
        getCollectionContext()
          .handle ||
        ''
    };

    try {
      localStorage.setItem(
        SAVED_WATCH_KEY,
        JSON.stringify(watch)
      );
    } catch (error) {
      console.warn(
        'DaLuca saved watch unavailable:',
        error
      );
    }

    return watch;
  }


  function getSavedWatch() {
    try {
      const raw =
        localStorage.getItem(
          SAVED_WATCH_KEY
        );

      if (!raw) return null;

      const watch =
        JSON.parse(raw);

      if (
        !watch ||
        !watch.brand ||
        !Number(
          watch.lug_width_mm
        )
      ) {
        return null;
      }

      const current = window.DaLucaWatchData.safeSaved(watch);
      return current && !window.DaLucaWatchData.requiresReview(current) &&
        window.DaLucaWatchData.canOrderWidth(current.lug_width_mm) ? current : null;

    } catch (error) {
      return null;
    }
  }


  function removeSavedWatch() {
    try {
      localStorage.removeItem(
        SAVED_WATCH_KEY
      );
    } catch (error) {
      /*
        Storage failure must never break
        collection filtering.
      */
    }
  }


  function normalizeCustomProgramWidth(value) {
    const numeric =
      String(value == null ? '' : value)
        .replace(/mm/gi, '')
        .trim();

    return CUSTOM_PROGRAM_WIDTHS.has(numeric)
      ? Number(numeric)
      : null;
  }


  function selectCustomProgramWidth(value) {
    if (!isCustomProgramCollection()) {
      return false;
    }

    const numeric =
      normalizeCustomProgramWidth(value);

    if (!numeric) {
      return false;
    }

    selectedCustomProgramWidth =
      selectedCustomProgramWidth === numeric
        ? null
        : numeric;

    document.dispatchEvent(
      new CustomEvent(
        'daluca:custom-program-width-change',
        {
          detail: {
            width: selectedCustomProgramWidth
          }
        }
      )
    );

    return true;
  }


  window.DaLucaCustomProgramWidth = {
    isCustomCollection: function () {
      return isCustomProgramCollection();
    },

    selected: function () {
      return selectedCustomProgramWidth;
    },

    select: selectCustomProgramWidth,

    clear: function () {
      if (!selectedCustomProgramWidth) {
        return false;
      }

      selectedCustomProgramWidth = null;

      document.dispatchEvent(
        new CustomEvent(
          'daluca:custom-program-width-change',
          { detail: { width: null } }
        )
      );

      return true;
    }
  };


  function normalizeManualCustomWidth(value) {
    const numeric =
      String(value == null ? '' : value)
        .replace(/mm/gi, '')
        .trim();

    return MANUAL_CUSTOM_WIDTHS.has(numeric)
      ? Number(numeric)
      : null;
  }


  function manualCustomWidthFromUrl() {
    try {
      const params =
        new URLSearchParams(
          window.location.search
        );

      return normalizeManualCustomWidth(
        params.get(
          MANUAL_CUSTOM_WIDTH_PARAM
        )
      );
    } catch (error) {
      return null;
    }
  }


  function getActiveManualCustomWidth() {
    if (
      getCollectionContext().handle !==
        'custom-watch-straps'
    ) {
      return null;
    }

    if (activeManualCustomWidth) {
      return activeManualCustomWidth;
    }

    activeManualCustomWidth =
      manualCustomWidthFromUrl();

    return activeManualCustomWidth;
  }


  function ensureManualCustomWidthCarryInput(
    width
  ) {
    const form = getFacetForm();

    if (!form || !width) return;

    let input =
      form.querySelector(
        '[data-daluca-manual-custom-width]'
      );

    if (!input) {
      input =
        document.createElement('input');

      input.type = 'hidden';
      input.name =
        MANUAL_CUSTOM_WIDTH_PARAM;

      input.setAttribute(
        'data-daluca-manual-custom-width',
        'true'
      );

      form.appendChild(input);
    }

    input.value = String(width);
  }


  function clearManualCustomWidthRoute() {
    activeManualCustomWidth = null;

    document
      .querySelectorAll(
        '[data-daluca-manual-custom-width]'
      )
      .forEach(function (input) {
        input.remove();
      });

    const notice =
      document.querySelector(
        '[data-daluca-manual-custom-fit]'
      );

    if (notice) {
      notice.hidden = true;
    }

    try {
      const url =
        new URL(
          window.location.href
        );

      if (
        url.searchParams.has(
          MANUAL_CUSTOM_WIDTH_PARAM
        )
      ) {
        url.searchParams.delete(
          MANUAL_CUSTOM_WIDTH_PARAM
        );

        window.history.replaceState(
          window.history.state,
          '',
          url.pathname +
            (url.searchParams.toString()
              ? '?' + url.searchParams.toString()
              : '') +
            url.hash
        );
      }
    } catch (error) {
      /* URL cleanup is a progressive enhancement only. */
    }
  }


  function getOrCreateManualCustomFitNotice() {
    const root = getRoot();

    if (!root) return null;

    let notice =
      root.querySelector(
        '[data-daluca-manual-custom-fit]'
      );

    if (notice) {
      return notice;
    }

    notice =
      document.createElement('div');

    notice.className =
      'daluca-custom-fit';

    notice.setAttribute(
      'data-daluca-manual-custom-fit',
      ''
    );

    window.DaLucaI18n.setHtml(notice, `
      <div class="daluca-custom-fit__copy">
        <span>EXACT WIDTH — MADE TO ORDER</span>
        <strong data-daluca-manual-custom-title></strong>
        <p data-daluca-manual-custom-copy></p>
      </div>
    `);

    const fitCard =
      root.querySelector(
        '.daluca-filter-fit'
      );

    if (
      fitCard &&
      fitCard.parentNode
    ) {
      fitCard.insertAdjacentElement(
        'afterend',
        notice
      );
    } else {
      root.insertBefore(
        notice,
        root.firstChild
      );
    }

    return notice;
  }


  function syncManualCustomWidthRouteUI() {
    const width =
      getActiveManualCustomWidth();

    if (!width) {
      return false;
    }

    const root = getRoot();

    if (!root) return false;

    ensureManualCustomWidthCarryInput(
      width
    );

    const widthSlot =
      root.querySelector(
        '[data-daluca-dynamic-filter-slot="width"]'
      );

    if (widthSlot) {
      widthSlot.hidden = true;
    }

    const heading =
      root.querySelector(
        '.daluca-filter-fit__heading'
      );

    if (heading) {
      setTextIfNeeded(
        heading.querySelector(
          '.daluca-filter-fit__eyebrow'
        ),
        `${width}MM EXACT WIDTH — MADE TO ORDER`
      );

      setTextIfNeeded(
        heading.querySelector(
          '.daluca-filter-fit__title'
        ),
        `Custom straps for your exact ${width}mm fit`
      );

      setTextIfNeeded(
        heading.querySelector(
          '.daluca-filter-fit__text'
        ),
        `DaLuca offers ${width}mm as a made-to-order fit. Every custom option below can be built to this exact width; refine the assortment by style or filters.`
      );
    }

    const notice =
      getOrCreateManualCustomFitNotice();

    if (notice) {
      notice.hidden = false;

      setTextIfNeeded(
        notice.querySelector(
          '[data-daluca-manual-custom-title]'
        ),
        `${width}mm custom fit`
      );

      setTextIfNeeded(
        notice.querySelector(
          '[data-daluca-manual-custom-copy]'
        ),
        `These made-to-order straps can be built specifically for a ${width}mm lug width. Choose a style above or use Filters to narrow the custom options.`
      );
    }

    setProductCountHidden(false);

    return true;
  }


  function notifyPendingManualCustomWidth() {
    document.dispatchEvent(
      new CustomEvent(
        'daluca:manual-custom-width-pending',
        {
          detail: {
            width: pendingManualCustomWidth
          }
        }
      )
    );
  }


  function routeManualWidthToCustomCollection(
    width
  ) {
    const numericWidth =
      normalizeManualCustomWidth(width);

    if (!numericWidth) {
      return false;
    }

    /*
      Manual Custom-route widths are staged first. This keeps the filter drawer
      open so an accidental 14–28mm Custom-route tap never throws the shopper
      into Custom Mode immediately. APPLY / VIEW PRODUCTS commits it.
    */
    pendingManualCustomWidth =
      pendingManualCustomWidth === numericWidth
        ? null
        : numericWidth;

    notifyPendingManualCustomWidth();

    return true;
  }


  function applyPendingManualCustomWidthRoute() {
    const numericWidth =
      normalizeManualCustomWidth(
        pendingManualCustomWidth
      );

    if (!numericWidth) {
      return false;
    }

    pendingManualCustomWidth = null;
    notifyPendingManualCustomWidth();

    /*
      Once the shopper explicitly applies a Custom-route width, it becomes
      the authoritative fit context. Only then do we clear a saved watch
      and swap the current grid into the in-place Custom assortment.
    */
    removeSavedWatch();

    if (
      window.DaLucaInPlaceCustomMode &&
      typeof window.DaLucaInPlaceCustomMode.enter === 'function'
    ) {
      window.DaLucaInPlaceCustomMode.enter({
        width: numericWidth,
        source: 'manual'
      });

      return true;
    }

    return false;
  }


  function clearPendingManualCustomWidthRoute() {
    if (!pendingManualCustomWidth) {
      return false;
    }

    pendingManualCustomWidth = null;
    notifyPendingManualCustomWidth();
    return true;
  }


  window.DaLucaManualCustomWidthRoute = {
    isCustomWidth: function (value) {
      return !!normalizeManualCustomWidth(
        value
      );
    },

    route: routeManualWidthToCustomCollection,

    applyPending: applyPendingManualCustomWidthRoute,

    clearPending: clearPendingManualCustomWidthRoute,

    pending: function () {
      return pendingManualCustomWidth;
    },

    collectionLocked: function () {
      return collectionHasLockedWidth();
    }
  };


  function isCustomWatchRoute(
    watch
  ) {
    return !!(
      watch &&
      window.DaLucaInPlaceCustomMode &&
      window.DaLucaInPlaceCustomMode.active()
    );
  }


  function markWatchForCustomRoute(
    watch
  ) {
    const routedWatch = {
      ...watch,
      custom_route: true,
      custom_route_width_mm: Number(
        watch.lug_width_mm
      ),
      custom_route_source_handle:
        getCollectionContext().handle || ''
    };

    try {
      localStorage.setItem(
        SAVED_WATCH_KEY,
        JSON.stringify(routedWatch)
      );
    } catch (error) {
      console.warn(
        'DaLuca custom route state unavailable:',
        error
      );
    }

    return routedWatch;
  }


  function routeWatchToCustomCollection(
    watch
  ) {
    if (!watch) return false;

    const width =
      Number(watch.lug_width_mm);

    if (
      !Number.isFinite(width)
    ) {
      return false;
    }

    let attempts = 0;

    function enterCustomMode() {
      if (
        window.DaLucaInPlaceCustomMode &&
        typeof window.DaLucaInPlaceCustomMode.enter === 'function'
      ) {
        window.DaLucaInPlaceCustomMode.enter({
          width: width,
          source: 'watch',
          watch: watch
        });

        return true;
      }

      /*
        The in-place Custom module is declared later in this asset.
        On a very fast tap / restored Safari page, allow it a few
        short ticks to finish initializing instead of silently
        leaving the shopper on the ready-made collection.
      */
      attempts += 1;

      if (attempts <= 8) {
        window.setTimeout(
          enterCustomMode,
          attempts * 35
        );

        return true;
      }

      /*
        Absolute safety fallback: if the in-place module truly
        cannot initialize, never leave an odd-width watch showing
        incompatible ready-made products. Carry the watch context
        into the real Custom collection instead.
      */
      markWatchForCustomRoute(
        watch
      );

      const url = new URL(
        CUSTOM_COLLECTION_PATH,
        window.location.origin
      );

      [
        'preview_theme_id',
        '_fd',
        'pb'
      ].forEach(function (key) {
        const value =
          new URL(window.location.href)
            .searchParams
            .get(key);

        if (value) {
          url.searchParams.set(
            key,
            value
          );
        }
      });

      window.location.assign(
        url.toString()
      );

      return false;
    }

    return enterCustomMode();
  }


  function syncCustomWatchRouteUI(
    watch
  ) {
    const root = getRoot();

    if (!root) return;

    const customRoute =
      isCustomWatchRoute(watch);

    const widthSlot =
      root.querySelector(
        '[data-daluca-dynamic-filter-slot="width"]'
      );

    if (widthSlot) {
      widthSlot.hidden = customRoute;
    }

    const heading =
      root.querySelector(
        '.daluca-filter-fit__heading'
      );

    if (!heading) return;

    const eyebrow =
      heading.querySelector(
        '.daluca-filter-fit__eyebrow'
      );

    const title =
      heading.querySelector(
        '.daluca-filter-fit__title'
      );

    const copy =
      heading.querySelector(
        '.daluca-filter-fit__text'
      );

    if (customRoute) {
      setTextIfNeeded(
        eyebrow,
        'MADE TO ORDER FOR YOUR WATCH'
      );

      setTextIfNeeded(
        title,
        'Custom straps in your exact width'
      );

      setTextIfNeeded(
        copy,
        `These made-to-order options can be built specifically for your watch's exact ${watch.lug_width_mm}mm lug width. Choose a style below to narrow the custom options.`
      );

      return;
    }

    setTextIfNeeded(
      eyebrow,
      'SHOP FOR YOUR WATCH'
    );

    setTextIfNeeded(
      title,
      'Find straps made to fit your watch'
    );

    setTextIfNeeded(
      copy,
      'Search your brand, model or reference and we’ll match the exact lug width.'
    );
  }


  /* =========================================================
     SELECTED WATCH DISPLAY
  ========================================================= */

  function setTextIfNeeded(
    element,
    value
  ) {
    if (
      element &&
      window.DaLucaI18n.sourceText(element) !== value
    ) {
      window.DaLucaI18n.setText(element, value);
    }
  }


  function renderSelectedWatchUI(
    watch
  ) {
    if (
      renderCollectionContextUI()
    ) {
      return;
    }

    const root =
      getRoot();

    if (!root) return;

    const selected =
      root.querySelector(
        '[data-daluca-selected-watch]'
      );

    if (!selected) return;

    const search =
      root.querySelector(
        '.daluca-filter-fit__search'
      );

    const changeButton =
      selected.querySelector(
        '[data-daluca-change-watch]'
      );

    const label =
      selected.querySelector(
        '.daluca-filter-fit__selected-label'
      );

    if (search) {
      search.hidden = false;
    }

    if (changeButton) {
      changeButton.hidden = false;
    }

    syncCustomWatchRouteUI(
      watch
    );

    setTextIfNeeded(
      label,
      isCustomWatchRoute(watch)
        ? 'CUSTOM FIT FOR YOUR WATCH'
        : 'YOUR WATCH'
    );

    if (!watch) {
      selected.hidden = true;
      hideCustomFitNotice();
      return;
    }

    selected.hidden = false;

    const name =
      root.querySelector(
        '[data-daluca-selected-watch-name]'
      );

    const width =
      root.querySelector(
        '[data-daluca-selected-watch-width]'
      );

    setTextIfNeeded(
      name,
      `${watch.brand} ${watch.model} · Ref. ${watch.reference}`
    );

    setTextIfNeeded(
      width,
      `${watch.lug_width_mm}mm lug width`
    );

    if (
      collectionAllowsWidth(
        watch.lug_width_mm
      ) ||
      isCustomWatchRoute(
        watch
      )
    ) {
      hideCustomFitNotice();
    } else {
      showCustomFitNotice(
        watch
      );
    }
  }


  /* =========================================================
     CUSTOM WIDTH ROUTE
  ========================================================= */

  function getOrCreateCustomFitNotice() {
    const root =
      getRoot();

    if (!root) return null;

    let notice =
      root.querySelector(
        '[data-daluca-custom-fit]'
      );

    if (notice) {
      return notice;
    }

    notice =
      document.createElement(
        'div'
      );

    notice.className =
      'daluca-custom-fit';

    notice.setAttribute(
      'data-daluca-custom-fit',
      ''
    );

    window.DaLucaI18n.setHtml(notice, `
      <div class="daluca-custom-fit__copy">
        <span>EXACT WIDTH REQUIRED</span>
        <strong data-daluca-custom-fit-title></strong>
        <p data-daluca-custom-fit-copy></p>
      </div>

      <a
        class="daluca-custom-fit__button"
        data-daluca-custom-fit-link
      >
        SHOP CUSTOM STRAPS →
      </a>
    `);

    const fitCard =
      root.querySelector(
        '.daluca-filter-fit'
      );

    if (
      fitCard &&
      fitCard.parentNode
    ) {
      fitCard.insertAdjacentElement(
        'afterend',
        notice
      );
    } else {
      root.insertBefore(
        notice,
        root.firstChild
      );
    }

    return notice;
  }


  function setProductCountHidden(
    hidden
  ) {

    document
      .querySelectorAll(
        '.daluca-results-count'
      )
      .forEach(function (count) {

        count.hidden =
          !!hidden;

        if (hidden) {
          count.style.setProperty(
            'display',
            'none',
            'important'
          );
        } else {
          count.style.removeProperty(
            'display'
          );
        }

      });

  }


  function showCustomFitNotice(
    watch
  ) {
    const notice =
      getOrCreateCustomFitNotice();

    if (!notice) return;

    notice.hidden = false;

    /*
      When a watch requires Custom, there are intentionally
      no compatible ready-made products to count. Hide the
      results count so "0 products" does not look like a
      failed search.
    */
    setProductCountHidden(
      true
    );

    const title =
      notice.querySelector(
        '[data-daluca-custom-fit-title]'
      );

    const copy =
      notice.querySelector(
        '[data-daluca-custom-fit-copy]'
      );

    const link =
      notice.querySelector(
        '[data-daluca-custom-fit-link]'
      );

    setTextIfNeeded(
      title,
      `${watch.lug_width_mm}mm fit — made to order`
    );

    const collectionTitle =
      getCollectionContext()
        .title;

    setTextIfNeeded(
      copy,
      `${watch.brand} ${watch.model} requires an exact ${watch.lug_width_mm}mm strap. ${collectionTitle ? collectionTitle + ' does' : 'This collection does'} not currently offer that exact ready-made width, so we will not recommend the wrong size.`
    );

    if (link) {
      link.href =
        window.DaLucaI18n.url('/collections/custom-watch-straps?') +
        WIDTH_PARAM +
        '=' +
        encodeURIComponent(
          `${watch.lug_width_mm}mm`
        );
    }
  }


  function hideCustomFitNotice() {
    const root =
      getRoot();

    if (!root) return;

    const notice =
      root.querySelector(
        '[data-daluca-custom-fit]'
      );

    if (notice) {
      notice.hidden = true;
    }

    /*
      Restore the normal collection product count whenever
      the shopper is no longer in the Custom-fit state.
    */
    setProductCountHidden(
      false
    );
  }


  /* =========================================================
     EXACT WIDTH -> SHOPIFY FILTER
  ========================================================= */

  function getWidthInputs() {
    const form =
      getFacetForm();

    if (!form) return [];

    return Array.from(
      form.querySelectorAll(
        `input[name="${WIDTH_PARAM}"]`
      )
    );
  }


  function clearStyleInputs() {
    getStyleInputs()
      .forEach((input) => {
        input.checked = false;
      });
  }


  function clearLegacyWidthInputs() {
    const form =
      getFacetForm();

    if (!form) return;

    form
      .querySelectorAll(
        `input[name="${LEGACY_WIDTH_PARAM}"]`
      )
      .forEach((input) => {
        input.checked = false;
      });
  }


  function applyReadyMadeWidth(
    watch
  ) {
    const form =
      getFacetForm();

    if (!form) return;

    const width =
      String(
        watch.lug_width_mm
      );

    const value =
      `${width}mm`;

    /*
      Watch fit is the primary constraint.

      Clear an existing Style selection while
      changing watches so an old Style cannot
      accidentally prevent the new watch width
      from loading.
    */
    clearStyleInputs();
    clearLegacyWidthInputs();

    const widthInputs =
      getWidthInputs();

    widthInputs.forEach(
      (input) => {
        input.checked = false;
      }
    );

    let target =
      widthInputs.find(
        (input) =>
          input.value === value
      );

    /*
      During an existing filtered state Shopify
      can omit a currently unavailable facet value.

      For DaLuca's standard ready-made widths — and for
      Custom collections that intentionally accept 18–26mm —
      a temporary width input is safe when Habitat has omitted
      the value from the current filtered state.
    */
    if (
      !target &&
      collectionAllowsWidth(width)
    ) {
      target =
        document.createElement(
          'input'
        );

      target.type =
        'checkbox';

      target.name =
        WIDTH_PARAM;

      target.value =
        value;

      target.checked =
        true;

      target.hidden =
        true;

      target.setAttribute(
        'data-daluca-temp-width',
        'true'
      );

      form.appendChild(
        target
      );

    } else if (target) {
      target.disabled =
        false;

      target.checked =
        true;
    }

    if (!target) {
      return;
    }

    target.dispatchEvent(
      new Event('input', {
        bubbles: true
      })
    );
  }


  function clearCurrentWidthFilter() {
    const form =
      getFacetForm();

    if (!form) return;

    const checkedWidth =
      getWidthInputs().find(
        (input) =>
          input.checked
      );

    getWidthInputs()
      .forEach((input) => {
        input.checked = false;
      });

    clearLegacyWidthInputs();

    /*
      If a native checked width exists,
      let Habitat clear it normally.
    */
    if (checkedWidth) {
      checkedWidth.dispatchEvent(
        new Event('input', {
          bubbles: true
        })
      );
    }
  }


  function selectWatch(
    record
  ) {
    if (
      collectionHasLockedWidth()
    ) {
      return;
    }

    /*
      If the shopper arrived in Custom through a manual odd-width
      choice and then selects an actual watch, the watch becomes the
      authoritative fit context.
    */
    if (getActiveManualCustomWidth()) {
      clearManualCustomWidthRoute();
    }

    if (
      !record ||
      !Number(
        record.lug_width_mm
      )
    ) {
      return;
    }

    // A documented dimension does not approve attachment or Custom inventory.
    if (window.DaLucaWatchData.requiresReview(record) ||
        !window.DaLucaWatchData.canOrderWidth(record.lug_width_mm)) {
      removeSavedWatch();
      const destination = new URL(window.DaLucaI18n.url('/pages/strap-finder'), window.location.origin);
      destination.searchParams.set('watch', record.canonical_reference || record.reference);
      window.location.assign(destination.pathname + destination.search);
      return;
    }

    const watch =
      saveWatch(record);

    const input =
      getWatchSearchInput();

    if (input) {
      input.value =
        `${watch.brand} ${watch.model}`;
    }

    const results =
      getWatchResultsBox();

    if (results) {
      results.hidden = true;
    }

    /*
      Standard width:
      render the selected watch, then let Shopify/Habitat apply the native
      exact-width facet.

      Odd/intermediate width:
      enter DaLuca's in-place Custom Mode FIRST. Rendering the selected-watch
      UI after Custom Mode is active prevents the legacy exact-fit guard from
      briefly hiding the product grid/count on mobile Safari.
    */
    if (
      collectionAllowsWidth(
        watch.lug_width_mm
      )
    ) {
      renderSelectedWatchUI(
        watch
      );

      applyReadyMadeWidth(
        watch
      );

    } else {
      routeWatchToCustomCollection(
        watch
      );

      renderSelectedWatchUI(
        watch
      );
    }
  }


  function clearWatchSelection() {
    if (
      window.DaLucaInPlaceCustomMode &&
      window.DaLucaInPlaceCustomMode.active()
    ) {
      window.DaLucaInPlaceCustomMode.exit();
    }

    removeSavedWatch();

    const root =
      getRoot();

    const input =
      getWatchSearchInput();

    if (input) {
      input.value = '';
    }

    const results =
      getWatchResultsBox();

    if (results) {
      results.hidden = true;
      window.DaLucaI18n.setHtml(results, '');
    }

    if (root) {
      const selected =
        root.querySelector(
          '[data-daluca-selected-watch]'
        );

      if (selected) {
        selected.hidden = true;
      }
    }

    hideCustomFitNotice();

    syncCustomWatchRouteUI(
      null
    );

    clearCurrentWidthFilter();

    window.setTimeout(
      function () {
        syncStyleButtons();

        const freshInput =
          getWatchSearchInput();

        if (freshInput) {
          freshInput.focus();
        }
      },
      150
    );
  }


  /* =========================================================
     EVENTS
  ========================================================= */

  document.addEventListener(
    'click',
    function (event) {

      /*
        STYLE
      */
      const styleButton =
        event.target.closest(
          '[data-daluca-style]'
        );

      if (styleButton) {
        event.preventDefault();

        if (
          !styleButton.disabled
        ) {
          applyStyle(
            styleButton
              .dataset
              .dalucaStyle
          );
        }

        return;
      }


      /*
        WATCH RESULT
      */
      const watchResult =
        event.target.closest(
          '[data-daluca-watch-index]'
        );

      if (watchResult) {
        event.preventDefault();

        const index =
          Number(
            watchResult
              .dataset
              .dalucaWatchIndex
          );

        const group =
          renderedWatchGroups[
            index
          ];

        if (
          group &&
          group.record
        ) {
          selectWatch(
            group.record
          );
        }

        return;
      }


      /*
        CHANGE WATCH

        Supports either our explicit data
        attribute or the existing Change
        button inside the selected-watch box.
      */
      const changeWatch =
        event.target.closest(
          '[data-daluca-change-watch], [data-daluca-selected-watch] button'
        );

      if (changeWatch) {
        event.preventDefault();

        clearWatchSelection();

        return;
      }


      /*
        Clicking outside the result list
        closes it.
      */
      const root =
        getRoot();

      if (
        root &&
        !event.target.closest(
          '#DaLucaCollectionWatchSearch'
        ) &&
        !event.target.closest(
          '[data-daluca-watch-results]'
        )
      ) {
        const box =
          getWatchResultsBox();

        if (box) {
          box.hidden = true;
        }
      }
    }
  );


  document.addEventListener(
    'input',
    function (event) {

      if (
        event.target.id !==
        'DaLucaCollectionWatchSearch'
      ) {
        return;
      }

      runWatchSearch(
        event.target.value
      );
    }
  );


  document.addEventListener(
    'focusin',
    function (event) {

      if (
        event.target.id !==
        'DaLucaCollectionWatchSearch'
      ) {
        return;
      }

      /*
        Lazy-load V20 only when the shopper
        actually interacts with Watch Search.
        This avoids downloading the large
        database unnecessarily on every
        collection visit.
      */
      ensureWatchDatabase()
        .then(() => {
          if (
            event.target.value
              .trim()
              .length >= 2
          ) {
            renderWatchResults(
              event.target.value
            );
          }
        })
        .catch(
          showWatchDatabaseError
        );
    }
  );


  document.addEventListener(
    'keydown',
    function (event) {

      if (
        event.target.id !==
        'DaLucaCollectionWatchSearch'
      ) {
        return;
      }

      if (
        event.key === 'Escape'
      ) {
        const box =
          getWatchResultsBox();

        if (box) {
          box.hidden = true;
        }

        return;
      }

      /*
        Enter chooses the highest-ranked
        visible database result.
      */
      if (
        event.key === 'Enter' &&
        renderedWatchGroups.length
      ) {
        event.preventDefault();

        selectWatch(
          renderedWatchGroups[0]
            .record
        );
      }
    }
  );


  /* =========================================================
     RESTORE STATE
  ========================================================= */

  function restoreDaLucaState() {
    if (
      renderCollectionContextUI()
    ) {
      syncStyleButtons();
      return;
    }

    renderSelectedWatchUI(
      getRelevantSavedWatch()
    );

    syncManualCustomWidthRouteUI();
    syncStyleButtons();
  }


  document.addEventListener(
    'DOMContentLoaded',
    restoreDaLucaState
  );


  window.addEventListener(
    'popstate',
    function () {
      window.setTimeout(
        restoreDaLucaState,
        150
      );
    }
  );


  /*
    Habitat replaces filter markup after
    AJAX requests.

    Our event handlers are delegated, so they
    survive. We only need to restore the visible
    selected-watch and Style states.
  */
  let syncTimer;

  const observer =
    new MutationObserver(
      function () {
        clearTimeout(
          syncTimer
        );

        syncTimer =
          setTimeout(
            restoreDaLucaState,
            100
          );
      }
    );

  observer.observe(
    document.body,
    {
      childList: true,
      subtree: true
    }
  );


  restoreDaLucaState();

})();

/* =========================================================
   DALUCA ADVANCED FILTER DRAWER — OPEN / CLOSE ONLY
========================================================= */

(function () {
  if (window.DaLucaFilterDrawerInitialized) return;
  window.DaLucaFilterDrawerInitialized = true;


  function getDrawer() {
    return document.querySelector(
      '[data-daluca-filter-drawer]'
    );
  }


  function getOverlay() {
    return document.querySelector(
      '[data-daluca-filter-overlay]'
    );
  }


  function getOpenButton() {
    return document.querySelector(
      '[data-daluca-open-filters]'
    );
  }


  function openDrawer() {
    const drawer = getDrawer();
    const overlay = getOverlay();
    const button = getOpenButton();

    if (!drawer || !overlay) return;

    overlay.hidden = false;
    drawer.hidden = false;

    drawer.setAttribute(
      'aria-hidden',
      'false'
    );

    if (button) {
      button.setAttribute(
        'aria-expanded',
        'true'
      );
    }

    document.documentElement.classList.add(
      'daluca-filters-open'
    );

    const closeButton =
      drawer.querySelector(
        '[data-daluca-close-filters]'
      );

    if (closeButton) {
      window.setTimeout(
        function () {
          closeButton.focus();
        },
        50
      );
    }
  }


  function closeDrawer() {
    const drawer = getDrawer();
    const overlay = getOverlay();
    const button = getOpenButton();

    if (!drawer || !overlay) return;

    drawer.hidden = true;
    overlay.hidden = true;

    drawer.setAttribute(
      'aria-hidden',
      'true'
    );

    if (button) {
      button.setAttribute(
        'aria-expanded',
        'false'
      );
    }

    document.documentElement.classList.remove(
      'daluca-filters-open'
    );
  }


  document.addEventListener(
    'click',
    function (event) {

      const openButton =
        event.target.closest(
          '[data-daluca-open-filters]'
        );

      if (openButton) {
        event.preventDefault();

        const drawer =
          getDrawer();

        if (
          drawer &&
          !drawer.hidden
        ) {
          closeDrawer();
        } else {
          openDrawer();
        }

        return;
      }


      const closeButton =
        event.target.closest(
          '[data-daluca-close-filters]'
        );

      if (closeButton) {
        event.preventDefault();
        closeDrawer();
        return;
      }


      if (
        event.target.closest(
          '[data-daluca-filter-overlay]'
        )
      ) {
        closeDrawer();
      }
    }
  );


  document.addEventListener(
    'keydown',
    function (event) {

      if (
        event.key === 'Escape' &&
        getDrawer() &&
        !getDrawer().hidden
      ) {
        closeDrawer();
      }
    }
  );

})();

/* =========================================================
   DALUCA CLEARANCE CATEGORY MODE

   Clearance uses a category-first shopping experience:
   - Top category buttons act as primary navigation and reset
     subordinate filters so customers never land in a dead
     combination such as Wallets + 24mm.
   - Category buttons inside the drawer preserve refinements.
   - Shopify Search & Discovery remains the filtering backend.
========================================================= */

(function () {

  if (window.DaLucaClearanceCategoryInitialized) return;
  window.DaLucaClearanceCategoryInitialized = true;


  const CLEARANCE_CATEGORY_PARAM =
    'filter.p.m.daluca_filter.clearance_category';


  function isClearanceMode() {

    return !!document.querySelector(
      '[data-daluca-clearance-mode]'
    );

  }


  function nativeForm() {

    return document.getElementById(
      'FacetFiltersForm'
    );

  }


  function categoryInputs() {

    const form = nativeForm();

    if (!form) return [];

    return Array.from(
      form.querySelectorAll(
        'input[name="' +
        CLEARANCE_CATEGORY_PARAM +
        '"]'
      )
    );

  }


  function findCategoryInput(value) {

    return categoryInputs().find(
      function (input) {
        return (
          String(input.value).trim() ===
          String(value).trim()
        );
      }
    ) || null;

  }


  function ensureCategoryInput(value) {

    let input =
      findCategoryInput(value);

    if (input) {
      input.disabled = false;
      return input;
    }

    const form = nativeForm();

    if (!form) return null;

    input =
      document.createElement('input');

    input.type = 'checkbox';
    input.name = CLEARANCE_CATEGORY_PARAM;
    input.value = value;
    input.hidden = true;
    input.checked = false;

    input.setAttribute(
      'data-daluca-temp-clearance-category',
      'true'
    );

    form.appendChild(input);

    return input;

  }


  function clearAllNativeFilters() {

    const form = nativeForm();

    if (!form) return;

    form.querySelectorAll(
      'input[name^="filter."]'
    ).forEach(function (input) {

      const type =
        String(input.type || '')
          .toLowerCase();

      if (
        type === 'checkbox' ||
        type === 'radio'
      ) {
        input.checked = false;
        return;
      }

      if (
        type === 'number' ||
        type === 'text' ||
        type === 'search'
      ) {
        input.value = '';
      }

    });

  }


  function firstFilterInput() {

    const form = nativeForm();

    if (!form) return null;

    return form.querySelector(
      'input[name^="filter."]'
    );

  }


  function dispatchFilter(input) {

    if (!input) return;

    input.dispatchEvent(
      new Event(
        'input',
        { bubbles: true }
      )
    );

  }


  function selectedCategoryValue() {

    const selected =
      categoryInputs().find(
        function (input) {
          return input.checked;
        }
      );

    return selected
      ? String(selected.value).trim()
      : '';

  }


  function hasAnyActiveNativeFilter() {

    const form = nativeForm();

    if (!form) return false;

    return Array.from(
      form.querySelectorAll(
        'input[name^="filter."]'
      )
    ).some(function (input) {

      const type =
        String(input.type || '')
          .toLowerCase();

      if (
        type === 'checkbox' ||
        type === 'radio'
      ) {
        return input.checked;
      }

      return !!String(
        input.value || ''
      ).trim();

    });

  }


  function syncCategoryButtons() {

    if (!isClearanceMode()) return;

    const selected =
      selectedCategoryValue();

    document.querySelectorAll(
      '[data-daluca-clearance-category-nav], ' +
      '[data-daluca-clearance-category]'
    ).forEach(function (button) {

      const value =
        button.getAttribute(
          button.hasAttribute(
            'data-daluca-clearance-category-nav'
          )
            ? 'data-daluca-clearance-category-nav'
            : 'data-daluca-clearance-category'
        ) || '';

      const active =
        selected === value;

      button.classList.toggle(
        'is-active',
        active
      );

      button.setAttribute(
        'aria-pressed',
        active ? 'true' : 'false'
      );

    });


    document.querySelectorAll(
      '[data-daluca-clearance-all]'
    ).forEach(function (button) {

      const active =
        !selected &&
        !hasAnyActiveNativeFilter();

      button.classList.toggle(
        'is-active',
        active
      );

      button.setAttribute(
        'aria-pressed',
        active ? 'true' : 'false'
      );

    });

  }


  function applyPrimaryCategory(value) {

    const wasActive =
      selectedCategoryValue() ===
      String(value);

    clearAllNativeFilters();

    let trigger = null;

    if (!wasActive) {

      trigger =
        ensureCategoryInput(value);

      if (trigger) {
        trigger.checked = true;
      }

    } else {

      trigger =
        ensureCategoryInput(value);

      if (trigger) {
        trigger.checked = false;
      }

    }

    dispatchFilter(
      trigger || firstFilterInput()
    );

    window.setTimeout(
      syncCategoryButtons,
      100
    );

  }


  function applyDrawerCategory(value) {

    let target =
      ensureCategoryInput(value);

    if (!target) return;

    const wasChecked =
      target.checked;

    categoryInputs().forEach(
      function (input) {
        input.checked = false;
      }
    );

    target =
      ensureCategoryInput(value);

    if (!target) return;

    target.checked =
      !wasChecked;

    dispatchFilter(target);

    window.setTimeout(
      syncCategoryButtons,
      100
    );

  }


  function clearPrimaryCategoryAndFilters() {

    const trigger =
      categoryInputs()[0] ||
      firstFilterInput();

    clearAllNativeFilters();

    dispatchFilter(trigger);

    window.setTimeout(
      syncCategoryButtons,
      100
    );

  }


  function usableNativeCount(inputName) {

    const form = nativeForm();

    if (!form) {
      return {
        count: 0,
        active: false
      };
    }

    const seen = new Set();
    let count = 0;
    let active = false;

    Array.from(
      form.querySelectorAll(
        'input[name="' +
        inputName +
        '"]'
      )
    ).forEach(function (input) {

      const value =
        String(input.value || '');

      if (seen.has(value)) return;
      seen.add(value);

      if (input.checked) {
        active = true;
      }

      if (
        !input.disabled ||
        input.checked
      ) {
        count += 1;
      }

    });

    return {
      count: count,
      active: active
    };

  }


  function syncClearanceStaticSections() {

    if (!isClearanceMode()) return;

    const rules = [
      {
        section:
          '[data-daluca-static-filter-section="material-family"]',
        inputName:
          'filter.p.m.daluca_filter.material_family'
      },
      {
        section:
          '[data-daluca-static-filter-section="material-type"]',
        inputName:
          'filter.p.m.daluca_filter.material_type'
      }
    ];

    rules.forEach(function (rule) {

      const section =
        document.querySelector(
          rule.section
        );

      if (!section) return;

      const state =
        usableNativeCount(
          rule.inputName
        );

      section.hidden =
        state.count === 0 ||
        (
          state.count <= 1 &&
          !state.active
        );

    });

  }


  function syncAll() {

    syncCategoryButtons();
    syncClearanceStaticSections();

  }


  document.addEventListener(
    'click',
    function (event) {

      if (!isClearanceMode()) return;

      const allButton =
        event.target.closest(
          '[data-daluca-clearance-all]'
        );

      if (allButton) {
        event.preventDefault();
        clearPrimaryCategoryAndFilters();
        return;
      }


      const primary =
        event.target.closest(
          '[data-daluca-clearance-category-nav]'
        );

      if (primary) {
        event.preventDefault();
        applyPrimaryCategory(
          primary.getAttribute(
            'data-daluca-clearance-category-nav'
          )
        );
        return;
      }


      const drawerButton =
        event.target.closest(
          '[data-daluca-clearance-category]'
        );

      if (drawerButton) {
        event.preventDefault();
        applyDrawerCategory(
          drawerButton.getAttribute(
            'data-daluca-clearance-category'
          )
        );
      }

    }
  );


  let syncTimer = null;

  function scheduleSync() {

    clearTimeout(syncTimer);

    syncTimer =
      window.setTimeout(
        syncAll,
        160
      );

  }


  const observer =
    new MutationObserver(
      scheduleSync
    );

  if (document.body) {
    observer.observe(
      document.body,
      {
        childList: true,
        subtree: true
      }
    );
  }


  document.addEventListener(
    'input',
    scheduleSync,
    true
  );

  document.addEventListener(
    'change',
    scheduleSync,
    true
  );

  window.addEventListener(
    'popstate',
    scheduleSync
  );

  window.addEventListener(
    'pageshow',
    scheduleSync
  );

  if (
    document.readyState ===
    'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      scheduleSync
    );
  } else {
    scheduleSync();
  }

})();

/* =========================================================
   DALUCA MATERIAL FAMILY BRIDGE
========================================================= */

(function () {

  const MATERIAL_PARAM =
    'filter.p.m.daluca_filter.material_family';


  function materialInputs() {
    return Array.from(
      document.querySelectorAll(
        'input[name="' + MATERIAL_PARAM + '"]'
      )
    );
  }


  function findMaterialInput(value) {
    return materialInputs().find(function (input) {
      return String(input.value).trim() === value;
    }) || null;
  }


  function syncMaterialButtons() {

    document.querySelectorAll(
      '[data-daluca-material-value]'
    ).forEach(function (button) {

      const input =
        findMaterialInput(
          button.dataset.dalucaMaterialValue
        );

      const active =
        !!input && input.checked;

      const unavailable =
        !input || input.disabled;

      button.classList.toggle(
        'is-active',
        active
      );

      button.disabled = unavailable;

      button.setAttribute(
        'aria-pressed',
        String(active)
      );
    });
  }


  function clearOtherMaterials(exceptInput) {

    materialInputs().forEach(function (input) {

      if (
        input !== exceptInput &&
        input.checked
      ) {
        input.checked = false;
      }
    });
  }


  document.addEventListener(
    'click',
    function (event) {

      const button =
        event.target.closest(
          '[data-daluca-material-value]'
        );

      if (!button) return;

      event.preventDefault();

      const input =
        findMaterialInput(
          button.dataset.dalucaMaterialValue
        );

      if (!input || input.disabled) return;


      const wasChecked = input.checked;

      clearOtherMaterials(input);

      input.checked = !wasChecked;

      input.dispatchEvent(
        new Event(
          'input',
          { bubbles: true }
        )
      );
    }
  );


  const observer =
    new MutationObserver(function () {
      syncMaterialButtons();
    });


  observer.observe(
    document.documentElement,
    {
      childList: true,
      subtree: true
    }
  );


  window.addEventListener(
    'popstate',
    syncMaterialButtons
  );


  syncMaterialButtons();

})();

/* =========================================================
   DALUCA MATERIAL TYPE BRIDGE
========================================================= */

(function () {

  const MATERIAL_TYPE_PARAM =
    'filter.p.m.daluca_filter.material_type';


  function materialTypeInputs() {
    return Array.from(
      document.querySelectorAll(
        'input[name="' + MATERIAL_TYPE_PARAM + '"]'
      )
    );
  }


  function findMaterialTypeInput(value) {
    return materialTypeInputs().find(function (input) {
      return String(input.value).trim() === value;
    }) || null;
  }


  function syncMaterialTypeButtons() {

    document.querySelectorAll(
      '[data-daluca-material-type-value]'
    ).forEach(function (button) {

      const input =
        findMaterialTypeInput(
          button.dataset.dalucaMaterialTypeValue
        );

      const active =
        !!input && input.checked;

      const unavailable =
        !input || input.disabled;

      button.classList.toggle(
        'is-active',
        active
      );

      button.disabled = unavailable;

      button.setAttribute(
        'aria-pressed',
        String(active)
      );
    });
  }


  function clearOtherMaterialTypes(exceptInput) {

    materialTypeInputs().forEach(function (input) {

      if (
        input !== exceptInput &&
        input.checked
      ) {
        input.checked = false;
      }
    });
  }


  document.addEventListener(
    'click',
    function (event) {

      const button =
        event.target.closest(
          '[data-daluca-material-type-value]'
        );

      if (!button) return;

      event.preventDefault();

      const input =
        findMaterialTypeInput(
          button.dataset.dalucaMaterialTypeValue
        );

      if (!input || input.disabled) return;

      const wasChecked = input.checked;

      clearOtherMaterialTypes(input);

      input.checked = !wasChecked;

      input.dispatchEvent(
        new Event(
          'input',
          { bubbles: true }
        )
      );
    }
  );


  const observer =
    new MutationObserver(function () {
      syncMaterialTypeButtons();
    });


  observer.observe(
    document.documentElement,
    {
      childList: true,
      subtree: true
    }
  );


  window.addEventListener(
    'popstate',
    syncMaterialTypeButtons
  );


  syncMaterialTypeButtons();

})();

/* =========================================================
   DALUCA AVAILABILITY FILTER BRIDGE
========================================================= */

(function () {

  const AVAILABILITY_PARAM =
    'filter.v.availability';


  function availabilityInputs() {
    return Array.from(
      document.querySelectorAll(
        'input[name="' + AVAILABILITY_PARAM + '"]'
      )
    );
  }


  function findAvailabilityInput(value) {
    return availabilityInputs().find(function (input) {
      return String(input.value).trim() === value;
    }) || null;
  }


  function syncAvailabilityButton() {

    document.querySelectorAll(
      '[data-daluca-availability-value]'
    ).forEach(function (button) {

      const input =
        findAvailabilityInput(
          button.dataset.dalucaAvailabilityValue
        );

      const active =
        !!input && input.checked;

      const unavailable =
        !input || input.disabled;

      button.classList.toggle(
        'is-active',
        active
      );

      button.disabled = unavailable;

      button.setAttribute(
        'aria-pressed',
        String(active)
      );
    });
  }


  document.addEventListener(
    'click',
    function (event) {

      const button =
        event.target.closest(
          '[data-daluca-availability-value]'
        );

      if (!button) return;

      event.preventDefault();

      const input =
        findAvailabilityInput(
          button.dataset.dalucaAvailabilityValue
        );

      if (!input || input.disabled) return;

      input.checked = !input.checked;

      input.dispatchEvent(
        new Event(
          'input',
          { bubbles: true }
        )
      );
    }
  );


  const observer =
    new MutationObserver(function () {
      syncAvailabilityButton();
    });


  observer.observe(
    document.documentElement,
    {
      childList: true,
      subtree: true
    }
  );


  window.addEventListener(
    'popstate',
    syncAvailabilityButton
  );


  syncAvailabilityButton();

})();

/* =========================================================
   DALUCA PRICE FILTER BRIDGE
========================================================= */

(function () {

  const PRICE_MIN_PARAM =
    'filter.v.price.gte';

  const PRICE_MAX_PARAM =
    'filter.v.price.lte';


  function nativePriceMin() {
    return document.querySelector(
      'input[name="' + PRICE_MIN_PARAM + '"]'
    );
  }


  function nativePriceMax() {
    return document.querySelector(
      'input[name="' + PRICE_MAX_PARAM + '"]'
    );
  }


  function customPriceMin() {
    return document.querySelector(
      '[data-daluca-price-min]'
    );
  }


  function customPriceMax() {
    return document.querySelector(
      '[data-daluca-price-max]'
    );
  }


  function clearButton() {
    return document.querySelector(
      '[data-daluca-price-clear]'
    );
  }


  function cleanPrice(value) {

    value = String(value || '')
      .replace(/[$,]/g, '')
      .trim();

    if (value === '') return '';

    const number = Number(value);

    if (
      !Number.isFinite(number) ||
      number < 0
    ) {
      return '';
    }

    return String(number);
  }


  function cleanEmptyPriceParams() {

    const url =
      new URL(window.location.href);

    let changed = false;


    if (
      url.searchParams.has(PRICE_MIN_PARAM) &&
      url.searchParams.get(PRICE_MIN_PARAM) === ''
    ) {
      url.searchParams.delete(
        PRICE_MIN_PARAM
      );

      changed = true;
    }


    if (
      url.searchParams.has(PRICE_MAX_PARAM) &&
      url.searchParams.get(PRICE_MAX_PARAM) === ''
    ) {
      url.searchParams.delete(
        PRICE_MAX_PARAM
      );

      changed = true;
    }


    if (changed) {

      window.history.replaceState(
        {},
        '',
        url.pathname +
        (url.searchParams.toString()
          ? '?' + url.searchParams.toString()
          : '') +
        url.hash
      );
    }
  }


  function syncDefaultPricePillVisibility() {

    const url = new URL(window.location.href);
    const minRaw = String(url.searchParams.get(PRICE_MIN_PARAM) || '').trim();
    const maxRaw = String(url.searchParams.get(PRICE_MAX_PARAM) || '').trim();

    const slider = document.querySelector('.price_slider[data-max]');

    const floor = slider
      ? Number(String(slider.getAttribute('data-min') || '0').replace(/[$,]/g, ''))
      : 0;

    const ceiling = slider
      ? Number(String(slider.getAttribute('data-max') || '').replace(/[$,]/g, ''))
      : NaN;

    const minValue = minRaw === '' ? NaN : Number(minRaw);
    const maxValue = maxRaw === '' ? NaN : Number(maxRaw);

    const minIsDefault =
      minRaw === '' ||
      !Number.isFinite(minValue) ||
      minValue === floor;

    const maxIsDefault =
      maxRaw === '' ||
      !Number.isFinite(maxValue) ||
      (Number.isFinite(ceiling) && maxValue === ceiling);

    const realPriceApplied = !(minIsDefault && maxIsDefault);

    document.querySelectorAll(
      'facet-remove.active-facets .active-facets__button'
    ).forEach(function (node) {
      const text = String(window.DaLucaI18n.sourceText(node) || '')
        .replace(/\s+/g, ' ')
        .trim();

      /*
        IMPORTANT:
        Habitat's removal URL for EVERY active pill preserves the other
        active filter params. So checking an href for price params causes
        Style/Material/Width pills to be mistaken for Price whenever a
        price state exists. Identify the Price pill only by its own visible
        range label, e.g. "$0.00-$220.00" or "$100-$150".
      */
      const looksLikePrice =
        /^\$\s*[0-9][0-9,]*(?:\.[0-9]{1,2})?\s*[-–—]\s*\$\s*[0-9][0-9,]*(?:\.[0-9]{1,2})?$/.test(text);

      if (!looksLikePrice) return;

      if (!realPriceApplied) {
        node.setAttribute('data-daluca-default-price-pill', '');
        node.hidden = true;
        node.style.setProperty('display', 'none', 'important');
        return;
      }

      if (node.hasAttribute('data-daluca-default-price-pill')) {
        node.removeAttribute('data-daluca-default-price-pill');
        node.hidden = false;
        node.style.removeProperty('display');
      }
    });
  }


  function syncPriceFields() {

    const nativeMin = nativePriceMin();
    const nativeMax = nativePriceMax();

    const customMin = customPriceMin();
    const customMax = customPriceMax();

    if (!customMin || !customMax) return;


    if (
      document.activeElement !== customMin
    ) {
      customMin.value =
        nativeMin && nativeMin.value
          ? nativeMin.value
          : '';
    }


    if (
      document.activeElement !== customMax
    ) {
      customMax.value =
        nativeMax && nativeMax.value
          ? nativeMax.value
          : '';
    }


    const clear = clearButton();

    if (clear) {

      const hasPrice =
        !!(
          (nativeMin && nativeMin.value) ||
          (nativeMax && nativeMax.value)
        );

      clear.hidden = !hasPrice;
    }


    cleanEmptyPriceParams();
    syncDefaultPricePillVisibility();
  }


  function applyPrice() {

    const nativeMin = nativePriceMin();
    const nativeMax = nativePriceMax();

    const customMin = customPriceMin();
    const customMax = customPriceMax();

    if (
      !nativeMin ||
      !nativeMax ||
      !customMin ||
      !customMax
    ) {
      return;
    }


    const min =
      cleanPrice(customMin.value);

    const max =
      cleanPrice(customMax.value);


    if (
      min !== '' &&
      max !== '' &&
      Number(min) > Number(max)
    ) {
      customMax.focus();
      return;
    }


    nativeMin.value = min;
    nativeMax.value = max;


    nativeMax.dispatchEvent(
      new Event(
        'input',
        { bubbles: true }
      )
    );

    /*
      Price is the only DaLuca filter that waits for an
      explicit Apply action. Once applied, close the filter
      panel so the shopper immediately returns to the updated
      products. This works for both the desktop under-bar panel
      and the mobile drawer without changing any filter state.
    */
    window.setTimeout(function () {
      const drawer = document.querySelector(
        '[data-daluca-filter-drawer]'
      );

      const overlay = document.querySelector(
        '[data-daluca-filter-overlay]'
      );

      const openButton = document.querySelector(
        '[data-daluca-open-filters]'
      );

      if (drawer) {
        drawer.hidden = true;
        drawer.setAttribute(
          'aria-hidden',
          'true'
        );
      }

      if (overlay) {
        overlay.hidden = true;
      }

      if (openButton) {
        openButton.setAttribute(
          'aria-expanded',
          'false'
        );
      }

      document.documentElement.classList.remove(
        'daluca-filters-open'
      );
    }, 0);
  }


  function clearPrice() {

    const nativeMin = nativePriceMin();
    const nativeMax = nativePriceMax();

    const customMin = customPriceMin();
    const customMax = customPriceMax();

    if (!nativeMin || !nativeMax) return;


    if (customMin) {
      customMin.value = '';
    }

    if (customMax) {
      customMax.value = '';
    }


    nativeMin.value = '';
    nativeMax.value = '';


    nativeMax.dispatchEvent(
      new Event(
        'input',
        { bubbles: true }
      )
    );
  }


  document.addEventListener(
    'click',
    function (event) {

      const applyButton =
        event.target.closest(
          '[data-daluca-price-apply]'
        );

      if (applyButton) {
        event.preventDefault();
        applyPrice();
        return;
      }


      const clear =
        event.target.closest(
          '[data-daluca-price-clear]'
        );

      if (clear) {
        event.preventDefault();
        clearPrice();
      }
    }
  );


  document.addEventListener(
    'keydown',
    function (event) {

      if (
        event.key !== 'Enter'
      ) {
        return;
      }


      if (
        event.target.matches(
          '[data-daluca-price-min], [data-daluca-price-max]'
        )
      ) {
        event.preventDefault();
        applyPrice();
      }
    }
  );


  const observer =
    new MutationObserver(function () {
      syncDefaultPricePillVisibility();
      syncPriceFields();
    });


  observer.observe(
    document.documentElement,
    {
      childList: true,
      subtree: true
    }
  );


  window.addEventListener(
    'popstate',
    syncPriceFields
  );


  syncDefaultPricePillVisibility();
  syncPriceFields();

})();

/* =========================================================
   DALUCA — HIDE UNAVAILABLE FILTER OPTIONS
   Hides custom drawer choices that have no valid Shopify
   facet option in the current collection/filter state.
   ========================================================= */

(function () {

  if (window.DaLucaHideUnavailableFilterOptionsInitialized) {
    return;
  }

  window.DaLucaHideUnavailableFilterOptionsInitialized = true;


  const FILTER_RULES = [

    {
      buttonSelector:
        '[data-daluca-material-value]',

      inputName:
        'filter.p.m.daluca_filter.material_family',

      datasetKey:
        'dalucaMaterialValue'
    },

    {
      buttonSelector:
        '[data-daluca-material-type-value]',

      inputName:
        'filter.p.m.daluca_filter.material_type',

      datasetKey:
        'dalucaMaterialTypeValue'
    },

    {
      buttonSelector:
        '[data-daluca-availability-value]',

      inputName:
        'filter.v.availability',

      datasetKey:
        'dalucaAvailabilityValue'
    }

  ];


  function getNativeInput(
    inputName,
    value
  ) {

    const inputs =
      Array.from(
        document.querySelectorAll(
          'input[name="' +
          inputName +
          '"]'
        )
      );

    return inputs.find(
      function (input) {

        return (
          String(input.value).trim() ===
          String(value).trim()
        );

      }
    ) || null;

  }


  function syncFilterRule(rule) {

    document.querySelectorAll(
      rule.buttonSelector
    ).forEach(
      function (button) {

        const value =
          button.dataset[
            rule.datasetKey
          ];

        const input =
          getNativeInput(
            rule.inputName,
            value
          );

        const active =
          !!input &&
          input.checked;

        const unavailable =
          !input ||
          input.disabled;

        /*
          If the option cannot return products,
          hide it completely.

          Keep a selected option visible so the
          shopper can still see/remove it.
        */
        const shouldHide =
          unavailable &&
          !active;


        button.hidden =
          shouldHide;

        button.style.display =
          shouldHide
            ? 'none'
            : '';

        button.setAttribute(
          'aria-hidden',
          shouldHide
            ? 'true'
            : 'false'
        );

      }
    );

  }


  function syncUnavailableOptions() {

    FILTER_RULES.forEach(
      syncFilterRule
    );

  }


  let syncTimer = null;


  function scheduleSync() {

    clearTimeout(
      syncTimer
    );

    syncTimer =
      setTimeout(
        syncUnavailableOptions,
        100
      );

  }


  /*
    Habitat replaces the filter markup after
    AJAX filtering, so rescan whenever that
    markup changes.
  */
  const observer =
    new MutationObserver(
      function () {

        scheduleSync();

      }
    );


  if (document.body) {

    observer.observe(
      document.body,
      {
        childList: true,
        subtree: true
      }
    );

  }


  /*
    Also resync after filter interaction.
  */
  document.addEventListener(
    'input',
    scheduleSync,
    true
  );


  document.addEventListener(
    'change',
    scheduleSync,
    true
  );


  /*
    Browser Back / Forward.
  */
  window.addEventListener(
    'popstate',
    function () {

      setTimeout(
        syncUnavailableOptions,
        150
      );

    }
  );


  /*
    Initial page load / restored browser page.
  */
  window.addEventListener(
    'pageshow',
    syncUnavailableOptions
  );


  document.addEventListener(
    'DOMContentLoaded',
    syncUnavailableOptions
  );


  syncUnavailableOptions();

})();

/* =========================================================
   DALUCA — ODD WIDTH / MADE-TO-ORDER RESULTS GUARD

   When the selected watch requires an exact width that this
   ready-made collection does not stock, hide incompatible
   ready-made products and native collection controls.

   When a normal stocked width is selected again, everything
   automatically returns.
   ========================================================= */

(function () {

  if (
    window.DaLucaOddWidthResultsGuardInitialized
  ) {
    return;
  }

  window.DaLucaOddWidthResultsGuardInitialized =
    true;


  const HIDDEN_ATTR =
    'data-daluca-custom-fit-hidden';


  /* =========================================================
     BASIC HELPERS
  ========================================================= */

  function getEngine() {

    return document.querySelector(
      '[data-daluca-filter-engine]'
    );

  }


  function customFitModeIsActive() {

    const engine =
      getEngine();

    if (!engine) {
      return false;
    }


    const notice =
      engine.querySelector(
        '[data-daluca-custom-fit]'
      );


    /*
      The existing DaLuca filter code already decides
      whether the selected watch needs a custom width.

      If its Exact Fit Required notice is visible,
      we know this ready-made collection should NOT
      show products.
    */
    return (
      !!notice &&
      !notice.hidden
    );

  }


  function hideElement(element) {

    if (!element) {
      return;
    }


    element.setAttribute(
      HIDDEN_ATTR,
      ''
    );

  }


  function restoreAll() {

    document.querySelectorAll(
      '[' + HIDDEN_ATTR + ']'
    ).forEach(
      function (element) {

        element.removeAttribute(
          HIDDEN_ATTR
        );

      }
    );

  }


  /* =========================================================
     HIDE STYLE
  ========================================================= */

  function installStyle() {

    if (
      document.getElementById(
        'daluca-custom-fit-results-guard-style'
      )
    ) {
      return;
    }


    const style =
      document.createElement(
        'style'
      );


    style.id =
      'daluca-custom-fit-results-guard-style';


    window.DaLucaI18n.setText(style, `
      [${HIDDEN_ATTR}] {
        display: none !important;
      }
    `);


    document.head.appendChild(
      style
    );

  }


  /* =========================================================
     PRODUCT HELPERS
  ========================================================= */

  function uniqueProductHrefCount(
    element
  ) {

    if (!element) {
      return 0;
    }


    const hrefs =
      new Set();


    element.querySelectorAll(
      'a[href*="/products/"]'
    ).forEach(
      function (link) {

        const href =
          link.getAttribute(
            'href'
          );


        if (href) {

          hrefs.add(
            href.split('?')[0]
          );

        }

      }
    );


    return hrefs.size;

  }


  /* =========================================================
     FIND MAIN PRODUCT GRID
  ========================================================= */

  function findProductGrid() {

    const engine =
      getEngine();


    const main =
      document.querySelector(
        'main'
      ) ||
      document.body;


    if (!main) {
      return null;
    }


    /*
      Try common Shopify / Habitat product
      grid selectors first.
    */
    const selectors = [

      '#product-grid',

      '#ProductGridContainer ul',

      '#ProductGridContainer .product-grid',

      '.collection__product-grid',

      '.product-grid',

      '[data-product-grid]'

    ];


    for (
      let i = 0;
      i < selectors.length;
      i += 1
    ) {

      const matches =
        Array.from(
          main.querySelectorAll(
            selectors[i]
          )
        );


      const match =
        matches.find(
          function (element) {

            return (

              (
                !engine ||
                !engine.contains(
                  element
                )
              )

              &&

              uniqueProductHrefCount(
                element
              ) >= 2

            );

          }
        );


      if (match) {
        return match;
      }

    }


    /*
      Habitat fallback:

      Find the smallest wrapper containing most
      of the visible collection product links.
    */
    const productLinks =
      Array.from(
        main.querySelectorAll(
          'a[href*="/products/"]'
        )
      ).filter(
        function (link) {

          return (

            !engine ||

            !engine.contains(
              link
            )

          );

        }
      );


    const allHrefs =
      new Set(
        productLinks
          .map(
            function (link) {

              const href =
                link.getAttribute(
                  'href'
                );


              return href
                ? href.split('?')[0]
                : '';

            }
          )
          .filter(Boolean)
      );


    const totalProducts =
      allHrefs.size;


    if (!totalProducts) {
      return null;
    }


    const threshold =
      Math.max(
        2,
        Math.ceil(
          totalProducts * 0.75
        )
      );


    let node =
      productLinks[0]
        ? productLinks[0]
            .parentElement
        : null;


    while (

      node &&

      node !== main &&

      node !== document.body

    ) {

      /*
        Never hide a wrapper that also contains
        the DaLuca Finder itself.
      */
      if (
        engine &&
        node.contains(
          engine
        )
      ) {
        break;
      }


      if (
        uniqueProductHrefCount(
          node
        ) >= threshold
      ) {

        return node;

      }


      node =
        node.parentElement;

    }


    return null;

  }


  /* =========================================================
     FALLBACK — HIDE INDIVIDUAL PRODUCT CARDS
  ========================================================= */

  function hideIndividualProductCards() {

    const engine =
      getEngine();


    const main =
      document.querySelector(
        'main'
      ) ||
      document.body;


    if (!main) {
      return;
    }


    const productLinks =
      Array.from(
        main.querySelectorAll(
          'a[href*="/products/"]'
        )
      ).filter(
        function (link) {

          return (

            !engine ||

            !engine.contains(
              link
            )

          );

        }
      );


    const handled =
      new Set();


    productLinks.forEach(
      function (link) {

        let node =
          link;


        let best =
          null;


        /*
          Walk upward while this wrapper still
          contains only one unique product.

          The largest one-product wrapper is
          normally the complete product card.
        */
        while (

          node &&

          node.parentElement &&

          node !== main

        ) {

          const parent =
            node.parentElement;


          if (
            engine &&
            parent.contains(
              engine
            )
          ) {
            break;
          }


          const productCount =
            uniqueProductHrefCount(
              parent
            );


          if (
            productCount === 1
          ) {

            best =
              parent;

            node =
              parent;

            continue;

          }


          break;

        }


        const card =
          best ||
          link.closest(
            'li, article'
          );


        if (
          card &&
          !handled.has(
            card
          )
        ) {

          handled.add(
            card
          );

          hideElement(
            card
          );

        }

      }
    );

  }


  /* =========================================================
     HIDE NATIVE FILTER / SORT / COUNT CONTROLS
  ========================================================= */

  function hideNativeFacetControls() {

    const forms = [

      document.getElementById(
        'FacetFiltersForm'
      ),

      document.getElementById(
        'FacetFiltersFormMobile'
      ),

      document.getElementById(
        'FacetFiltersPillsForm'
      )

    ].filter(Boolean);


    forms.forEach(
      function (form) {

        hideElement(

          form.closest(
            'facet-filters-form'
          )

          ||

          form

        );

      }
    );


    /*
      Hide 612 products / result counts.
    */
    document.querySelectorAll(

      '.product-count, ' +

      '#ProductCount, ' +

      '#ProductCountDesktop, ' +

      '[id^="ProductCount"]'

    ).forEach(
      function (element) {

        hideElement(

          element.closest(
            '.product-count'
          )

          ||

          element

        );

      }
    );


    /*
      Hide any separate Sort By control.
    */
    document.querySelectorAll(
      'select[name="sort_by"]'
    ).forEach(
      function (select) {

        hideElement(

          select.closest(

            '.facet-filters, ' +

            '.sorting, ' +

            'facet-filters-form'

          )

          ||

          select

        );

      }
    );

  }


  /* =========================================================
     HIDE LOAD MORE
  ========================================================= */

  function hideLoadMoreControls() {

    document.querySelectorAll(
      'button, a'
    ).forEach(
      function (element) {

        const text =
          String(
            window.DaLucaI18n.sourceText(element) ||
            ''
          )
            .replace(
              /\s+/g,
              ' '
            )
            .trim()
            .toLowerCase();


        if (

          text === 'load more' ||

          text ===
            'show more products'

        ) {

          hideElement(
            element
          );

        }

      }
    );

  }


  /* =========================================================
     HIDE DALUCA FILTER DRAWER BUTTON
     No reason to refine ready-made products when none fit.
  ========================================================= */

  function hideDaLucaReadyMadeControls() {

    document.querySelectorAll(
      '[data-daluca-open-filters]'
    ).forEach(
      hideElement
    );

  }


  /* =========================================================
     MASTER SYNC
  ========================================================= */

  function syncCustomFitResultsGuard() {

    installStyle();


    /*
      If the selected watch CAN use a ready-made
      width, restore everything normally.
    */
    if (
      !customFitModeIsActive()
    ) {

      restoreAll();

      return;

    }


    /*
      Exact custom width required.

      Hide every part of the page that could
      imply the ready-made straps below fit
      the selected watch.
    */
    hideNativeFacetControls();


    hideDaLucaReadyMadeControls();


    const productGrid =
      findProductGrid();


    if (productGrid) {

      hideElement(
        productGrid
      );

    } else {

      /*
        Safety fallback if Habitat changes the
        grid wrapper markup.
      */
      hideIndividualProductCards();

    }


    hideLoadMoreControls();

  }


  /* =========================================================
     AJAX / HABITAT RESYNC
  ========================================================= */

  let syncTimer =
    null;


  function scheduleSync() {

    clearTimeout(
      syncTimer
    );


    syncTimer =
      setTimeout(
        syncCustomFitResultsGuard,
        80
      );

  }


  const observer =
    new MutationObserver(
      scheduleSync
    );


  function start() {

    syncCustomFitResultsGuard();


    if (
      document.body
    ) {

      observer.observe(
        document.body,
        {
          childList: true,
          subtree: true
        }
      );

    }

  }


  /*
    Watch selection / filter interactions.
  */
  document.addEventListener(
    'click',
    scheduleSync,
    true
  );


  document.addEventListener(
    'input',
    scheduleSync,
    true
  );


  /*
    Browser Back / Forward.
  */
  window.addEventListener(
    'popstate',
    scheduleSync
  );


  /*
    Browser restores cached page.
  */
  window.addEventListener(
    'pageshow',
    scheduleSync
  );


  /*
    Initial load.
  */
  if (
    document.readyState ===
    'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      start,
      {
        once: true
      }
    );

  } else {

    start();

  }

})();

/* =========================================================
   DALUCA SORT BY BRIDGE
   Desktop: 8 compact sort buttons.
   Mobile/tablet: existing compact select remains available.
   Both continue to use Shopify / Habitat native sorting.
========================================================= */

(function () {

  if (window.DaLucaSortBridgeInitialized) return;
  window.DaLucaSortBridgeInitialized = true;


  function customSortSelect() {
    return document.querySelector(
      '[data-daluca-sort]'
    );
  }


  function customSortButtons() {
    return Array.from(
      document.querySelectorAll(
        '[data-daluca-sort-option]'
      )
    );
  }


  function nativeSortSelects() {
    return Array.from(
      document.querySelectorAll(
        'select[name="sort_by"]'
      )
    ).filter(function (select) {
      return !select.matches(
        '[data-daluca-sort]'
      );
    });
  }


  function primaryNativeSortSelect() {

    const byId =
      document.getElementById(
        'SortBy'
      );

    if (
      byId &&
      byId.matches(
        'select[name="sort_by"]'
      )
    ) {
      return byId;
    }

    return (
      nativeSortSelects()[0] ||
      null
    );
  }


  function currentSortValue() {

    const native =
      primaryNativeSortSelect();

    let value = '';

    if (native) {
      value = String(
        native.value || ''
      );
    }

    if (!value) {
      const url = new URL(
        window.location.href
      );

      value =
        url.searchParams.get(
          'sort_by'
        ) || '';
    }

    return value || 'manual';
  }


  function syncSortControl() {

    const value =
      currentSortValue();

    const custom =
      customSortSelect();

    if (
      custom &&
      Array.from(
        custom.options
      ).some(function (option) {
        return option.value === value;
      })
    ) {
      custom.value = value;
    }

    customSortButtons()
      .forEach(function (button) {

        const active =
          button.getAttribute(
            'data-daluca-sort-option'
          ) === value;

        button.classList.toggle(
          'is-active',
          active
        );

        button.setAttribute(
          'aria-pressed',
          active ? 'true' : 'false'
        );

      });

  }


  function applySort(value) {

    const native =
      primaryNativeSortSelect();

    if (!native) return;

    const valid =
      Array.from(
        native.options
      ).some(function (option) {
        return option.value === value;
      });

    if (!valid) return;


    /*
      Keep any duplicate Habitat sort
      controls synchronized.
    */
    nativeSortSelects()
      .forEach(function (select) {

        const hasValue =
          Array.from(
            select.options
          ).some(function (option) {
            return option.value === value;
          });

        if (hasValue) {
          select.value = value;
        }

      });


    /*
      Update the compact controls immediately so the
      click feels responsive while Habitat refreshes.
    */
    const custom =
      customSortSelect();

    if (custom) {
      custom.value = value;
    }

    customSortButtons()
      .forEach(function (button) {

        const active =
          button.getAttribute(
            'data-daluca-sort-option'
          ) === value;

        button.classList.toggle(
          'is-active',
          active
        );

        button.setAttribute(
          'aria-pressed',
          active ? 'true' : 'false'
        );

      });


    /*
      Habitat already knows how to perform
      the AJAX sort. Trigger its existing
      native input event rather than
      rebuilding sorting ourselves.
    */
    native.dispatchEvent(
      new Event(
        'input',
        { bubbles: true }
      )
    );

  }


  document.addEventListener(
    'change',
    function (event) {

      const select =
        event.target.closest(
          '[data-daluca-sort]'
        );

      if (!select) return;

      applySort(
        select.value
      );

    }
  );


  document.addEventListener(
    'click',
    function (event) {

      const button =
        event.target.closest(
          '[data-daluca-sort-option]'
        );

      if (!button) return;

      event.preventDefault();

      applySort(
        button.getAttribute(
          'data-daluca-sort-option'
        ) || ''
      );

    }
  );


  /*
    Habitat replaces native filter/sort
    markup after AJAX updates, so keep the
    DaLuca controls synchronized.
  */
  let syncTimer = null;

  const observer =
    new MutationObserver(
      function () {

        clearTimeout(
          syncTimer
        );

        syncTimer =
          setTimeout(
            syncSortControl,
            100
          );

      }
    );


  if (document.body) {

    observer.observe(
      document.body,
      {
        childList: true,
        subtree: true
      }
    );

  }


  window.addEventListener(
    'popstate',
    syncSortControl
  );


  if (
    document.readyState ===
    'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      syncSortControl
    );

  } else {

    syncSortControl();

  }

})();

/* =========================================================
   DALUCA UNIFIED FILTER UI
   Hide Habitat's visible filter interface while keeping
   Shopify's native forms active as the filtering backend.
========================================================= */

(function () {

  if (window.DaLucaUnifiedFilterUIInitialized) return;
  window.DaLucaUnifiedFilterUIInitialized = true;

  const HIDDEN_ATTR =
    'data-daluca-native-filter-ui-hidden';


  function installStyle() {

    if (
      document.getElementById(
        'daluca-unified-filter-ui-style'
      )
    ) {
      return;
    }

    const style =
      document.createElement('style');

    style.id =
      'daluca-unified-filter-ui-style';

    window.DaLucaI18n.setText(style, `
      [${HIDDEN_ATTR}] {
        display: none !important;
      }
    `);

    document.head.appendChild(style);

  }


  function hideNativeUI() {

    /*
      Only do this on a page where the
      DaLuca filter actually exists.
    */
    if (
      !document.querySelector(
        '[data-daluca-filter-engine]'
      )
    ) {
      return;
    }


    [
      'FacetFiltersForm',
      'FacetFiltersFormMobile',
      'FacetFiltersPillsForm'
    ].forEach(function (id) {

      const form =
        document.getElementById(id);

      if (!form) return;


      /*
        Hide the visual wrapper, NOT remove it.
        Shopify can still read the inputs and
        Habitat can still process AJAX filtering.
      */
      const wrapper =
        form.closest(
          'facet-filters-form, ' +
          'facetfiltersformmobile'
        ) ||
        form;

      wrapper.setAttribute(
        HIDDEN_ATTR,
        ''
      );

    });

  }

  function sync() {

    installStyle();
    hideNativeUI();

  }


  let timer = null;

  const observer =
    new MutationObserver(function () {

      clearTimeout(timer);

      timer =
        setTimeout(
          sync,
          100
        );

    });


  if (document.body) {

    observer.observe(
      document.body,
      {
        childList: true,
        subtree: true
      }
    );

  }


  if (
    document.readyState === 'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      sync
    );

  } else {

    sync();

  }

})();

/* =========================================================
   DALUCA DYNAMIC COLLECTION FILTERS
   Adds useful Shopify facets to the DaLuca drawer.

   Automatically:
   - Uses Shopify's native facet inputs as the backend.
   - Hides filters with no meaningful choice.
   - Keeps selected options visible.
   - Rebuilds after Habitat AJAX updates.
   - Prefers DaLuca Lug Width over generic Width.
   - Excludes duplicate Style / Material / Material Type /
     Availability / Price controls already handled elsewhere.
========================================================= */

(function () {

  if (window.DaLucaDynamicCollectionFiltersInitialized) return;
  window.DaLucaDynamicCollectionFiltersInitialized = true;


  const CONFIGS = [

    {
      key: 'lug-width',
      title: 'Lug Width',
      slot: 'width'
    },

    {
      key: 'color',
      title: 'Color',
      slot: 'extras'
    },

    {
      key: 'construction',
      title: 'Construction',
      slot: 'extras'
    },

    {
      key: 'order-type',
      title: 'Order Type',
      slot: 'extras'
    },

    {
      key: 'special',
      title: 'Special',
      slot: 'extras'
    }

  ];


  /*
    Keep the Lug Width choices visually stable while shoppers refine.
    Shopify can remove currently-impossible facet values after an AJAX
    update; we remember the widths that were available for this collection
    and render missing ones as disabled instead of making the row jump.
  */
  const rememberedLugWidths = new Map();


  function nativeForm() {

    return document.getElementById(
      'FacetFiltersForm'
    );

  }


  function allNativeInputs() {

    const form = nativeForm();

    if (!form) return [];

    return Array.from(
      form.querySelectorAll(
        'input[type="checkbox"], input[type="radio"]'
      )
    ).filter(function (input) {

      return (
        input.name &&
        input.value
      );

    });

  }


  function uniqueInputs(inputs) {

    const seen = new Set();

    return inputs.filter(function (input) {

      const key =
        String(input.name) +
        '||' +
        String(input.value);

      if (seen.has(key)) {
        return false;
      }

      seen.add(key);

      return true;

    });

  }


  function nameText(input) {

    return String(
      input.name || ''
    ).toLowerCase();

  }


  function clearanceModeActive() {

    return !!document.querySelector(
      '[data-daluca-clearance-mode]'
    );

  }


  function getInputsForConfig(config) {

    const inputs =
      allNativeInputs();


    /*
      LUG WIDTH

      Prefer the dedicated DaLuca lug-width metafield.
      Only fall back to another Width filter when the
      dedicated one is not present.
    */
    if (config.key === 'lug-width') {

      let matches =
        inputs.filter(function (input) {

          const name =
            nameText(input);

          return (
            name.indexOf(
              'daluca_filter.widths'
            ) !== -1 ||

            name.indexOf(
              'lug_width'
            ) !== -1 ||

            name.indexOf(
              'lug-width'
            ) !== -1
          );

        });


      if (!matches.length) {

        matches =
          inputs.filter(function (input) {

            const name =
              nameText(input);

            return (
              name ===
                'filter.p.m.filter.width' ||

              name ===
                'filter.v.option.width'
            );

          });

      }


      return uniqueInputs(matches);

    }


    /*
      COLOR
    */
    if (config.key === 'color') {

      return uniqueInputs(
        inputs.filter(function (input) {

          const name =
            nameText(input);

          return (
            name.indexOf('color') !== -1 ||
            name.indexOf('colour') !== -1
          );

        })
      );

    }


    /*
      CONSTRUCTION
    */
    if (config.key === 'construction') {

      return uniqueInputs(
        inputs.filter(function (input) {

          return (
            nameText(input)
              .indexOf('construction') !== -1
          );

        })
      );

    }


    /*
      ORDER TYPE
      Ready Made / Made to Order / Custom, etc.
    */
    if (config.key === 'order-type') {

      return uniqueInputs(
        inputs.filter(function (input) {

          const name =
            nameText(input);

          return (
            name.indexOf('order_type') !== -1 ||
            name.indexOf('order-type') !== -1 ||
            name.indexOf('ordertype') !== -1
          );

        })
      );

    }


    /*
      SPECIAL

      Supports either a dedicated Special facet or
      the DaLuca flags metafield.
    */
    if (config.key === 'special') {

      return uniqueInputs(
        inputs.filter(function (input) {

          const name =
            nameText(input);

          return (
            name.indexOf('special') !== -1 ||
            name.indexOf(
              'daluca_filter.flags'
            ) !== -1
          );

        })
      );

    }


    return [];

  }
function getColorSwatch(value) {

  const color =
    String(value || '')
      .trim()
      .toLowerCase();

  const colors = {

    black: '#111111',
    brown: '#6b4226',
    natural: '#c9a777',
    grey: '#8a8a8a',
    gray: '#8a8a8a',
    green: '#365c46',
    blue: '#345a7c',
    navy: '#24364b',
    red: '#8b2f2f',
    burgundy: '#6d2638',
    maroon: '#6b2737',
    orange: '#c56a2d',
    yellow: '#d3ad42',
    tan: '#b98c5b',
    beige: '#d7c3a4',
    cream: '#eee4cf',
    white: '#f7f7f7',
    purple: '#6b5278',
    pink: '#c88a9d',
    gold: '#b39454',
    silver: '#b7b9ba',
    olive: '#6a7045',
    khaki: '#a39168',
    cognac: '#9a562f'

  };


  /*
    If Shopify ever supplies an actual
    hex value, use it directly.
  */
  if (
    /^#[0-9a-f]{3,8}$/i.test(color)
  ) {
    return color;
  }


  return (
    colors[color] ||
    '#d8d8d8'
  );

}

  function displayValue(
    config,
    input
  ) {

    let value =
      String(
        input.value || ''
      ).trim();


    if(input.dalucaAppleWidth){const root=document.querySelector('[data-daluca-filter-engine]');return root?.dataset[input.value==='22mm'?'dalucaAppleSmall':'dalucaAppleLarge']||input.value;}

    /*
      Width values should read naturally:
      18 -> 18mm
      20 -> 20mm
    */
    if (
      config.key === 'lug-width' &&
      /^\d+(?:\.\d+)?$/.test(value)
    ) {

      value += 'mm';

    }


    return value;

  }


  function shouldExcludeValue(
    config,
    input
  ) {

    const value =
      String(
        input.value || ''
      ).trim();


    /*
      Apple adapter products should never become
      a customer-facing recommendation/filter path.
    */
    if (
      config.key === 'special' &&
      /apple\s*adapter/i.test(value)
    ) {

      return true;

    }


    /*
      On the Clearance collection, every product is already
      clearance. Do not waste drawer space with a redundant
      "Clearance" Special button.
    */
    if (
      clearanceModeActive() &&
      config.key === 'special' &&
      /^clearance$/i.test(value)
    ) {

      return true;

    }


    return false;

  }


  function rememberLugWidthInputs(inputs) {

    inputs.forEach(function (input) {

      const key =
        String(input.name) +
        '||' +
        String(input.value);

      rememberedLugWidths.set(
        key,
        {
          name: String(input.name),
          value: String(input.value)
        }
      );

    });

  }


  function stableLugWidthInputs(currentInputs) {
    if (window.DaLucaAppleWidth) return ['22','24'].map(width=>({name:'daluca_apple_width',value:width+'mm',checked:window.DaLucaAppleWidth.selected()===width,disabled:false,dalucaAppleWidth:true}));

    rememberLugWidthInputs(
      currentInputs
    );


    const freshByKey =
      new Map();


    currentInputs.forEach(function (input) {

      freshByKey.set(
        String(input.name) +
          '||' +
          String(input.value),
        input
      );

    });


    /*
      DALUCA V29 — UNIVERSAL 14–28MM WIDTH SYSTEM

      Every customer-facing watch-strap Lug Width filter uses the same
      complete 14mm through 28mm range. This keeps the control predictable
      from collection to collection.

      - If Shopify has a native width input for the current collection,
        that real input remains authoritative.
      - If a width is not available as a native ready-made option, it
        becomes a Custom-route choice instead of disappearing.
      - On the Custom collection, all 14–28mm choices are fit context and
        remain selectable without filtering Custom products out of the grid.
      - Clearance keeps its existing category-first behavior and does not
        receive synthetic watch-width choices.
    */
    if (!clearanceModeActive()) {
      const widthName =
        currentInputs[0]
          ? String(currentInputs[0].name)
          : 'filter.p.m.daluca_filter.widths';

      const customCollectionActive =
        !!(
          window.DaLucaCustomProgramWidth &&
          typeof window.DaLucaCustomProgramWidth.isCustomCollection === 'function' &&
          window.DaLucaCustomProgramWidth.isCustomCollection()
        );

      const values = Array.from(
        { length: 15 },
        function (_, index) {
          return String(14 + index) + 'mm';
        }
      );

      values.forEach(function (value) {
        const key =
          widthName +
          '||' +
          value;

        if (!rememberedLugWidths.has(key)) {
          rememberedLugWidths.set(
            key,
            customCollectionActive
              ? {
                  name: widthName,
                  value: value,
                  dalucaCustomProgramWidth: true
                }
              : {
                  name: widthName,
                  value: value,
                  dalucaCustomRoute: true
                }
          );
        }
      });

      /*
        A native width may already have been remembered before we knew we
        were on the Custom collection. Promote every 14–28mm descriptor to
        Custom-program behavior here. Keep this check local to this module
        so it cannot fail because of another IIFE's private helper scope.
      */
      if (customCollectionActive) {
        rememberedLugWidths.forEach(function (descriptor, key) {
          const numericWidth = Number(
            String(descriptor.value || '')
              .replace(/mm/gi, '')
              .trim()
          );

          if (
            String(key).startsWith(widthName + '||') &&
            Number.isFinite(numericWidth) &&
            numericWidth >= 14 &&
            numericWidth <= 28
          ) {
            descriptor.dalucaCustomProgramWidth = true;
            descriptor.dalucaCustomRoute = false;
          }
        });
      }
    }


    return Array.from(
      rememberedLugWidths.entries()
    )
      .map(function (entry) {

        const key = entry[0];
        const descriptor = entry[1];
        const fresh = freshByKey.get(key);

        if (fresh) {
          if (descriptor.dalucaCustomProgramWidth) {
            fresh.dalucaCustomProgramWidth = true;
            fresh.dalucaCustomRoute = false;
            fresh.disabled = false;
          }

          return fresh;
        }

        /*
          Synthetic disabled choice: it is visible for orientation,
          but cannot be selected until Shopify says it is available
          again under the current filter combination.
        */
        if (descriptor.dalucaCustomProgramWidth) {
          return {
            name: descriptor.name,
            value: descriptor.value,
            checked: false,
            disabled: false,
            dalucaCustomProgramWidth: true
          };
        }

        if (descriptor.dalucaCustomRoute) {
          return {
            name: descriptor.name,
            value: descriptor.value,
            checked: false,
            disabled: false,
            dalucaCustomRoute: true
          };
        }

        return {
          name: descriptor.name,
          value: descriptor.value,
          checked: false,
          disabled: true,
          dalucaUnavailable: true
        };

      })
      .sort(function (a, b) {

        const aNumber =
          parseFloat(String(a.value));

        const bNumber =
          parseFloat(String(b.value));

        if (
          Number.isFinite(aNumber) &&
          Number.isFinite(bNumber) &&
          aNumber !== bNumber
        ) {
          return aNumber - bNumber;
        }

        return String(a.value)
          .localeCompare(
            String(b.value),
            undefined,
            {
              numeric: true,
              sensitivity: 'base'
            }
          );

      });

  }


  function usableInputs(config) {

    const candidates =
      getInputsForConfig(config)
        .filter(function (input) {

          return !shouldExcludeValue(
            config,
            input
          );

        });


    /*
      Lug Width is a fixed physical specification. Keep remembered
      widths in the same positions and grey out impossible choices
      rather than making them disappear as other filters change.
    */
    if (
      config.key === 'lug-width'
    ) {
      /*
        DALUCA V31 — CUSTOMER-FACING WIDTH RANGE

        Shopify may expose a broader native width facet (for example
        10mm–30mm). DaLuca's Finder/filter experience intentionally
        presents only the supported 14mm–28mm range everywhere,
        including the Custom Watch Straps collection.
      */
      return stableLugWidthInputs(
        candidates
      ).filter(function (input) {
        const width = parseFloat(
          String(input.value || '')
            .replace(/mm/gi, '')
            .trim()
        );

        return (
          Number.isFinite(width) &&
          width >= 14 &&
          width <= 28
        );
      });
    }


    return candidates
      .filter(function (input) {

        /*
          Other dynamic facets stay compact: hide unavailable choices,
          but never hide something that is currently selected.
        */
        return (
          !input.disabled ||
          input.checked
        );

      });

  }


  function createSection(config) {

    /*
      FIXED-WIDTH COLLECTION SAFETY
      Habitat can retain width facet markup during AJAX redraws. On a true
      fixed-width collection, Lug Width is context, not a customer choice.
    */
    if (
      config.key === 'lug-width' &&
      window.DaLucaManualCustomWidthRoute &&
      typeof window.DaLucaManualCustomWidthRoute.collectionLocked === 'function' &&
      window.DaLucaManualCustomWidthRoute.collectionLocked()
    ) {
      return null;
    }

    const inputs =
      usableInputs(config);


    const hasActive =
      inputs.some(function (input) {
        return input.checked;
      });


    /*
      THE IMPORTANT COLLECTION-AWARE RULE:

      If the collection only has one possible value,
      there is nothing useful for the customer to choose.

      Examples:
      - Two Piece = Ready Made only -> hide Order Type.
      - Custom collection = Made to Order only -> hide it.
      - Fixed 24mm collection -> hide Lug Width.
      - One construction only -> hide Construction.

      If the single value is already selected, keep it
      visible so the shopper can turn it off.
    */
    const allowSingleClearanceSpecial =
      clearanceModeActive() &&
      config.key === 'special' &&
      inputs.length === 1;


    if (
      inputs.length === 0 ||
      (
        inputs.length <= 1 &&
        !hasActive &&
        !allowSingleClearanceSpecial
      )
    ) {

      return null;

    }


    const section =
      document.createElement(
        'div'
      );

    section.className =
      'daluca-filter-drawer__section ' +
      'daluca-filter-drawer__section--choices ' +
      'daluca-dynamic-filter-section';

    section.setAttribute(
      'data-daluca-dynamic-section',
      config.key
    );


    const title =
      document.createElement(
        'span'
      );

    title.className =
      'daluca-filter-drawer__section-title';

    window.DaLucaI18n.setText(title, config.title);

    section.appendChild(
      title
    );


    const choices =
      document.createElement(
        'div'
      );

    choices.className =
      'daluca-filter-drawer__choices';

    section.appendChild(
      choices
    );


    inputs.forEach(function (input) {

      const button =
        document.createElement(
          'button'
        );

      button.type =
        'button';

const label =
  displayValue(
    config,
    input
  );


if (config.key === 'color') {

  const swatch =
    document.createElement(
      'span'
    );

  swatch.className =
    'daluca-color-swatch';

  swatch.style.setProperty(
    '--daluca-swatch',
    getColorSwatch(
      input.value
    )
  );


  const text =
    document.createElement(
      'span'
    );

  window.DaLucaI18n.setText(text, label);


  button.appendChild(
    swatch
  );

  button.appendChild(
    text
  );

} else {

  window.DaLucaI18n.setText(button, label);

}

      button.setAttribute(
        'data-daluca-dynamic-filter-name',
        input.name
      );

      button.setAttribute(
        'data-daluca-dynamic-filter-value',
        input.value
      );

      if(input.dalucaAppleWidth)button.setAttribute('data-daluca-apple-width',parseInt(input.value,10));

      if (input.dalucaCustomProgramWidth) {
        button.setAttribute(
          'data-daluca-custom-program-width',
          'true'
        );
      }

      if (input.dalucaCustomRoute) {
        button.setAttribute(
          'data-daluca-custom-width-route',
          'true'
        );
      }

      const isSelectedCustomProgramWidth =
        !!input.dalucaCustomProgramWidth &&
        !!(
          window.DaLucaCustomProgramWidth &&
          typeof window.DaLucaCustomProgramWidth.selected === 'function' &&
          Number(
            String(input.value || '')
              .replace(/mm/gi, '')
              .trim()
          ) === Number(
            window.DaLucaCustomProgramWidth.selected()
          )
        );

      const isPendingCustomWidth =
        !!input.dalucaCustomRoute &&
        !!(
          window.DaLucaManualCustomWidthRoute &&
          typeof window.DaLucaManualCustomWidthRoute.pending === 'function' &&
          Number(
            String(input.value || '')
              .replace(/mm/gi, '')
              .trim()
          ) === Number(
            window.DaLucaManualCustomWidthRoute.pending()
          )
        );

      const isActiveChoice =
        isSelectedCustomProgramWidth ||
        (
          !input.dalucaCustomProgramWidth &&
          !!input.checked
        ) ||
        isPendingCustomWidth;

      button.classList.toggle(
        'is-active',
        isActiveChoice
      );

      button.setAttribute(
        'aria-pressed',
        isActiveChoice
          ? 'true'
          : 'false'
      );


      const unavailable =
        !!input.disabled &&
        !input.checked;

      button.disabled =
        unavailable;

      button.classList.toggle(
        'is-disabled',
        unavailable
      );

      button.setAttribute(
        'aria-disabled',
        unavailable
          ? 'true'
          : 'false'
      );

      choices.appendChild(
        button
      );

    });


    return section;

  }


  function renderSlot(slotName) {

    const slot =
      document.querySelector(
        '[data-daluca-dynamic-filter-slot="' +
        slotName +
        '"]'
      );

    if (!slot) return;


    window.DaLucaI18n.setHtml(slot, '');


    CONFIGS
      .filter(function (config) {

        return (
          config.slot ===
          slotName
        );

      })
      .forEach(function (config) {

        const section =
          createSection(
            config
          );

        if (section) {

          slot.appendChild(
            section
          );

        }

      });

  }


  function syncDynamicFilters() {

    renderSlot(
      'width'
    );

    renderSlot(
      'extras'
    );

  }


  function findFreshNativeInput(
    name,
    value
  ) {

    return allNativeInputs()
      .find(function (input) {

        return (
          String(input.name) ===
            String(name) &&

          String(input.value) ===
            String(value)
        );

      }) || null;

  }


  /* =========================================================
     DALUCA V43 — LUG WIDTH IS SINGLE-SELECT

     Shopify metafield facets are multi-select by default, but lug
     width is a physical fit constraint. Only one width may be active
     at a time. This helper clears sibling width inputs before the new
     width is applied or staged for Custom Mode.
     ========================================================= */
  function isLugWidthButton(button) {
    return !!(
      button &&
      button.closest &&
      button.closest('[data-daluca-dynamic-section="lug-width"]')
    );
  }


  function clearSiblingWidthInputs(name, exceptInput) {
    allNativeInputs().forEach(function (candidate) {
      if (
        candidate !== exceptInput &&
        String(candidate.name) === String(name) &&
        candidate.checked
      ) {
        candidate.checked = false;
      }
    });
  }


  document.addEventListener(
    'daluca:custom-program-width-change',
    function () {
      syncDynamicFilters();
    }
  );


  document.addEventListener(
    'click',
    function (event) {

      const button =
        event.target.closest(
          '[data-daluca-dynamic-filter-name]'
        );

      if (!button) return;

      event.preventDefault();

      const filterName =
        button.getAttribute(
          'data-daluca-dynamic-filter-name'
        );

      const filterValue =
        button.getAttribute(
          'data-daluca-dynamic-filter-value'
        );

      if(button.hasAttribute('data-daluca-apple-width')&&window.DaLucaAppleWidth){window.DaLucaAppleWidth.select(button.dataset.dalucaAppleWidth);syncDynamicFilters();return;}

      const lugWidthChoice =
        isLugWidthButton(button);


      /*
        Defense in depth: even if a stale width button survives an AJAX
        redraw on a fixed-width collection, never allow it to change fit.
      */
      if (
        lugWidthChoice &&
        window.DaLucaManualCustomWidthRoute &&
        typeof window.DaLucaManualCustomWidthRoute.collectionLocked === 'function' &&
        window.DaLucaManualCustomWidthRoute.collectionLocked()
      ) {
        syncDynamicFilters();
        return;
      }


      if (lugWidthChoice) {
        /*
          Clear every other native width before any width path runs.
          This prevents URLs/forms such as 18mm + 20mm from coexisting.
        */
        clearSiblingWidthInputs(
          filterName,
          null
        );

        if (
          window.DaLucaCustomProgramWidth &&
          typeof window.DaLucaCustomProgramWidth.clear === 'function' &&
          !button.hasAttribute('data-daluca-custom-program-width')
        ) {
          window.DaLucaCustomProgramWidth.clear();
        }
      }


      if (
        button.hasAttribute(
          'data-daluca-custom-program-width'
        ) &&
        window.DaLucaCustomProgramWidth
      ) {
        const selected =
          window.DaLucaCustomProgramWidth.select(
            filterValue
          );

        if (selected) {
          syncDynamicFilters();
          return;
        }
      }


      if (
        button.hasAttribute(
          'data-daluca-custom-width-route'
        ) &&
        window.DaLucaManualCustomWidthRoute
      ) {
        const routed =
          window.DaLucaManualCustomWidthRoute.route(
            filterValue
          );

        if (routed) {
          syncDynamicFilters();
          return;
        }
      }


      if (
        window.DaLucaManualCustomWidthRoute &&
        typeof window.DaLucaManualCustomWidthRoute.clearPending === 'function'
      ) {
        window.DaLucaManualCustomWidthRoute.clearPending();
      }


      const input =
        findFreshNativeInput(
          filterName,
          filterValue
        );


      if (
        !input ||
        (
          input.disabled &&
          !input.checked
        )
      ) {
        return;
      }


      const wasChecked =
        !!input.checked;

      if (lugWidthChoice) {
        clearSiblingWidthInputs(
          filterName,
          input
        );
      }

      input.checked =
        !wasChecked;


      /*
        Habitat's filtering system responds to
        the input event, just like the working
        DaLuca Material filters.
      */
      input.dispatchEvent(
        new Event(
          'input',
          {
            bubbles: true
          }
        )
      );

    }
  );


  document.addEventListener(
    'daluca:manual-custom-width-pending',
    function () {
      syncDynamicFilters();
    }
  );


  /*
    Habitat replaces its native filter markup
    after AJAX filtering.

    Ignore mutations inside the DaLuca UI itself
    so rebuilding these buttons does not create
    an observer loop.
  */
  let syncTimer =
    null;

  const observer =
    new MutationObserver(
      function (mutations) {

        const engine =
          document.querySelector(
            '[data-daluca-filter-engine]'
          );


        const nativeMutation =
          mutations.some(
            function (mutation) {

              if (
                engine &&
                engine.contains(
                  mutation.target
                )
              ) {
                return false;
              }

              return true;

            }
          );


        if (!nativeMutation) {
          return;
        }


        clearTimeout(
          syncTimer
        );


        syncTimer =
          setTimeout(
            syncDynamicFilters,
            100
          );

      }
    );


  if (document.body) {

    observer.observe(
      document.body,
      {
        childList: true,
        subtree: true
      }
    );

  }


  document.addEventListener(
    'input',
    function (event) {

      if (
        event.target &&
        event.target.closest &&
        event.target.closest(
          '#FacetFiltersForm'
        )
      ) {

        window.setTimeout(
          syncDynamicFilters,
          100
        );

      }

    },
    true
  );


  window.addEventListener(
    'popstate',
    function () {

      window.setTimeout(
        syncDynamicFilters,
        100
      );

    }
  );


  if (
    document.readyState ===
    'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      syncDynamicFilters
    );

  } else {

    syncDynamicFilters();

  }

})();

/* =========================================================
   DALUCA LIVE PRODUCT COUNT
   Copies Shopify's authoritative result count into the
   visible DaLuca UI while Habitat's native UI stays hidden.
========================================================= */

(function () {

  if (window.DaLucaProductCountInitialized) return;
  window.DaLucaProductCountInitialized = true;


  function customCount() {

    return document.querySelector(
      '[data-daluca-product-count]'
    );

  }


  function nativeCount() {

    return (
      document.getElementById(
        'ProductCountDesktop'
      ) ||

      document.getElementById(
        'ProductCount'
      ) ||

      document.querySelector(
        '.product-count'
      ) ||

      document.querySelector(
        '[id^="ProductCount"]'
      )
    );

  }


  function syncProductCount() {

    if (
      window.DaLucaInPlaceCustomMode &&
      window.DaLucaInPlaceCustomMode.active()
    ) {
      return;
    }

    const custom =
      customCount();

    const native =
      nativeCount();

    if (!custom) return;


    if (!native) {

      window.DaLucaI18n.setText(custom, '');
      custom.hidden = true;
      return;

    }


    const text =
      String(
        window.DaLucaI18n.sourceText(native) || ''
      )
        .replace(
          /\s+/g,
          ' '
        )
        .trim();


    if (!text) {

      window.DaLucaI18n.setText(custom, '');
      custom.hidden = true;
      return;

    }


    const countMatch =
      text.match(
        /([\d,]+)\s+of\s+([\d,]+)\s+products?/i
      );

    if (countMatch) {

      window.DaLucaI18n.setText(custom, countMatch[1] + ' products');

    } else {

      window.DaLucaI18n.setText(custom, text);

    }

    custom.hidden =
      false;

  }


  let timer = null;


  const observer =
    new MutationObserver(
      function () {

        clearTimeout(
          timer
        );

        timer =
          setTimeout(
            syncProductCount,
            100
          );

      }
    );


  if (document.body) {

    observer.observe(
      document.body,
      {
        childList: true,
        subtree: true,
        characterData: true
      }
    );

  }


  document.addEventListener(
    'input',
    function () {

      window.setTimeout(
        syncProductCount,
        150
      );

    },
    true
  );


  window.addEventListener(
    'popstate',
    function () {

      window.setTimeout(
        syncProductCount,
        100
      );

    }
  );


  if (
    document.readyState ===
    'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      syncProductCount
    );

  } else {

    syncProductCount();

  }

})();
/* =========================================================
   DALUCA COMPACT FILTER — ONE HIDE / SHOW CONTROL
   The same circular control remains in the same right-side rail.
   Filtering state remains intact.
   ========================================================= */
(function () {

  if (window.DaLucaCompactFilterVisibilityInitialized) return;
  window.DaLucaCompactFilterVisibilityInitialized = true;

  const STORAGE_KEY =
    'daluca_compact_filter_hidden_v1';

  function getEngine() {
    return document.querySelector(
      '[data-daluca-filter-engine]'
    );
  }

  function getToggleButton() {
    const engine = getEngine();
    return engine
      ? engine.querySelector(
          '[data-daluca-visibility-toggle]'
        )
      : null;
  }

  function closeDrawerIfOpen() {
    const engine = getEngine();
    if (!engine) return;

    const drawer = engine.querySelector(
      '[data-daluca-filter-drawer]'
    );

    if (
      drawer &&
      !drawer.hidden
    ) {
      const closeButton =
        drawer.querySelector(
          '[data-daluca-close-filters]'
        );

      if (closeButton) {
        closeButton.click();
      }
    }
  }

  function setHidden(hidden) {
    const engine = getEngine();
    if (!engine) return;

    const button = getToggleButton();

    engine.classList.toggle(
      'daluca-filter-interface-hidden',
      !!hidden
    );

    if (button) {
      button.classList.toggle(
        'is-show-state',
        !!hidden
      );

      button.setAttribute(
        'aria-expanded',
        hidden ? 'false' : 'true'
      );

      button.setAttribute(
        'aria-label',
        hidden
          ? window.DaLucaI18n.displayText('Show filter controls')
          : window.DaLucaI18n.displayText('Hide filter controls')
      );

      const label = button.querySelector(
        '[data-daluca-visibility-label]'
      );

      if (label) {
        window.DaLucaI18n.setText(label, hidden
          ? 'Show filters'
          : 'Hide filters');
      }
    }

    if (hidden) {
      closeDrawerIfOpen();
    }

    try {
      sessionStorage.setItem(
        STORAGE_KEY,
        hidden ? '1' : '0'
      );
    } catch (error) {
      /* Storage is optional. */
    }
  }

  function restore() {
    let hidden = false;

    try {
      hidden =
        sessionStorage.getItem(
          STORAGE_KEY
        ) === '1';
    } catch (error) {
      hidden = false;
    }

    setHidden(hidden);
  }

  document.addEventListener(
    'click',
    function (event) {
      const button =
        event.target.closest(
          '[data-daluca-visibility-toggle]'
        );

      if (!button) return;

      event.preventDefault();

      const engine = getEngine();
      if (!engine) return;

      setHidden(
        !engine.classList.contains(
          'daluca-filter-interface-hidden'
        )
      );
    }
  );

  if (
    document.readyState === 'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      restore
    );
  } else {
    restore();
  }

})();


/* =========================================================
   DALUCA MOBILE FILTER ACCORDION
   Mobile-only presentation layer:
   - Clean collapsed rows with one chevron per section.
   - Selected values remain visible in each row summary.
   - Only one section is expanded at a time.
   - Sticky VIEW PRODUCTS footer closes the drawer.
   Desktop under-bar filter is untouched.
========================================================= */
(function () {

  if (window.DaLucaMobileFilterAccordionInitialized) return;
  window.DaLucaMobileFilterAccordionInitialized = true;

  let openKey = null;
  let syncTimer = null;
  let pendingCustomPreviewWidth = null;
  let pendingCustomPreviewCount = '';
  let pendingCustomPreviewLoading = false;

  /*
    When a manual Custom width is staged, keep the visible outside result
    count synchronized with the drawer preview. These snapshots let us put
    the original ready-made count back if the shopper cancels the staged
    width before Apply.
  */
  const pendingOutsideCountSnapshots = new Map();


  function isMobile() {
    return window.matchMedia(
      '(max-width: 767px)'
    ).matches;
  }


  function setTextIfChanged(node, value) {
    if (
      node &&
      window.DaLucaI18n.sourceText(node) !== value
    ) {
      window.DaLucaI18n.setText(node, value);
    }
  }


  function setAttributeIfChanged(node, name, value) {
    if (
      node &&
      node.getAttribute(name) !== value
    ) {
      node.setAttribute(name, value);
    }
  }


  function getDrawer() {
    return document.querySelector(
      '[data-daluca-filter-drawer]'
    );
  }


  function getSections() {
    const drawer = getDrawer();

    if (!drawer) return [];

    return Array.from(
      drawer.querySelectorAll(
        '.daluca-filter-drawer__section'
      )
    );
  }


  function sectionKey(section) {

    const explicit =
      section.getAttribute(
        'data-daluca-mobile-accordion-key'
      );

    if (explicit) {
      return explicit;
    }

    const title =
      section.querySelector(
        ':scope > .daluca-filter-drawer__section-title'
      );

    const label =
      title
        ? String(window.DaLucaI18n.sourceText(title) || '').trim()
        : 'filter';

    const key =
      label
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '') ||
      'filter';

    section.setAttribute(
      'data-daluca-mobile-accordion-key',
      key
    );

    return key;
  }


  function selectedButtonLabels(section) {

    return Array.from(
      section.querySelectorAll(
        'button.is-active, button[aria-pressed="true"]'
      )
    )
      .filter(function (button) {
        return !button.matches(
          '[data-daluca-mobile-accordion-toggle]'
        );
      })
      .map(function (button) {
        return String(
          window.DaLucaI18n.sourceText(button) || ''
        )
          .replace(/\s+/g, ' ')
          .trim();
      })
      .filter(Boolean);

  }


  function sectionSummaryDisplay(section) {
    const source = sectionSummary(section);
    if (section.classList.contains('daluca-filter-sort') || section.classList.contains('daluca-filter-price')) {
      return window.DaLucaI18n.displayText(source);
    }
    const labels = selectedButtonLabels(section);
    return labels.slice(0, 2).map(function (label) { return window.DaLucaI18n.displayText(label); }).join(', ') +
      (labels.length > 2 ? ' +' + (labels.length - 2) : '');
  }

  function sectionSummary(section) {

    if (
      section.classList.contains(
        'daluca-filter-sort'
      )
    ) {
      const select =
        section.querySelector(
          '[data-daluca-sort]'
        );

      if (
        select &&
        select.selectedOptions &&
        select.selectedOptions.length
      ) {
        return String(
          window.DaLucaI18n.sourceText(select.selectedOptions[0]) || ''
        ).trim();
      }
    }


    if (
      section.classList.contains(
        'daluca-filter-price'
      )
    ) {
      const min =
        section.querySelector(
          '[data-daluca-price-min]'
        );

      const max =
        section.querySelector(
          '[data-daluca-price-max]'
        );

      const minValue =
        min ? String(min.value || '').trim() : '';

      const maxValue =
        max ? String(max.value || '').trim() : '';

      if (minValue && maxValue) {
        return '$' + minValue + '–$' + maxValue;
      }

      if (minValue) {
        return 'From $' + minValue;
      }

      if (maxValue) {
        return 'Up to $' + maxValue;
      }

      return '';
    }


    const labels =
      selectedButtonLabels(
        section
      );

    if (!labels.length) {
      return '';
    }

    if (labels.length === 1) {
      return labels[0];
    }

    return (
      labels.slice(0, 2).join(', ') +
      (labels.length > 2
        ? ' +' + (labels.length - 2)
        : '')
    );

  }


  function decorateSection(section) {

    const key =
      sectionKey(section);

    let toggle =
      section.querySelector(
        ':scope > [data-daluca-mobile-accordion-toggle]'
      );

    const title =
      section.querySelector(
        ':scope > .daluca-filter-drawer__section-title'
      );

    if (!title) return;


    if (!toggle) {

      toggle =
        document.createElement(
          'button'
        );

      toggle.type = 'button';
      toggle.className =
        'daluca-mobile-accordion-toggle';

      toggle.setAttribute(
        'data-daluca-mobile-accordion-toggle',
        key
      );

      window.DaLucaI18n.setHtml(toggle, '<span class="daluca-mobile-accordion-label"></span>' +
        '<span class="daluca-mobile-accordion-summary"></span>' +
        '<span class="daluca-mobile-accordion-chevron" aria-hidden="true"></span>');

      section.insertBefore(
        toggle,
        section.firstChild
      );
    }


    const labelNode =
      toggle.querySelector(
        '.daluca-mobile-accordion-label'
      );

    const summaryNode =
      toggle.querySelector(
        '.daluca-mobile-accordion-summary'
      );

    if (labelNode) {
      setTextIfChanged(
        labelNode,
        String(window.DaLucaI18n.sourceText(title) || '')
          .replace(/\s+/g, ' ')
          .trim()
      );
    }

    if (summaryNode) {
      window.DaLucaI18n.setDisplayText(
        summaryNode,
        sectionSummary(section),
        sectionSummaryDisplay(section)
      );
    }


    const expanded =
      openKey === key;

    section.classList.toggle(
      'is-mobile-open',
      expanded
    );

    setAttributeIfChanged(
      toggle,
      'aria-expanded',
      expanded ? 'true' : 'false'
    );

  }


  function nativeProductCountText() {

    function countFromNode(node) {
      if (!node) return '';

      const text =
        String(window.DaLucaI18n.sourceText(node) || '')
          .replace(/\s+/g, ' ')
          .trim();

      if (!text) return '';

      const ofMatch =
        text.match(
          /([\d,]+)\s+of\s+[\d,]+\s+products?/i
        );

      if (ofMatch) {
        return ofMatch[1];
      }

      const direct =
        text.match(
          /([\d,]+)\s+products?/i
        );

      if (direct) {
        return direct[1];
      }

      const numberOnly =
        text.match(/^([\d,]+)$/);

      return numberOnly
        ? numberOnly[1]
        : '';
    }


    function isActuallyVisible(node) {
      if (!node) return false;

      if (
        node.hidden ||
        node.getAttribute('aria-hidden') === 'true' ||
        node.closest('[data-daluca-filter-drawer]')
      ) {
        return false;
      }

      const style =
        window.getComputedStyle
          ? window.getComputedStyle(node)
          : null;

      if (
        style &&
        (
          style.display === 'none' ||
          style.visibility === 'hidden'
        )
      ) {
        return false;
      }

      return (
        !node.getClientRects ||
        node.getClientRects().length > 0
      );
    }


    function firstVisibleCount(selector) {
      const nodes =
        Array.from(
          document.querySelectorAll(selector)
        );

      for (const node of nodes) {
        if (!isActuallyVisible(node)) continue;

        const count =
          countFromNode(node);

        if (count) {
          return count;
        }
      }

      return '';
    }


    /*
      V43: mirror the exact results-bar number the shopper sees outside
      the drawer. This avoids stale Habitat/native count nodes that may
      remain in the DOM after AJAX filtering.
    */
    const visibleResultsBarCount =
      firstVisibleCount(
        '.daluca-filter-results-bar .daluca-filter-product-count'
      ) ||
      firstVisibleCount(
        '[data-daluca-filter-engine] .daluca-filter-product-count'
      ) ||
      firstVisibleCount(
        '[data-daluca-product-count]'
      );

    if (visibleResultsBarCount) {
      return visibleResultsBarCount;
    }


    const visibleNativeCount =
      firstVisibleCount('#ProductCountDesktop') ||
      firstVisibleCount('#ProductCount') ||
      firstVisibleCount('#ProductCountMobile') ||
      firstVisibleCount('.product-count') ||
      firstVisibleCount('[id^="ProductCount"]');

    if (visibleNativeCount) {
      return visibleNativeCount;
    }


    /* Last-resort fallback for themes that keep count nodes offscreen. */
    const fallbackNodes = [
      document.querySelector('.daluca-filter-results-bar .daluca-filter-product-count'),
      document.querySelector('[data-daluca-product-count]'),
      document.getElementById('ProductCountDesktop'),
      document.getElementById('ProductCount'),
      document.getElementById('ProductCountMobile'),
      document.querySelector('.product-count'),
      document.querySelector('[id^="ProductCount"]')
    ].filter(Boolean);

    for (const node of fallbackNodes) {
      const count =
        countFromNode(node);

      if (count) {
        return count;
      }
    }

    return '';
  }

  function inPlaceCustomProductCountText() {

    const mode =
      window.DaLucaInPlaceCustomMode;

    if (
      !mode ||
      typeof mode.active !== 'function' ||
      !mode.active() ||
      !mode.state
    ) {
      return '';
    }

    return String(
      mode.state.currentCount || ''
    )
      .replace(/[^0-9,]/g, '')
      .trim();

  }


  function pendingManualCustomWidth() {

    const route =
      window.DaLucaManualCustomWidthRoute;

    if (
      !route ||
      typeof route.pending !== 'function'
    ) {
      return null;
    }

    const width =
      Number(route.pending());

    return (
      Number.isFinite(width) &&
      width >= 14 &&
      width <= 28
    )
      ? width
      : null;

  }


  function customCountFromDocument(doc) {

    const countNodes = [
      doc.getElementById('ProductCountDesktop'),
      doc.getElementById('ProductCountMobile'),
      doc.getElementById('ProductCount'),
      doc.querySelector('.product-count'),
      doc.querySelector('[id^="ProductCount"]')
    ].filter(Boolean);

    for (const node of countNodes) {
      const text =
        String(window.DaLucaI18n.sourceText(node) || '')
          .replace(/\s+/g, ' ')
          .trim();

      const match =
        text.match(
          /([\d,]+)(?:\s+of\s+[\d,]+)?\s+products?/i
        );

      if (match) {
        return match[1];
      }
    }

    const grid =
      doc.querySelector('#product-grid') ||
      doc.querySelector('#ProductGridContainer .product-grid') ||
      doc.querySelector('.collection__product-grid') ||
      doc.querySelector('.product-grid') ||
      doc.querySelector('[data-product-grid]');

    if (!grid) return '';

    const productHrefs = new Set();

    grid.querySelectorAll(
      'a[href*="/products/"]'
    ).forEach(function (link) {
      const href =
        String(link.getAttribute('href') || '')
          .split('?')[0]
          .replace(/\/$/, '');

      if (/\/products\/[^/]+$/i.test(href)) {
        productHrefs.add(href);
      }
    });

    return productHrefs.size
      ? String(productHrefs.size)
      : '';

  }


  function pendingOutsideCountNodes() {

    const selectors = [
      '.daluca-results-count',
      '.daluca-filter-product-count',
      '[data-daluca-product-count]',
      '#ProductCountDesktop',
      '#ProductCount',
      '#ProductCountMobile',
      '.product-count',
      '[id^="ProductCount"]'
    ];

    const nodes = [];
    const seen = new Set();

    selectors.forEach(function (selector) {
      document.querySelectorAll(selector).forEach(function (node) {
        if (
          !node ||
          seen.has(node) ||
          node.closest('[data-daluca-filter-drawer]')
        ) {
          return;
        }

        seen.add(node);
        nodes.push(node);
      });
    });

    return nodes;

  }


  function setPendingOutsideCount(count) {

    const clean = String(count || '')
      .replace(/[^0-9,]/g, '')
      .trim();

    if (!clean) return;

    pendingOutsideCountNodes().forEach(function (node) {
      if (!pendingOutsideCountSnapshots.has(node)) {
        pendingOutsideCountSnapshots.set(node, {
          text: window.DaLucaI18n.sourceText(node),
          hidden: !!node.hidden,
          display: node.style ? node.style.getPropertyValue('display') : ''
        });
      }

      node.hidden = false;

      if (node.style) {
        node.style.removeProperty('display');
      }

      window.DaLucaI18n.setText(node, clean + (clean === '1' ? ' product' : ' products'));
    });

  }


  function restorePendingOutsideCount() {

    pendingOutsideCountSnapshots.forEach(function (snapshot, node) {
      if (!node || !node.isConnected) return;

      window.DaLucaI18n.setText(node, snapshot.text);
      node.hidden = snapshot.hidden;

      if (node.style) {
        if (snapshot.display) {
          node.style.setProperty('display', snapshot.display);
        } else {
          node.style.removeProperty('display');
        }
      }
    });

    pendingOutsideCountSnapshots.clear();

  }


  function requestPendingCustomPreviewCount(width) {

    if (!width) {
      pendingCustomPreviewWidth = null;
      pendingCustomPreviewCount = '';
      pendingCustomPreviewLoading = false;

      const mode = window.DaLucaInPlaceCustomMode;
      const customActive = !!(
        mode &&
        typeof mode.active === 'function' &&
        mode.active()
      );

      if (!customActive) {
        restorePendingOutsideCount();
      }

      return;
    }

    if (
      pendingCustomPreviewWidth === width &&
      (pendingCustomPreviewCount || pendingCustomPreviewLoading)
    ) {
      return;
    }

    pendingCustomPreviewWidth = width;
    pendingCustomPreviewCount = '';
    pendingCustomPreviewLoading = true;

    fetch(window.DaLucaI18n.url('/collections/custom-watch-straps'), {
      credentials: 'same-origin',
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
      .then(function (response) {
        if (!response.ok) {
          throw new Error(
            'Custom preview count HTTP ' + response.status
          );
        }
        return response.text();
      })
      .then(function (html) {
        if (
          pendingManualCustomWidth() !== width ||
          pendingCustomPreviewWidth !== width
        ) {
          return;
        }

        const doc = new DOMParser()
          .parseFromString(html, 'text/html');

        pendingCustomPreviewCount =
          customCountFromDocument(doc);

        if (pendingCustomPreviewCount) {
          setPendingOutsideCount(
            pendingCustomPreviewCount
          );
        }
      })
      .catch(function (error) {
        console.warn(
          'DaLuca Custom preview count unavailable:',
          error
        );
      })
      .finally(function () {
        if (pendingCustomPreviewWidth === width) {
          pendingCustomPreviewLoading = false;
          scheduleSync();
        }
      });

  }


  function syncFooter() {

    const drawer = getDrawer();
    if (!drawer) return;

    const button =
      drawer.querySelector(
        '[data-daluca-mobile-view-results], .daluca-filter-drawer__done'
      );

    if (!button) return;

    const pendingWidth =
      pendingManualCustomWidth();

    if (pendingWidth) {
      requestPendingCustomPreviewCount(pendingWidth);
    } else {
      requestPendingCustomPreviewCount(null);
    }

    const customCount =
      inPlaceCustomProductCountText();

    if (pendingWidth && !customCount) {
      if (pendingCustomPreviewCount) {
        setPendingOutsideCount(
          pendingCustomPreviewCount
        );
      }

      setTextIfChanged(
        button,
        pendingCustomPreviewCount
          ? 'VIEW ' + pendingCustomPreviewCount + ' CUSTOM PRODUCTS'
          : 'VIEW CUSTOM PRODUCTS'
      );
      return;
    }

    const count =
      customCount ||
      nativeProductCountText();

    setTextIfChanged(
      button,
      count
        ? 'VIEW ' + count + ' PRODUCTS'
        : 'VIEW PRODUCTS'
    );

  }


  function sync() {

    getSections()
      .forEach(
        decorateSection
      );

    syncFooter();

  }


  function scheduleSync() {

    clearTimeout(
      syncTimer
    );

    syncTimer =
      window.setTimeout(
        sync,
        80
      );

  }


  document.addEventListener(
    'click',
    function (event) {

      const toggle =
        event.target.closest(
          '[data-daluca-mobile-accordion-toggle]'
        );

      if (
        toggle &&
        isMobile()
      ) {
        event.preventDefault();

        const key =
          toggle.getAttribute(
            'data-daluca-mobile-accordion-toggle'
          );

        openKey =
          openKey === key
            ? null
            : key;

        sync();
        return;
      }


      if (
        isMobile() &&
        event.target.closest(
          '[data-daluca-open-filters]'
        )
      ) {
        window.setTimeout(
          sync,
          20
        );
        return;
      }


      if (
        isMobile() &&
        event.target.closest(
          '[data-daluca-filter-drawer] button, [data-daluca-filter-drawer] select'
        )
      ) {
        window.setTimeout(
          scheduleSync,
          40
        );
      }

    },
    true
  );


  document.addEventListener(
    'input',
    function (event) {

      if (
        event.target &&
        event.target.closest &&
        event.target.closest(
          '[data-daluca-filter-drawer]'
        )
      ) {
        scheduleSync();
      }

    },
    true
  );


  document.addEventListener(
    'change',
    function (event) {

      if (
        event.target &&
        event.target.closest &&
        event.target.closest(
          '[data-daluca-filter-drawer]'
        )
      ) {
        scheduleSync();
      }

    },
    true
  );


  document.addEventListener(
    'daluca:manual-custom-width-pending',
    function () {
      requestPendingCustomPreviewCount(
        pendingManualCustomWidth()
      );
      scheduleSync();
    }
  );


  const observer =
    new MutationObserver(
      scheduleSync
    );


  if (document.body) {
    observer.observe(
      document.body,
      {
        childList: true,
        subtree: true,
        characterData: true,
        attributes: true,
        attributeFilter: [
          'class',
          'aria-pressed',
          'disabled',
          'hidden',
          'aria-hidden'
        ]
      }
    );
  }


  /*
    V43 desktop parity: Habitat dispatches the authoritative facet input
    outside the visible drawer. Resync the drawer footer after those AJAX
    events as well as after the drawer's own controls.
  */
  document.addEventListener(
    'input',
    function () {
      scheduleSync();
      window.setTimeout(sync, 220);
      window.setTimeout(sync, 650);
    },
    true
  );

  document.addEventListener(
    'change',
    function () {
      scheduleSync();
      window.setTimeout(sync, 220);
      window.setTimeout(sync, 650);
    },
    true
  );

  document.addEventListener(
    'daluca:inplace-custom-products-updated',
    function () {
      scheduleSync();
      window.setTimeout(sync, 180);
    }
  );

  window.addEventListener(
    'resize',
    scheduleSync
  );

  window.addEventListener(
    'popstate',
    scheduleSync
  );


  if (
    document.readyState === 'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      sync
    );
  } else {
    sync();
  }

})();

/* =========================================================
   DALUCA V12 — MOBILE WATCH SEARCH PLACEHOLDER
   Keep the desktop wording intact while using a shorter,
   readable prompt on narrow phones.
========================================================= */
(function () {
  if (window.DaLucaMobileSearchPlaceholderInitialized) return;
  window.DaLucaMobileSearchPlaceholderInitialized = true;

  const DESKTOP_PLACEHOLDER = 'Search your watch, model, or reference';
  const MOBILE_PLACEHOLDER = 'Search watch, model, or reference';

  function syncMobileSearchPlaceholder() {
    const input = document.getElementById('DaLucaCollectionWatchSearch');
    if (!input) return;

    const mobile = window.matchMedia('(max-width: 767px)').matches;
    const next = window.DaLucaI18n.displayText(mobile ? MOBILE_PLACEHOLDER : DESKTOP_PLACEHOLDER);

    if (input.getAttribute('placeholder') !== next) {
      input.setAttribute('placeholder', next);
    }
  }

  document.addEventListener('DOMContentLoaded', syncMobileSearchPlaceholder);
  window.addEventListener('resize', syncMobileSearchPlaceholder);

  const observer = new MutationObserver(function () {
    window.clearTimeout(syncMobileSearchPlaceholder._timer);
    syncMobileSearchPlaceholder._timer = window.setTimeout(
      syncMobileSearchPlaceholder,
      80
    );
  });

  if (document.body) {
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  syncMobileSearchPlaceholder();
})();

/* =========================================================
   DALUCA V15 — MOBILE CONVERSION HELPERS
   - Show active refinement count in the main FILTERS trigger.
   - Add a quiet Clear All control to the mobile drawer header.
   - Keep Sort intact while clearing filter.* parameters.
   - Gently bring an opened accordion section into view.
========================================================= */
(function () {
  if (window.DaLucaMobileConversionHelpersInitialized) return;
  window.DaLucaMobileConversionHelpersInitialized = true;

  let syncTimer = null;

  function isMobile() {
    return window.matchMedia('(max-width: 767px)').matches;
  }

  function activeFilterCount() {
    const params = new URLSearchParams(window.location.search);
    const entries = [];
    let hasPrice = false;

    params.forEach(function (value, key) {
      if (!key || !key.startsWith('filter.')) return;
      if (String(value || '').trim() === '') return;

      if (
        key === 'filter.v.price.gte' ||
        key === 'filter.v.price.lte'
      ) {
        hasPrice = true;
        return;
      }

      entries.push(key + '::' + value);
    });

    return entries.length + (hasPrice ? 1 : 0);
  }

  function clearAllFilters() {
    const form = document.getElementById('FacetFiltersForm');
    const drawer = document.querySelector('[data-daluca-filter-drawer]');
    const overlay = document.querySelector('[data-daluca-filter-overlay]');
    const openButton = document.querySelector('[data-daluca-open-filters]');
    const drawerBody = drawer
      ? drawer.querySelector('.daluca-filter-drawer__body')
      : null;

    if (!form) return;

    const savedScrollTop = drawerBody
      ? drawerBody.scrollTop
      : 0;

    let triggerInput = null;

    form.querySelectorAll('input[name^="filter."]').forEach(function (input) {
      const type = String(input.type || '').toLowerCase();

      if (type === 'checkbox' || type === 'radio') {
        if (input.checked) {
          input.checked = false;
          triggerInput = triggerInput || input;
        }
        return;
      }

      if (
        type === 'number' ||
        type === 'text' ||
        type === 'search' ||
        type === 'hidden'
      ) {
        if (String(input.value || '') !== '') {
          input.value = '';
          triggerInput = triggerInput || input;
        }
      }
    });

    document.querySelectorAll(
      '[data-daluca-price-min], [data-daluca-price-max]'
    ).forEach(function (input) {
      input.value = '';
    });

    /*
      Clear All is an in-drawer action on mobile.
      Do not navigate/reload the page: let Habitat process the
      already-cleared native facet form so the drawer stays open.
      Sort is intentionally untouched.
    */
    if (triggerInput) {
      triggerInput.dispatchEvent(
        new Event('input', { bubbles: true })
      );
    } else {
      const url = new URL(window.location.href);
      Array.from(url.searchParams.keys()).forEach(function (key) {
        if (key.startsWith('filter.') || key === 'page') {
          url.searchParams.delete(key);
        }
      });

      window.history.replaceState(
        {},
        '',
        url.pathname +
          (url.searchParams.toString()
            ? '?' + url.searchParams.toString()
            : '') +
          url.hash
      );
    }

    function keepDrawerOpen() {
      if (!isMobile()) return;

      if (drawer) {
        drawer.hidden = false;
        drawer.setAttribute('aria-hidden', 'false');
      }

      if (overlay) {
        overlay.hidden = false;
      }

      if (openButton) {
        openButton.setAttribute('aria-expanded', 'true');
      }

      document.documentElement.classList.add('daluca-filters-open');

      if (drawerBody) {
        drawerBody.scrollTop = savedScrollTop;
      }
    }

    keepDrawerOpen();
    window.setTimeout(keepDrawerOpen, 120);
    window.setTimeout(function () {
      keepDrawerOpen();
      scheduleSync();
    }, 320);
  }

  function ensureMobileClearAll(count) {
    const drawer = document.querySelector('[data-daluca-filter-drawer]');
    if (!drawer) return;

    const headerCopy = drawer.querySelector('.daluca-filter-drawer__header > div');
    if (!headerCopy) return;

    let button = headerCopy.querySelector('[data-daluca-mobile-clear-all]');

    if (!button) {
      button = document.createElement('button');
      button.type = 'button';
      button.className = 'daluca-mobile-clear-all';
      button.setAttribute('data-daluca-mobile-clear-all', '');
      window.DaLucaI18n.setText(button, 'Clear all');
      headerCopy.appendChild(button);
    }

    button.hidden = !isMobile() || count < 1;
  }

  function sync() {
    const count = activeFilterCount();

    document.querySelectorAll('[data-daluca-active-filter-count]')
      .forEach(function (node) {
        window.DaLucaI18n.setText(node, isMobile() && count > 0
          ? String(count)
          : '');
      });

    ensureMobileClearAll(count);
  }

  function scheduleSync() {
    window.clearTimeout(syncTimer);
    syncTimer = window.setTimeout(sync, 80);
  }

  document.addEventListener('click', function (event) {
    const clear = event.target.closest('[data-daluca-mobile-clear-all]');

    if (clear && isMobile()) {
      event.preventDefault();
      clearAllFilters();
      return;
    }

    const toggle = event.target.closest('[data-daluca-mobile-accordion-toggle]');

    if (toggle && isMobile()) {
      const section = toggle.closest('.daluca-filter-drawer__section');

      window.setTimeout(function () {
        if (
          section &&
          section.classList.contains('is-mobile-open')
        ) {
          try {
            section.scrollIntoView({
              behavior: 'auto',
              block: 'nearest'
            });
          } catch (error) {
            section.scrollIntoView(false);
          }
        }
      }, 90);
    }

    window.setTimeout(scheduleSync, 100);
  }, true);

  window.addEventListener('popstate', scheduleSync);
  window.addEventListener('resize', scheduleSync);

  const observer = new MutationObserver(scheduleSync);

  if (document.body) {
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'aria-pressed', 'checked', 'disabled']
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sync);
  } else {
    sync();
  }
})();


/* =========================================================
   DALUCA V16 — MOBILE FILTER STABILITY
   DISABLED FOR PRODUCTION:
   The old scroll-anchor restoration repeatedly wrote drawerBody.scrollTop
   after a filter tap. On iOS Safari this could fight the user's touch scroll
   and create a sticky/bounce-back drawer. Habitat is now allowed to settle
   naturally; no JavaScript rewrites mobile drawer scroll position here.
   ========================================================= */

/* =========================================================
   DALUCA V21.2 — IN-PLACE CUSTOM MODE

   Odd widths (19 / 21 / 23 / 25mm) and watches that require one of
   those widths stay on the shopper's current collection page.

   - No collection navigation.
   - No dead-end 0-product state.
   - Existing ready-made state is preserved for an instant return.
   - Custom collection products are fetched and rendered in-place.
   - Style remains usable to narrow the made-to-order assortment.
   ========================================================= */
(function () {

  if (window.DaLucaInPlaceCustomModeInitialized) return;
  window.DaLucaInPlaceCustomModeInitialized = true;

  const CUSTOM_PATH = window.DaLucaI18n.url('/collections/custom-watch-straps');
  const STYLE_PARAM = 'filter.p.m.daluca_filter.styles';

  const state = {
    active: false,
    width: null,
    source: '',
    watch: null,
    style: '',
    originalGridHtml: '',
    gridSelector: '',
    baseAvailableStyles: null,
    requestId: 0,
    originalHeading: null,
    originalCounts: null,
    currentCount: '',
    customGridHtml: '',
    allowedProductHrefs: null,
    customGridNode: null,
    resultGuardTimer: null
  };

  /*
    IMPORTANT — CUSTOM MODE IS ITS OWN IIFE/SCOPE.

    These helpers intentionally live inside this module. Earlier versions
    called same-named helpers from the main filter IIFE, but those functions
    are private to that closure. That caused a runtime ReferenceError inside
    syncStyles(), stopping execution before loadCustom() could fetch/replace
    the Custom collection grid and product count.
  */
  function collectionShouldOfferSportShortcut() {
    return true;
  }

  function isSportStyle(style) {
    return String(style || '')
      .trim()
      .toLowerCase() === 'sport';
  }

  function syncVisibleStyleCount() {
    document
      .querySelectorAll('.daluca-filter-styles__grid')
      .forEach(function (grid) {
        const visibleCount = Array.from(
          grid.querySelectorAll('[data-daluca-style]')
        ).filter(function (button) {
          return !button.hidden;
        }).length;

        grid.setAttribute(
          'data-daluca-visible-style-count',
          String(visibleCount)
        );
      });
  }

  function engine() {
    return document.querySelector('[data-daluca-filter-engine]');
  }

  function uniqueProductHrefCount(element) {
    if (!element) return 0;

    const hrefs = new Set();

    element
      .querySelectorAll('a[href*="/products/"]')
      .forEach(function (link) {
        const href =
          String(
            link.getAttribute('href') || ''
          )
            .split('?')[0]
            .replace(/\/$/, '');

        if (
          /\/products\/[^/]+$/i.test(href)
        ) {
          hrefs.add(href);
        }
      });

    return hrefs.size;
  }

  function gridElement(doc) {
    doc = doc || document;

    const main =
      doc.querySelector('main') ||
      doc.body ||
      doc.documentElement;

    if (!main) return null;

    const filterEngine =
      main.querySelector(
        '[data-daluca-filter-engine]'
      );

    const selectors = [
      '#product-grid',
      '#ProductGridContainer .product-grid',
      '#ProductGridContainer ul',
      '[id*="ProductGridContainer"] .product-grid',
      '[id*="ProductGridContainer"] ul',
      '.collection__product-grid',
      '.product-grid',
      '[data-product-grid]',
      '[data-products-grid]',
      '[data-collection-products]',
      '.products-grid',
      '.collection-products'
    ];

    for (
      let i = 0;
      i < selectors.length;
      i += 1
    ) {
      const candidates =
        Array.from(
          main.querySelectorAll(
            selectors[i]
          )
        );

      const match =
        candidates.find(
          function (candidate) {
            return (
              (
                !filterEngine ||
                !filterEngine.contains(
                  candidate
                )
              ) &&
              uniqueProductHrefCount(
                candidate
              ) >= 2
            );
          }
        );

      if (match) {
        return match;
      }
    }

    /*
      Habitat fallback. Its collection markup can use a
      theme-specific wrapper with no standard Shopify grid ID.
      Find the smallest ancestor containing most unique product
      links in <main>, while never selecting the DaLuca filter.
    */
    const productLinks =
      Array.from(
        main.querySelectorAll(
          'a[href*="/products/"]'
        )
      ).filter(
        function (link) {
          const href =
            String(
              link.getAttribute('href') || ''
            )
              .split('?')[0]
              .replace(/\/$/, '');

          return (
            /\/products\/[^/]+$/i.test(href) &&
            (
              !filterEngine ||
              !filterEngine.contains(link)
            )
          );
        }
      );

    const uniqueLinks =
      new Set(
        productLinks.map(
          function (link) {
            return String(
              link.getAttribute('href') || ''
            )
              .split('?')[0]
              .replace(/\/$/, '');
          }
        )
      );

    const totalProducts =
      uniqueLinks.size;

    if (!totalProducts) {
      return null;
    }

    const threshold =
      Math.max(
        2,
        Math.ceil(
          totalProducts * 0.7
        )
      );

    let best = null;
    let bestDepth = -1;

    productLinks.forEach(
      function (link) {
        let node =
          link.parentElement;
        let depth = 0;

        while (
          node &&
          node !== main &&
          node !== doc.body
        ) {
          if (
            filterEngine &&
            node.contains(
              filterEngine
            )
          ) {
            break;
          }

          if (
            uniqueProductHrefCount(
              node
            ) >= threshold
          ) {
            if (
              !best ||
              depth < bestDepth ||
              bestDepth < 0
            ) {
              best = node;
              bestDepth = depth;
            }

            break;
          }

          node =
            node.parentElement;
          depth += 1;
        }
      }
    );

    return best;
  }

  function gridContainer(doc) {
    doc = doc || document;

    const standard =
      doc.querySelector(
        '#ProductGridContainer'
      ) ||
      doc.querySelector(
        '[id*="ProductGridContainer"]'
      );

    if (standard) {
      return standard;
    }

    const grid =
      gridElement(doc);

    if (!grid) return null;

    return (
      grid.closest(
        '[data-collection-products], .collection-products, section'
      ) ||
      grid.parentElement ||
      grid
    );
  }

  function rememberOriginalPage() {
    const target = gridContainer(document);

    if (target && !state.originalGridHtml) {
      state.originalGridHtml = target.innerHTML;
      state.gridSelector = '#ProductGridContainer';
    }

    const root = engine();
    const heading = root && root.querySelector('.daluca-filter-fit__heading');

    if (heading && !state.originalHeading) {
      state.originalHeading = {
        eyebrow: String(
          window.DaLucaI18n.sourceText(heading.querySelector('.daluca-filter-fit__eyebrow') || {}) || ''
        ).trim(),
        title: String(
          window.DaLucaI18n.sourceText(heading.querySelector('.daluca-filter-fit__title') || {}) || ''
        ).trim(),
        copy: String(
          window.DaLucaI18n.sourceText(heading.querySelector('.daluca-filter-fit__text') || {}) || ''
        ).trim()
      };
    }
  }

  function installStyle() {
    if (document.getElementById('daluca-inplace-custom-mode-style')) return;

    const style = document.createElement('style');
    style.id = 'daluca-inplace-custom-mode-style';
    window.DaLucaI18n.setText(style, `
      html.daluca-inplace-custom-mode .daluca-filter-actions,
      html.daluca-inplace-custom-mode .daluca-compact-hide-rail {
        display: none !important;
      }

      /*
        Keep Habitat's active-facet RESULTS ROW alive in Custom Mode because
        it owns the customer-visible outside product count. Hide only its
        stale native facet buttons; DaLuca renders the applied Custom width
        in its own compact active-filter host.
      */
      html.daluca-inplace-custom-mode facet-remove.active-facets {
        display: flex !important;
      }

      html.daluca-inplace-custom-mode facet-remove.active-facets [data-daluca-native-width-pill] {
        display: none !important;
      }

      html.daluca-inplace-custom-mode facet-remove.active-facets .daluca-results-count {
        display: inline-flex !important;
        visibility: visible !important;
        margin-left: auto !important;
      }

      html.daluca-inplace-custom-mode .daluca-filter-drawer,
      html.daluca-inplace-custom-mode .daluca-filter-overlay {
        display: none !important;
      }

      .daluca-inplace-custom-fit[hidden] {
        display: none !important;
      }

      .daluca-inplace-custom-fit .daluca-custom-fit__button {
        cursor: pointer;
      }

      .daluca-inplace-custom-loading {
        opacity: .45;
        pointer-events: none;
        transition: opacity .12s ease;
      }

      /*
        The source collection still owns Habitat's native pagination.
        While the 11 made-to-order products are being shown in place,
        that pagination must never append ready-made products underneath.
      */
      html.daluca-inplace-custom-mode [data-daluca-native-pagination-hidden] {
        display: none !important;
      }
    `);
    document.head.appendChild(style);
  }

  function closeDrawer() {
    const drawer = document.querySelector('[data-daluca-filter-drawer]');
    const overlay = document.querySelector('[data-daluca-filter-overlay]');
    const openButton = document.querySelector('[data-daluca-open-filters]');

    if (drawer) {
      drawer.hidden = true;
      drawer.setAttribute('aria-hidden', 'true');
    }

    if (overlay) overlay.hidden = true;

    if (openButton) {
      openButton.setAttribute('aria-expanded', 'false');
    }

    document.documentElement.classList.remove('daluca-filters-open');
  }

  function ensureNotice() {
    const root = engine();
    if (!root) return null;

    let notice = root.querySelector('[data-daluca-inplace-custom-fit]');
    if (notice) return notice;

    notice = document.createElement('div');
    notice.className = 'daluca-custom-fit daluca-inplace-custom-fit';
    notice.setAttribute('data-daluca-inplace-custom-fit', '');
    window.DaLucaI18n.setHtml(notice, `
      <div class="daluca-custom-fit__copy">
        <span>EXACT WIDTH — MADE TO ORDER</span>
        <strong data-daluca-inplace-custom-title></strong>
        <p data-daluca-inplace-custom-copy></p>
      </div>
      <button
        type="button"
        class="daluca-custom-fit__button"
        data-daluca-exit-inplace-custom
      >
        ← BACK TO READY-MADE STRAPS
      </button>
    `);

    const fit = root.querySelector('.daluca-filter-fit');
    if (fit) fit.insertAdjacentElement('afterend', notice);
    else root.insertBefore(notice, root.firstChild);

    return notice;
  }

  function setHeading() {
    const root = engine();
    if (!root) return;

    const heading = root.querySelector('.daluca-filter-fit__heading');
    if (!heading) return;

    const eyebrow = heading.querySelector('.daluca-filter-fit__eyebrow');
    const title = heading.querySelector('.daluca-filter-fit__title');
    const copy = heading.querySelector('.daluca-filter-fit__text');

    if (state.source === 'watch' && state.watch) {
      if (eyebrow) window.DaLucaI18n.setText(eyebrow, 'MADE TO ORDER FOR YOUR WATCH');
      if (title) window.DaLucaI18n.setText(title, 'Custom straps in your exact width');
      if (copy) {
        window.DaLucaI18n.setText(copy, `Your ${state.width}mm fit is made to order. Choose a style below to narrow the custom options.`);
      }
    } else {
      if (eyebrow) window.DaLucaI18n.setText(eyebrow, 'EXACT WIDTH — MADE TO ORDER');
      if (title) window.DaLucaI18n.setText(title, `${state.width}mm custom watch straps`);
      if (copy) {
        window.DaLucaI18n.setText(copy, `DaLuca makes ${state.width}mm straps to order. Choose a style below to narrow the custom options.`);
      }
    }
  }

  function restoreHeading() {
    if (!state.originalHeading) return;

    const root = engine();
    const heading = root && root.querySelector('.daluca-filter-fit__heading');
    if (!heading) return;

    const eyebrow = heading.querySelector('.daluca-filter-fit__eyebrow');
    const title = heading.querySelector('.daluca-filter-fit__title');
    const copy = heading.querySelector('.daluca-filter-fit__text');

    if (eyebrow) window.DaLucaI18n.setText(eyebrow, state.originalHeading.eyebrow);
    if (title) window.DaLucaI18n.setText(title, state.originalHeading.title);
    if (copy) window.DaLucaI18n.setText(copy, state.originalHeading.copy);
  }

  function hideOldCustomNotice() {
    const root = engine();
    if (!root) return;

    const old = root.querySelector('[data-daluca-custom-fit]');
    if (old) old.hidden = true;
  }

  function updateNotice(count) {
    const notice = ensureNotice();
    if (!notice) return;

    notice.hidden = false;

    const title = notice.querySelector('[data-daluca-inplace-custom-title]');
    const copy = notice.querySelector('[data-daluca-inplace-custom-copy]');

    if (title) {
      window.DaLucaI18n.setText(title, `${state.width}mm exact width — made to order`);
    }

    const countText = count
      ? `${count} made-to-order option${String(count) === '1' ? '' : 's'} shown below. `
      : '';

    if (copy) {
      if (state.source === 'watch' && state.watch) {
        window.DaLucaI18n.setText(copy, `${state.watch.brand} ${state.watch.model} requires an exact ${state.width}mm strap. ` +
          countText +
          'These custom straps can be built specifically for that fit.');
      } else {
        window.DaLucaI18n.setText(copy, `${state.width}mm is available through DaLuca Custom. ` +
          countText +
          'Choose a style above to narrow the made-to-order options.');
      }
    }
  }

  function customUrl(style) {
    const url =
      new URL(
        CUSTOM_PATH,
        window.location.origin
      );

    url.searchParams.set(
      'sort_by',
      'best-selling'
    );

    if (style) {
      url.searchParams.set(
        STYLE_PARAM,
        style
      );
    }

    /*
      Theme previews must fetch the Custom collection from the
      SAME preview theme. Without these parameters Shopify can
      return the live theme's collection markup instead, whose
      grid/count wrappers may differ from the theme being tested.
    */
    const current =
      new URL(
        window.location.href
      );

    [
      'preview_theme_id',
      '_fd',
      'pb'
    ].forEach(
      function (key) {
        const value =
          current.searchParams.get(
            key
          );

        if (value) {
          url.searchParams.set(
            key,
            value
          );
        }
      }
    );

    if (
      !url.searchParams.has(
        'preview_theme_id'
      ) &&
      window.Shopify &&
      window.Shopify.designMode &&
      window.Shopify.theme &&
      window.Shopify.theme.id
    ) {
      url.searchParams.set(
        'preview_theme_id',
        String(
          window.Shopify.theme.id
        )
      );
    }

    return url.toString();
  }

  function parseAvailableStyles(doc) {
    const values = new Set();

    doc.querySelectorAll(`input[name="${STYLE_PARAM}"]`).forEach(function (input) {
      if (!input.disabled && input.value) values.add(String(input.value));
    });

    return values;
  }

  function currentProductCountNodes() {
    const selectors = [
      '[data-daluca-product-count]',
      '[data-product-count]',
      '.daluca-filter-product-count',
      '.daluca-results-count',
      '.facets__product-count',
      '.facets__results-count',
      '.collection__product-count',
      '.collection-product-count',
      '.products-count',
      '.product-count',
      '[class*="product-count"]',
      '[class*="products-count"]',
      '#ProductCountDesktop',
      '#ProductCountMobile',
      '#ProductCount',
      '[id^="ProductCount"]',
      '[id*="ProductCount"]'
    ];

    const nodes = [];
    const seen = new Set();

    function add(node) {
      if (!node || seen.has(node)) return;
      seen.add(node);
      nodes.push(node);
    }

    selectors.forEach(function (selector) {
      document.querySelectorAll(selector).forEach(add);
    });

    /*
      Habitat can render the visible collection count with a theme-specific
      class that is different from Shopify's usual ProductCount selectors.
      In in-place Custom Mode, discover any small non-interactive element
      whose complete visible text is only a product count, e.g.
      "612 products" or "11 of 612 products". This keeps the count
      directly above the product grid synchronized even when its class name
      is not one of the standard selectors above.
    */
    document.querySelectorAll('body *').forEach(function (node) {
      if (
        node.matches('script, style, noscript, template') ||
        node.querySelector('a, button, input, select, textarea')
      ) {
        return;
      }

      const text = String(window.DaLucaI18n.sourceText(node) || '')
        .replace(/\s+/g, ' ')
        .trim();

      if (!/^[\d,]+(?:\s+of\s+[\d,]+)?\s+products?$/i.test(text)) {
        return;
      }

      /* Prefer the most specific count element instead of a wrapper. */
      const childHasSameCount = Array.from(node.children || []).some(function (child) {
        const childText = String(window.DaLucaI18n.sourceText(child) || '')
          .replace(/\s+/g, ' ')
          .trim();
        return /^[\d,]+(?:\s+of\s+[\d,]+)?\s+products?$/i.test(childText);
      });

      if (!childHasSameCount) add(node);
    });

    return nodes;
  }

  function rememberOriginalProductCounts() {
    if (state.originalCounts) return;

    state.originalCounts = currentProductCountNodes().map(function (node) {
      return {
        node: node,
        text: window.DaLucaI18n.sourceText(node),
        hidden: !!node.hidden
      };
    });
  }

  function enforceCustomProductCount() {
    if (!state.active) return;

    const clean =
      String(state.currentCount || '')
        .replace(/[^0-9,]/g, '');

    if (!clean) return;

    currentProductCountNodes().forEach(function (node) {
      const expected = clean + ' products';

      if (String(window.DaLucaI18n.sourceText(node) || '').trim() !== expected) {
        window.DaLucaI18n.setText(node, expected);
      }

      /*
        Any count discovered by currentProductCountNodes() is a
        legitimate collection-count node. Make sure an earlier
        Exact-Fit guard cannot leave the mobile count hidden.
        Responsive theme CSS still decides which duplicate count
        is visible at each breakpoint.
      */
      node.hidden = false;
      node.removeAttribute(
        'data-daluca-custom-fit-hidden'
      );

      if (
        node.style &&
        node.style.getPropertyValue(
          'display'
        ) === 'none'
      ) {
        node.style.removeProperty(
          'display'
        );
      }
    });
  }


  function setCustomProductCount(count) {
    const clean = String(count || '').replace(/[^0-9,]/g, '');
    state.currentCount = clean;

    if (!clean) return;

    enforceCustomProductCount();

    /*
      Habitat and a few collection components can repaint their
      result count immediately after the custom grid swaps in.
      Re-assert the in-place Custom count after those repaint windows
      so mobile never falls back to the ready-made collection total.
    */
    [40, 140, 320].forEach(function (delay) {
      window.setTimeout(function () {
        enforceCustomProductCount();
      }, delay);
    });
  }

  function restoreOriginalProductCounts() {
    if (!state.originalCounts) return;

    state.originalCounts.forEach(function (entry) {
      if (!entry.node || !entry.node.isConnected) return;
      window.DaLucaI18n.setText(entry.node, entry.text);
      entry.node.hidden = entry.hidden;
    });

    state.originalCounts = null;
    state.currentCount = '';
  }

  function productCountFromDocument(doc) {
    /*
      IMPORTANT: use Shopify/Habitat's authoritative count from the
      fetched Custom collection FIRST. The product grid can contain
      extra /products/ links for quick-view, hidden templates, preload
      markup, or pagination helpers, so counting links can overstate the
      number of Custom products actually returned by the filter.
    */
    const countNodes = [
      doc.getElementById('ProductCountDesktop'),
      doc.getElementById('ProductCountMobile'),
      doc.getElementById('ProductCount'),
      doc.querySelector('.product-count'),
      doc.querySelector('[id^="ProductCount"]')
    ].filter(Boolean);

    for (const node of countNodes) {
      const text = String(window.DaLucaI18n.sourceText(node) || '')
        .replace(/\s+/g, ' ')
        .trim();

      if (!text) continue;

      /*
        Shopify can render either:
          "11 products"
        or:
          "11 of 11 products"

        For an AJAX-filtered Custom collection, the first number is the
        count currently being shown and is the number we want.
      */
      const match = text.match(/([\d,]+)(?:\s+of\s+[\d,]+)?\s+products?/i);
      if (match) return match[1];
    }

    /*
      Habitat fallback: the count can live in a theme-specific
      element with no ProductCount class/id. Search non-interactive
      text nodes for a complete "11 products" style count.
    */
    const scope =
      doc.querySelector('main') ||
      doc.body;

    if (scope) {
      const genericCounts =
        Array.from(
          scope.querySelectorAll('*')
        );

      for (const node of genericCounts) {
        if (
          node.matches(
            'script, style, noscript, template'
          ) ||
          node.querySelector(
            'a, button, input, select, textarea'
          )
        ) {
          continue;
        }

        const text =
          String(
            window.DaLucaI18n.sourceText(node) || ''
          )
            .replace(/\s+/g, ' ')
            .trim();

        const match =
          text.match(
            /^([\d,]+)(?:\s+of\s+[\d,]+)?\s+products?$/i
          );

        if (match) {
          return match[1];
        }
      }
    }

    /*
      Fallback only: if a theme response omits its count markup, count
      unique product URLs inside the actual product grid.
    */
    const grid = gridElement(doc);

    if (grid) {
      const productHrefs = new Set();

      grid.querySelectorAll('a[href*="/products/"]').forEach(function (link) {
        const href = String(link.getAttribute('href') || '')
          .split('?')[0]
          .replace(/\/$/, '');

        if (/\/products\/[^/]+$/i.test(href)) {
          productHrefs.add(href);
        }
      });

      if (productHrefs.size) {
        return String(productHrefs.size);
      }
    }

    return '';
  }


  function productHrefSet(element) {
    const hrefs = new Set();

    if (!element) return hrefs;

    element.querySelectorAll('a[href*="/products/"]').forEach(function (link) {
      const href = String(link.getAttribute('href') || '')
        .split('?')[0]
        .replace(/\/$/, '');

      if (/\/products\/[^/]+$/i.test(href)) {
        hrefs.add(href);
      }
    });

    return hrefs;
  }

  function nativePaginationCandidates() {
    const selectors = [
      '.pagination-wrapper',
      '.pagination',
      'pagination-component',
      '[data-pagination]',
      '[data-load-more]',
      '[data-loadmore]',
      '[data-infinite-scroll]',
      '[data-infinite-scroll-container]',
      '.load-more',
      '.load-more-wrapper',
      '.loadmore',
      '.infinite-scroll',
      '[class*="load-more"]',
      '[class*="loadmore"]'
    ];

    const nodes = new Set();

    selectors.forEach(function (selector) {
      document.querySelectorAll(selector).forEach(function (node) {
        nodes.add(node);
      });
    });

    document.querySelectorAll('button, a').forEach(function (node) {
      const text = String(window.DaLucaI18n.sourceText(node) || '')
        .replace(/\s+/g, ' ')
        .trim()
        .toLowerCase();

      if (
        text === 'load more' ||
        text === 'show more products' ||
        text === 'view more' ||
        text === 'more products'
      ) {
        nodes.add(
          node.closest(
            '.pagination-wrapper, .pagination, pagination-component, [data-pagination], [data-load-more], [data-loadmore], [data-infinite-scroll], .load-more, .load-more-wrapper, .loadmore, .infinite-scroll'
          ) || node
        );
      }
    });

    return Array.from(nodes);
  }

  function suppressNativePagination() {
    if (!state.active) return;

    nativePaginationCandidates().forEach(function (node) {
      node.setAttribute('data-daluca-native-pagination-hidden', '');

      if ('disabled' in node) {
        try { node.disabled = true; } catch (error) {}
      }
    });
  }

  function restoreNativePagination() {
    document.querySelectorAll('[data-daluca-native-pagination-hidden]').forEach(function (node) {
      node.removeAttribute('data-daluca-native-pagination-hidden');

      if ('disabled' in node) {
        try { node.disabled = false; } catch (error) {}
      }
    });
  }

  function customGridIsPolluted(grid) {
    if (!grid || !state.allowedProductHrefs || !state.allowedProductHrefs.size) {
      return false;
    }

    const current = productHrefSet(grid);

    if (current.size > state.allowedProductHrefs.size) {
      return true;
    }

    for (const href of current) {
      if (!state.allowedProductHrefs.has(href)) {
        return true;
      }
    }

    return false;
  }

  function enforceCustomGridOwnership() {
    if (!state.active || !state.customGridHtml) return;

    suppressNativePagination();

    let grid = state.customGridNode;

    if (!grid || !grid.isConnected) {
      grid =
        document.querySelector('[data-daluca-inplace-custom-grid]') ||
        gridElement(document);
    }

    if (!grid) return;

    if (customGridIsPolluted(grid)) {
      window.DaLucaI18n.setHtml(grid, state.customGridHtml);
    }

    grid.setAttribute('data-daluca-inplace-custom-grid', '');
    state.customGridNode = grid;

    enforceCustomProductCount();
  }

  function scheduleCustomGridGuard() {
    if (!state.active) return;

    window.clearTimeout(state.resultGuardTimer);
    state.resultGuardTimer = window.setTimeout(function () {
      enforceCustomGridOwnership();
    }, 30);
  }

  function clearLegacyCustomFitHiddenState() {
    document
      .querySelectorAll(
        '[data-daluca-custom-fit-hidden]'
      )
      .forEach(
        function (element) {
          element.removeAttribute(
            'data-daluca-custom-fit-hidden'
          );
        }
      );
  }

  function replaceGridFromDocument(doc) {
    const currentGrid =
      gridElement(document);
    const sourceGrid =
      gridElement(doc);

    /*
      Prefer replacing the grid itself. Replacing a large Habitat
      container can also replace filter/count controls and allow the
      ready-made collection state to repaint over Custom Mode.
    */
    if (
      currentGrid &&
      sourceGrid
    ) {
      window.DaLucaI18n.setHtml(currentGrid, sourceGrid.innerHTML);

      state.customGridHtml = sourceGrid.innerHTML;
      state.allowedProductHrefs = productHrefSet(sourceGrid);
      state.customGridNode = currentGrid;
      currentGrid.setAttribute('data-daluca-inplace-custom-grid', '');

      suppressNativePagination();
      clearLegacyCustomFitHiddenState();
      scheduleCustomGridGuard();
      return true;
    }

    const currentContainer =
      gridContainer(document);
    const sourceContainer =
      gridContainer(doc);

    if (
      currentContainer &&
      sourceContainer
    ) {
      window.DaLucaI18n.setHtml(currentContainer, sourceContainer.innerHTML);

      const freshGrid = gridElement(document);
      const sourceGridAfter = gridElement(doc);

      if (freshGrid && sourceGridAfter) {
        state.customGridHtml = sourceGridAfter.innerHTML;
        state.allowedProductHrefs = productHrefSet(sourceGridAfter);
        state.customGridNode = freshGrid;
        freshGrid.setAttribute('data-daluca-inplace-custom-grid', '');
      }

      suppressNativePagination();
      clearLegacyCustomFitHiddenState();
      scheduleCustomGridGuard();
      return true;
    }

    return false;
  }

  function syncStyles() {
    if (!state.active) return;

    const buttons = Array.from(document.querySelectorAll('[data-daluca-style]'));
    const available = state.baseAvailableStyles;

    buttons.forEach(function (button) {
      const style = String(button.dataset.dalucaStyle || '');
      const isAvailable = !available || !available.size || available.has(style);
      const isActive = !!state.style && state.style === style;

      /*
        Preserve the same restrained collection-page shortcut policy while
        Custom Mode is active. Sport only appears when the originating
        collection is sport-oriented AND the Custom assortment supports it.
      */
      if (
        isSportStyle(style) &&
        (!collectionShouldOfferSportShortcut() || !isAvailable) &&
        !isActive
      ) {
        button.hidden = true;
        button.disabled = true;
        button.classList.add('is-disabled');
        button.classList.remove('is-active');
        button.setAttribute('aria-pressed', 'false');
        button.setAttribute('aria-hidden', 'true');
        return;
      }

      button.hidden = false;
      button.disabled = !isAvailable;
      button.classList.toggle('is-disabled', !isAvailable);
      button.classList.toggle('is-active', isActive);
      button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      button.setAttribute('aria-hidden', 'false');
    });

    syncVisibleStyleCount();
  }


  async function loadCustom(style) {
    if (!state.active) return;

    const requestId = ++state.requestId;
    const target = gridContainer(document) || gridElement(document);

    if (target) target.classList.add('daluca-inplace-custom-loading');

    try {
      const response = await fetch(customUrl(style), {
        credentials: 'same-origin',
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        }
      });

      if (!response.ok) {
        throw new Error('Custom collection HTTP ' + response.status);
      }

      const html = await response.text();
      if (!state.active || requestId !== state.requestId) return;

      const doc = new DOMParser().parseFromString(html, 'text/html');

      if (!state.baseAvailableStyles) {
        state.baseAvailableStyles = parseAvailableStyles(doc);
      }

      if (!replaceGridFromDocument(doc)) {
        throw new Error('Custom product grid not found');
      }

      const customCount = productCountFromDocument(doc);

      updateNotice(customCount);
      setCustomProductCount(customCount);
      syncStyles();

      document.dispatchEvent(
        new CustomEvent('daluca:inplace-custom-products-updated', {
          detail: {
            width: state.width,
            style: state.style || ''
          }
        })
      );

    } catch (error) {
      console.error('DaLuca in-place Custom Mode:', error);

      const notice = ensureNotice();
      const copy = notice && notice.querySelector('[data-daluca-inplace-custom-copy]');

      if (copy) {
        window.DaLucaI18n.setHtml(copy, `We couldn't load the custom options here. ` +
          `<a href="${CUSTOM_PATH}">View Custom Watch Straps →</a>`);
      }
    } finally {
      const freshTarget = gridContainer(document) || gridElement(document);
      if (freshTarget) freshTarget.classList.remove('daluca-inplace-custom-loading');
    }
  }

  function enter(options) {
    options = options || {};
    const width = Number(options.width);

    if (
      !Number.isFinite(width) ||
      width < 14 ||
      width > 28
    ) return false;

    installStyle();
    rememberOriginalPage();
    rememberOriginalProductCounts();

    state.active = true;
    state.width = width;
    state.source = options.source || 'manual';
    state.watch = options.watch || null;
    state.style = '';
    state.baseAvailableStyles = null;
    state.customGridHtml = '';
    state.allowedProductHrefs = null;
    state.customGridNode = null;

    document.documentElement.classList.add('daluca-inplace-custom-mode');

    closeDrawer();
    hideOldCustomNotice();
    clearLegacyCustomFitHiddenState();
    setHeading();
    updateNotice('');
    setCustomProductCount('');
    syncStyles();

    loadCustom('');

    return true;
  }

  function exit() {
    if (!state.active) return;

    state.active = false;
    state.requestId += 1;

    document.documentElement.classList.remove('daluca-inplace-custom-mode');
    restoreNativePagination();

    if (state.customGridNode && state.customGridNode.isConnected) {
      state.customGridNode.removeAttribute('data-daluca-inplace-custom-grid');
    }

    window.clearTimeout(state.resultGuardTimer);

    /*
      Returning to ready-made mode always restores the FILTERS control
      to its normal closed/down-chevron state on desktop and mobile.
    */
    closeDrawer();

    const currentContainer = gridContainer(document);
    if (currentContainer && state.originalGridHtml) {
      window.DaLucaI18n.setHtml(currentContainer, state.originalGridHtml);
    }

    const notice = document.querySelector('[data-daluca-inplace-custom-fit]');
    if (notice) notice.hidden = true;

    restoreHeading();
    restoreOriginalProductCounts();

    state.width = null;
    state.source = '';
    state.watch = null;
    state.style = '';
    state.baseAvailableStyles = null;
    state.customGridHtml = '';
    state.allowedProductHrefs = null;
    state.customGridNode = null;

    window.setTimeout(function () {
      document.dispatchEvent(new Event('input', { bubbles: true }));
      window.dispatchEvent(new Event('popstate'));
    }, 0);
  }

  function applyStyle(style) {
    if (!state.active) return;

    const value = String(style || '');
    const available = state.baseAvailableStyles;

    if (available && available.size && !available.has(value)) return;

    state.style = state.style === value ? '' : value;
    syncStyles();
    loadCustom(state.style);
  }

  /*
    A manually selected odd width is intentionally staged until the
    shopper explicitly applies the drawer. Desktop uses APPLY; mobile
    uses the sticky VIEW PRODUCTS action. Capture phase lets us commit
    before the normal close/apply handlers run.
  */
  document.addEventListener(
    'click',
    function (event) {
      const manualRoute =
        window.DaLucaManualCustomWidthRoute;

      if (
        !manualRoute ||
        typeof manualRoute.pending !== 'function' ||
        !manualRoute.pending() ||
        typeof manualRoute.applyPending !== 'function'
      ) {
        return;
      }

      const applyButton =
        event.target.closest(
          '[data-daluca-price-apply], ' +
          '[data-daluca-mobile-view-results], ' +
          '.daluca-filter-drawer__done'
        );

      if (!applyButton) {
        return;
      }

      event.preventDefault();
      event.stopImmediatePropagation();

      manualRoute.applyPending();
    },
    true
  );


  document.addEventListener(
    'click',
    function (event) {
      if (!state.active) return;

      const trigger = event.target.closest(
        '[data-daluca-native-pagination-hidden], ' +
        '[data-load-more], [data-loadmore], [data-infinite-scroll], ' +
        '.load-more, .load-more-wrapper, .loadmore, .pagination-wrapper, pagination-component'
      );

      if (!trigger) return;

      event.preventDefault();
      event.stopImmediatePropagation();
    },
    true
  );


  document.addEventListener('click', function (event) {
    const back = event.target.closest('[data-daluca-exit-inplace-custom]');
    if (!back) return;

    event.preventDefault();

    if (state.source === 'watch') {
      const change = document.querySelector('[data-daluca-change-watch]');
      if (change) {
        change.click();
        return;
      }
    }

    exit();
  });

  let customCountSyncTimer = null;

  const customCountObserver = new MutationObserver(function () {
    if (!state.active) return;

    scheduleCustomGridGuard();

    if (!state.currentCount) return;

    window.clearTimeout(customCountSyncTimer);
    customCountSyncTimer = window.setTimeout(function () {
      enforceCustomProductCount();
      enforceCustomGridOwnership();
    }, 35);
  });

  if (document.body) {
    customCountObserver.observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }

  window.DaLucaInPlaceCustomMode = {
    active: function () {
      return state.active;
    },
    enter: enter,
    exit: exit,
    applyStyle: applyStyle,
    syncStyles: syncStyles,
    state: state
  };

})();


/* =========================================================
   DALUCA V40 — DESKTOP DRAWER LIVE RESULT COUNT
   Desktop intentionally has no sticky footer. Show the live
   result total directly in the drawer header instead.

   Count priority:
   1) In-place Custom Mode authoritative count.
   2) DaLuca live result count.
   3) Shopify / Habitat native collection count.
   ========================================================= */
(function () {
  if (window.DaLucaDesktopDrawerHeaderCountInitialized) return;
  window.DaLucaDesktopDrawerHeaderCountInitialized = true;

  /* V43: desktop count lives only in the footer CTA. */
  return;

  let timer = null;

  function isDesktop() {
    return window.matchMedia('(min-width: 768px)').matches;
  }

  function normalizeCount(value) {
    const text = String(value == null ? '' : value)
      .replace(/\s+/g, ' ')
      .trim();

    if (!text) return '';

    const ofMatch = text.match(
      /([\d,]+)\s+of\s+([\d,]+)\s+products?/i
    );
    if (ofMatch) return ofMatch[1];

    const productMatch = text.match(
      /([\d,]+)\s+products?/i
    );
    if (productMatch) return productMatch[1];

    const direct = text.match(/^\s*([\d,]+)\s*$/);
    return direct ? direct[1] : '';
  }

  function customModeCount() {
    const mode = window.DaLucaInPlaceCustomMode;

    if (
      !mode ||
      typeof mode.active !== 'function' ||
      !mode.active() ||
      !mode.state
    ) {
      return '';
    }

    return normalizeCount(mode.state.currentCount);
  }

  function dalucaLiveCount() {
    const selectors = [
      '[data-daluca-product-count]',
      '.daluca-filter-product-count',
      '.daluca-results-count'
    ];

    for (let i = 0; i < selectors.length; i += 1) {
      const nodes = Array.from(
        document.querySelectorAll(selectors[i])
      );

      for (let j = 0; j < nodes.length; j += 1) {
        const node = nodes[j];
        if (!node || node.hidden) continue;
        if (node.matches('[data-daluca-desktop-drawer-result-count]')) continue;

        const count = normalizeCount(window.DaLucaI18n.sourceText(node));
        if (count) return count;
      }
    }

    return '';
  }

  function nativeCount() {
    const nodes = [
      document.getElementById('ProductCountDesktop'),
      document.getElementById('ProductCount'),
      document.getElementById('ProductCountMobile'),
      document.querySelector('.product-count'),
      document.querySelector('[id^="ProductCount"]')
    ].filter(Boolean);

    for (let i = 0; i < nodes.length; i += 1) {
      const count = normalizeCount(window.DaLucaI18n.sourceText(nodes[i]));
      if (count) return count;
    }

    return '';
  }

  function currentCount() {
    return (
      customModeCount() ||
      dalucaLiveCount() ||
      nativeCount()
    );
  }

  function ensureTarget(drawer) {
    if (!drawer) return null;

    const headerCopy = drawer.querySelector(
      '.daluca-filter-drawer__header > div'
    );
    if (!headerCopy) return null;

    let target = headerCopy.querySelector(
      '[data-daluca-desktop-drawer-result-count]'
    );

    if (!target) {
      target = document.createElement('div');
      target.className = 'daluca-desktop-drawer-result-count';
      target.setAttribute(
        'data-daluca-desktop-drawer-result-count',
        ''
      );
      target.setAttribute('aria-live', 'polite');
      headerCopy.appendChild(target);
    }

    return target;
  }

  function sync() {
    const drawer = document.querySelector(
      '[data-daluca-filter-drawer]'
    );

    if (!drawer) return;

    const target = ensureTarget(drawer);
    if (!target) return;

    if (!isDesktop()) {
      target.hidden = true;
      return;
    }

    const count = currentCount();
    target.hidden = !count;
    window.DaLucaI18n.setText(target, count
      ? count + (count === '1' ? ' PRODUCT' : ' PRODUCTS')
      : '');
  }

  function schedule(delay) {
    window.clearTimeout(timer);
    timer = window.setTimeout(sync, delay == null ? 70 : delay);
  }

  document.addEventListener('input', function () {
    schedule(80);
    window.setTimeout(sync, 320);
    window.setTimeout(sync, 700);
  }, true);

  document.addEventListener('change', function () {
    schedule(80);
    window.setTimeout(sync, 320);
    window.setTimeout(sync, 700);
  }, true);

  document.addEventListener('click', function () {
    schedule(40);
    window.setTimeout(sync, 240);
    window.setTimeout(sync, 650);
  }, true);

  document.addEventListener(
    'daluca:manual-custom-width-pending',
    function () {
      schedule(40);
      window.setTimeout(sync, 500);
    }
  );

  window.addEventListener('popstate', function () {
    schedule(50);
  });

  window.addEventListener('resize', function () {
    schedule(50);
  });

  const observer = new MutationObserver(function () {
    schedule(60);
  });

  if (document.body) {
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['hidden', 'class', 'aria-hidden']
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sync);
  } else {
    sync();
  }
})();

/* =========================================================
   DALUCA V42 — DESKTOP DRAWER FINAL COUNT / ACTIONS
   - Footer count reads the same authoritative DaLuca counter visible
     outside the drawer; odd-width Custom Mode remains authoritative.
   - One quiet Clear all utility only.
   - The footer VIEW X PRODUCTS button commits desktop price fields,
     replacing the old separate Apply Price / Clear pair on desktop.
   - Clear all is deterministic and preserves only an exact watch width.
   ========================================================= */
(function () {
  if (window.DaLucaDesktopDrawerV42Initialized) return;
  window.DaLucaDesktopDrawerV42Initialized = true;

  const WIDTH_PARAM = 'filter.p.m.daluca_filter.widths';
  const SAVED_WATCH_KEY = 'daluca_selected_watch_v1';
  let syncTimer = null;

  function isDesktop() {
    return window.matchMedia('(min-width: 768px)').matches;
  }

  function selectedSavedWatchWidth() {
    try {
      const saved = JSON.parse(
        localStorage.getItem(SAVED_WATCH_KEY) || 'null'
      );

      const current = saved && window.DaLucaWatchData.safeSaved(saved);
      if (current && !window.DaLucaWatchData.requiresReview(current) &&
          window.DaLucaWatchData.canOrderWidth(current.lug_width_mm)) {
        return String(Number(current.lug_width_mm));
      }
    } catch (error) {}

    return '';
  }

  function ensureDesktopClearButton() {
    const drawer = document.querySelector('[data-daluca-filter-drawer]');
    if (!drawer) return null;

    const footer = drawer.querySelector('.daluca-filter-drawer__footer');
    if (!footer) return null;

    let button = footer.querySelector('[data-daluca-desktop-clear-all]');

    if (!button) {
      button = document.createElement('button');
      button.type = 'button';
      button.className = 'daluca-desktop-drawer-clear-all';
      button.setAttribute('data-daluca-desktop-clear-all', '');
      window.DaLucaI18n.setText(button, 'Clear all');
      footer.insertBefore(button, footer.firstChild);
    }

    button.hidden = !isDesktop();
    return button;
  }

  function buildClearUrl() {
    const url = new URL(window.location.href);
    const watchWidth = selectedSavedWatchWidth();

    Array.from(url.searchParams.keys()).forEach(function (key) {
      if (key.startsWith('filter.') || key === 'page') {
        url.searchParams.delete(key);
      }
    });

    if (watchWidth) {
      url.searchParams.set(WIDTH_PARAM, watchWidth + 'mm');
    }

    return (
      url.pathname +
      (url.searchParams.toString()
        ? '?' + url.searchParams.toString()
        : '') +
      url.hash
    );
  }

  function clearAllDeterministically() {
    const form = document.getElementById('FacetFiltersForm');
    const drawer = document.querySelector('[data-daluca-filter-drawer]');
    const overlay = document.querySelector('[data-daluca-filter-overlay]');
    const openButton = document.querySelector('[data-daluca-open-filters]');
    const drawerBody = drawer
      ? drawer.querySelector('.daluca-filter-drawer__body')
      : null;
    const savedScrollTop = drawerBody ? drawerBody.scrollTop : 0;
    const watchWidth = selectedSavedWatchWidth();

    if (!form) return;

    let triggerInput = null;
    let preservedWidthInput = null;

    form.querySelectorAll('input[name^="filter."]').forEach(function (input) {
      const type = String(input.type || '').toLowerCase();
      const name = String(input.name || '');
      const value = String(input.value || '');

      if (name === WIDTH_PARAM && watchWidth) {
        const matchesWatch =
          value.replace(/\s+/g, '').toLowerCase() ===
          (watchWidth + 'mm').toLowerCase();

        if (type === 'checkbox' || type === 'radio') {
          input.checked = matchesWatch;
          if (matchesWatch) preservedWidthInput = input;
        }
        return;
      }

      if (type === 'checkbox' || type === 'radio') {
        if (input.checked) {
          input.checked = false;
          triggerInput = triggerInput || input;
        }
        return;
      }

      if (
        type === 'number' ||
        type === 'text' ||
        type === 'search' ||
        type === 'hidden'
      ) {
        if (value !== '') {
          input.value = '';
          triggerInput = triggerInput || input;
        }
      }
    });

    document.querySelectorAll(
      '[data-daluca-price-min], [data-daluca-price-max]'
    ).forEach(function (input) {
      input.value = '';
    });

    const mode = window.DaLucaInPlaceCustomMode;
    if (mode && typeof mode.active === 'function' && mode.active()) {
      if (typeof mode.exit === 'function') {
        mode.exit();
      }
    }

    const eventTarget = triggerInput || preservedWidthInput;
    if (eventTarget) {
      eventTarget.dispatchEvent(new Event('input', { bubbles: true }));
    }

    function keepDrawerOpen() {
      if (drawer) {
        drawer.hidden = false;
        drawer.setAttribute('aria-hidden', 'false');
      }

      if (overlay) {
        overlay.hidden = false;
      }

      if (openButton) {
        openButton.setAttribute('aria-expanded', 'true');
      }

      document.documentElement.classList.add('daluca-filters-open');

      if (drawerBody) {
        drawerBody.scrollTop = savedScrollTop;
      }
    }

    keepDrawerOpen();
    window.setTimeout(keepDrawerOpen, 80);
    window.setTimeout(keepDrawerOpen, 260);
    window.setTimeout(keepDrawerOpen, 650);
  }

  function cleanPrice(value) {
    const cleaned = String(value == null ? '' : value)
      .replace(/[$,]/g, '')
      .trim();

    if (!cleaned) return '';

    const number = Number(cleaned);
    return Number.isFinite(number) && number >= 0
      ? String(number)
      : '';
  }

  function commitDesktopPrice() {
    if (!isDesktop()) return true;

    const customMin = document.querySelector('[data-daluca-price-min]');
    const customMax = document.querySelector('[data-daluca-price-max]');
    const nativeMin = document.querySelector('input[name="filter.v.price.gte"]');
    const nativeMax = document.querySelector('input[name="filter.v.price.lte"]');

    if (!customMin || !customMax || !nativeMin || !nativeMax) {
      return true;
    }

    const min = cleanPrice(customMin.value);
    const max = cleanPrice(customMax.value);

    if (min !== '' && max !== '' && Number(min) > Number(max)) {
      customMax.focus();
      return false;
    }

    const changed =
      String(nativeMin.value || '') !== min ||
      String(nativeMax.value || '') !== max;

    nativeMin.value = min;
    nativeMax.value = max;

    if (changed) {
      nativeMax.dispatchEvent(
        new Event('input', { bubbles: true })
      );
    }

    return true;
  }

  function enforceCustomVisibleCount() {
    const mode = window.DaLucaInPlaceCustomMode;

    if (
      !mode ||
      typeof mode.active !== 'function' ||
      !mode.active() ||
      !mode.state
    ) {
      return;
    }

    const count = String(mode.state.currentCount || '')
      .replace(/[^0-9,]/g, '')
      .trim();

    if (!count) return;

    document.querySelectorAll(
      '[data-daluca-product-count], .daluca-filter-product-count'
    ).forEach(function (node) {
      node.hidden = false;
      window.DaLucaI18n.setText(node, count + (count === '1' ? ' product' : ' products'));
    });
  }

  function sync() {
    ensureDesktopClearButton();
    enforceCustomVisibleCount();
  }

  function schedule(delay) {
    window.clearTimeout(syncTimer);
    syncTimer = window.setTimeout(
      sync,
      delay == null ? 70 : delay
    );
  }

  document.addEventListener('click', function (event) {
    const desktopClear = event.target.closest(
      '[data-daluca-desktop-clear-all]'
    );

    if (desktopClear && isDesktop()) {
      event.preventDefault();
      event.stopImmediatePropagation();
      clearAllDeterministically();
      return;
    }

    const topClear = event.target.closest('[data-daluca-clear-filters]');

    if (topClear && isDesktop()) {
      event.preventDefault();
      event.stopImmediatePropagation();
      clearAllDeterministically();
      return;
    }

    const done = event.target.closest(
      '.daluca-filter-drawer__done, [data-daluca-mobile-view-results]'
    );

    if (done && isDesktop()) {
      if (!commitDesktopPrice()) {
        event.preventDefault();
        event.stopImmediatePropagation();
        return;
      }
    }

    schedule(50);
  }, true);

  document.addEventListener('input', function () {
    schedule(80);
  }, true);

  document.addEventListener(
    'daluca:inplace-custom-products-updated',
    function () {
      schedule(30);
      window.setTimeout(sync, 220);
    }
  );

  window.addEventListener('resize', function () {
    schedule(50);
  });

  const observer = new MutationObserver(function () {
    schedule(80);
  });

  if (document.body) {
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sync);
  } else {
    sync();
  }
})();


/* =========================================================
   DALUCA V56 — STABLE APPLIED CUSTOM WIDTH PILL
   Pre-cleanup architecture recovery:
   - 14–28mm remains available in the drawer.
   - Pending Custom widths stay inside the drawer until Apply.
   - After Apply, one compact width pill appears in DaLuca's normal
     active-filter host; no synthetic Habitat/floating pill is created.
   - Removing the pill exits manual in-place Custom Mode.
   ========================================================= */
(function () {
  if (window.DaLucaStableCustomWidthPillInitialized) return;
  window.DaLucaStableCustomWidthPillInitialized = true;

  const HOST_SELECTOR = '[data-daluca-active-filters]';
  const PILL_ATTR = 'data-daluca-custom-width-pill';
  const NATIVE_WIDTH_ATTR = 'data-daluca-native-width-pill';

  function manualCustomWidth() {
    const mode = window.DaLucaInPlaceCustomMode;

    if (
      !mode ||
      typeof mode.active !== 'function' ||
      !mode.active() ||
      !mode.state ||
      mode.state.source !== 'manual'
    ) {
      return null;
    }

    const width = Number(mode.state.width);
    return Number.isFinite(width) ? width : null;
  }

  function host() {
    return document.querySelector(HOST_SELECTOR);
  }

  function clearOwnedPill(container) {
    if (!container) return;

    container.querySelectorAll('[' + PILL_ATTR + ']').forEach(function (node) {
      node.remove();
    });

    container.removeAttribute('data-daluca-custom-width-active');

    if (!container.children.length) {
      container.hidden = true;
    }
  }

  function syncNativeWidthPills() {
    const customActive =
      document.documentElement.classList.contains('daluca-inplace-custom-mode');

    document.querySelectorAll(
      'facet-remove.active-facets .active-facets__button, ' +
      'facet-remove.active-facets .active-facets__button-remove'
    ).forEach(function (node) {
      const text = String(window.DaLucaI18n.sourceText(node) || '')
        .replace(/\s+/g, ' ')
        .trim();

      const isWidth = /\b(?:1[4-9]|2[0-8])\s*mm\b/i.test(text);

      if (customActive && isWidth) {
        node.setAttribute(NATIVE_WIDTH_ATTR, '');
        return;
      }

      if (node.hasAttribute(NATIVE_WIDTH_ATTR)) {
        node.removeAttribute(NATIVE_WIDTH_ATTR);
      }
    });
  }

  function render() {
    const container = host();
    if (!container) return;

    syncNativeWidthPills();
    clearOwnedPill(container);

    const width = manualCustomWidth();
    if (!width) return;

    const pill = document.createElement('button');
    pill.type = 'button';
    pill.className = 'daluca-custom-width-pill';
    pill.setAttribute(PILL_ATTR, '');
    pill.setAttribute('aria-label', window.DaLucaI18n.displayText('Remove ' + width + 'mm lug width'));
    window.DaLucaI18n.setHtml(pill, '<span>' + width + 'mm</span><span aria-hidden="true">×</span>');

    container.appendChild(pill);
    container.hidden = false;
    container.setAttribute('data-daluca-custom-width-active', '');
  }

  function schedule(delay) {
    window.setTimeout(render, delay == null ? 0 : delay);
  }

  document.addEventListener('daluca:inplace-custom-mode-changed', function () {
    render();
    schedule(80);
  });

  document.addEventListener('daluca:inplace-custom-products-updated', function () {
    render();
    schedule(80);
  });

  document.addEventListener('click', function (event) {
    const pill = event.target.closest('[' + PILL_ATTR + ']');
    if (!pill) return;

    event.preventDefault();
    event.stopPropagation();

    const mode = window.DaLucaInPlaceCustomMode;
    if (mode && typeof mode.exit === 'function') {
      mode.exit();
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', render);
  } else {
    render();
  }
})();
